/// <reference path="./custom.d.ts" />
// tslint:disable
// @ts-nocheck
/**
 * Cats example
 * The cats API description
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This file is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the file manually.
 */

import * as url from "url";
import * as isomorphicFetch from "isomorphic-fetch";
import { Configuration } from "./configuration";

const BASE_PATH = "/".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface FetchAPI
 */
export interface FetchAPI {
    (url: string, init?: any): Promise<Response>;
}

/**
 *
 * @export
 * @interface FetchArgs
 */
export interface FetchArgs {
    url: string;
    options: any;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected fetch: FetchAPI = isomorphicFetch) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
}

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    name = "RequiredError"
    constructor(public field: string, msg?: string) {
        super(msg);
    }
}

/**
 * 
 * @export
 * @interface AddJobPostingEmailDto
 */
export interface AddJobPostingEmailDto {
}
/**
 * 
 * @export
 * @interface AdminCompanyGalleryRemoveDto
 */
export interface AdminCompanyGalleryRemoveDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyGalleryRemoveDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface AdminCompanyGalleryUpdateDto
 */
export interface AdminCompanyGalleryUpdateDto {
    /**
     * 
     * @type {Blob}
     * @memberof AdminCompanyGalleryUpdateDto
     */
    file?: Blob;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyGalleryUpdateDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCompanyGalleryUpdateDto
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface AdminCreateNoteDto
 */
export interface AdminCreateNoteDto {
    /**
     * 
     * @type {string}
     * @memberof AdminCreateNoteDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateNoteDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminCreateNoteDto
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminCreateNoteDto
     */
    createdAt?: Date;
}
/**
 * 
 * @export
 * @interface AdminNote
 */
export interface AdminNote {
    /**
     * 
     * @type {string}
     * @memberof AdminNote
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNote
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AdminNote
     */
    content: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminNote
     */
    createdAt: Date;
}
/**
 * 
 * @export
 * @interface AdminNoteDto
 */
export interface AdminNoteDto {
    /**
     * 
     * @type {string}
     * @memberof AdminNoteDto
     */
    id: string;
    /**
     * 
     * @type {Date}
     * @memberof AdminNoteDto
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof AdminNoteDto
     */
    content: string;
}
/**
 * 
 * @export
 * @interface AnalyticsQueryDto
 */
export interface AnalyticsQueryDto {
    /**
     * 
     * @type {string}
     * @memberof AnalyticsQueryDto
     */
    query: string;
}
/**
 * 
 * @export
 * @interface AppliedUserInfoCompetencesManagerDto
 */
export interface AppliedUserInfoCompetencesManagerDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    drivingLicense: Array<AppliedUserInfoCompetencesManagerDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    preferredCountries: Array<AppliedUserInfoCompetencesManagerDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    country: AppliedUserInfoCompetencesManagerDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    positionName: AppliedUserInfoCompetencesManagerDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    experienceYears: AppliedUserInfoCompetencesManagerDto.ExperienceYearsEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    nativeLanguage: AppliedUserInfoCompetencesManagerDto.NativeLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    availableSince: AppliedUserInfoCompetencesManagerDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    salaryRange: AppliedUserInfoCompetencesManagerDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    currencySalary: AppliedUserInfoCompetencesManagerDto.CurrencySalaryEnum;
    /**
     * 
     * @type {Array<AppliedUserInfoCompetencesManagerExperienceDto>}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    experience: Array<AppliedUserInfoCompetencesManagerExperienceDto>;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    education: Array<EducationDto>;
    /**
     * 
     * @type {AppliedUserInfoCompetencesManagerDtoSkills}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    skills: AppliedUserInfoCompetencesManagerDtoSkills;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    languages: Array<LanguageProficiency>;
    /**
     * 
     * @type {AppliedUserInfoCompetencesManagerDtoCertificates}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    certificates: AppliedUserInfoCompetencesManagerDtoCertificates;
    /**
     * 
     * @type {Array<CertificateFiles>}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    certificateFiles: Array<CertificateFiles>;
    /**
     * 
     * @type {boolean}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    isLookingForJob: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AppliedUserInfoCompetencesManagerDto
     */
    hasOwnCompany: boolean;
}

/**
 * @export
 * @namespace AppliedUserInfoCompetencesManagerDto
 */
export namespace AppliedUserInfoCompetencesManagerDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
}
/**
 * 
 * @export
 * @interface AppliedUserInfoCompetencesManagerDtoCertificates
 */
export interface AppliedUserInfoCompetencesManagerDtoCertificates {
    /**
     * 
     * @type {Array<string>}
     * @memberof AppliedUserInfoCompetencesManagerDtoCertificates
     */
    predefined?: Array<AppliedUserInfoCompetencesManagerDtoCertificates.PredefinedEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppliedUserInfoCompetencesManagerDtoCertificates
     */
    other?: Array<string>;
}

/**
 * @export
 * @namespace AppliedUserInfoCompetencesManagerDtoCertificates
 */
export namespace AppliedUserInfoCompetencesManagerDtoCertificates {
    /**
     * @export
     * @enum {string}
     */
    export enum PredefinedEnum {
        SEP1KV = <any> 'SEP_1KV',
        SEPABOVE1KV = <any> 'SEP_ABOVE_1KV',
        EDQUALIFICATIONS = <any> 'E_D_QUALIFICATIONS',
        UDT = <any> 'UDT',
        ROLLEROPERATOR = <any> 'ROLLER_OPERATOR',
        EXCAVATOROPERATOR = <any> 'EXCAVATOR_OPERATOR',
        GRADEROPERATOR = <any> 'GRADER_OPERATOR',
        BACKHOELOADEROPERATOR = <any> 'BACKHOE_LOADER_OPERATOR',
        BULLDOZEROPERATOR = <any> 'BULLDOZER_OPERATOR',
        REINFORCEMENTMACHINERYOPERATOR = <any> 'REINFORCEMENT_MACHINERY_OPERATOR',
        PAVEROPERATOR = <any> 'PAVER_OPERATOR',
        MAG135 = <any> 'MAG_135',
        MIG131 = <any> 'MIG_131',
        MAG136 = <any> 'MAG_136',
        TIG141 = <any> 'TIG_141',
        CERT111 = <any> 'CERT_111',
        CERT311 = <any> 'CERT_311',
        CERT114 = <any> 'CERT_114',
        MAG138 = <any> 'MAG_138',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface AppliedUserInfoCompetencesManagerDtoSkills
 */
export interface AppliedUserInfoCompetencesManagerDtoSkills {
    /**
     * 
     * @type {Array<AppliedUserInfoCompetencesManagerSkillsDto>}
     * @memberof AppliedUserInfoCompetencesManagerDtoSkills
     */
    predefined?: Array<AppliedUserInfoCompetencesManagerSkillsDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppliedUserInfoCompetencesManagerDtoSkills
     */
    other?: Array<string>;
}
/**
 * 
 * @export
 * @interface AppliedUserInfoCompetencesManagerExperienceDto
 */
export interface AppliedUserInfoCompetencesManagerExperienceDto {
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    positionName?: AppliedUserInfoCompetencesManagerExperienceDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    positionOther?: string;
    /**
     * 
     * @type {Date}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    isCurrent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    country: AppliedUserInfoCompetencesManagerExperienceDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerExperienceDto
     */
    description?: string;
}

/**
 * @export
 * @namespace AppliedUserInfoCompetencesManagerExperienceDto
 */
export namespace AppliedUserInfoCompetencesManagerExperienceDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface AppliedUserInfoCompetencesManagerSkillsDto
 */
export interface AppliedUserInfoCompetencesManagerSkillsDto {
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoCompetencesManagerSkillsDto
     */
    positionName: AppliedUserInfoCompetencesManagerSkillsDto.PositionNameEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof AppliedUserInfoCompetencesManagerSkillsDto
     */
    positionSkills: Array<string>;
}

/**
 * @export
 * @namespace AppliedUserInfoCompetencesManagerSkillsDto
 */
export namespace AppliedUserInfoCompetencesManagerSkillsDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface AppliedUserInfoManagerDto
 */
export interface AppliedUserInfoManagerDto {
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoManagerDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoManagerDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoManagerDto
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof AppliedUserInfoManagerDto
     */
    userNumber: number;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoManagerDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoManagerDto
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof AppliedUserInfoManagerDto
     */
    email: string;
    /**
     * 
     * @type {AppliedUserInfoCompetencesManagerDto}
     * @memberof AppliedUserInfoManagerDto
     */
    userCompetences: AppliedUserInfoCompetencesManagerDto;
    /**
     * 
     * @type {boolean}
     * @memberof AppliedUserInfoManagerDto
     */
    hasCv?: boolean;
}
/**
 * 
 * @export
 * @interface AppliesReadManyAdminResponseDto
 */
export interface AppliesReadManyAdminResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof AppliesReadManyAdminResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof AppliesReadManyAdminResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof AppliesReadManyAdminResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface AppliesReadManyManagerResponseDto
 */
export interface AppliesReadManyManagerResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof AppliesReadManyManagerResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof AppliesReadManyManagerResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof AppliesReadManyManagerResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface AppliesReadManyUserResponseDto
 */
export interface AppliesReadManyUserResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof AppliesReadManyUserResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof AppliesReadManyUserResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof AppliesReadManyUserResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface Apply
 */
export interface Apply {
    /**
     * 
     * @type {string}
     * @memberof Apply
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Apply
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof Apply
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof Apply
     */
    name?: string;
    /**
     * 
     * @type {Job}
     * @memberof Apply
     */
    job: Job;
    /**
     * 
     * @type {any}
     * @memberof Apply
     */
    cvFile?: any;
    /**
     * 
     * @type {string}
     * @memberof Apply
     */
    status: Apply.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Apply
     */
    description?: string;
    /**
     * 
     * @type {User}
     * @memberof Apply
     */
    user: User;
    /**
     * 
     * @type {Date}
     * @memberof Apply
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Apply
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Apply
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace Apply
 */
export namespace Apply {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface ApplyForJobPublicDto
 */
export interface ApplyForJobPublicDto {
    /**
     * 
     * @type {Blob}
     * @memberof ApplyForJobPublicDto
     */
    file?: Blob;
    /**
     * 
     * @type {string}
     * @memberof ApplyForJobPublicDto
     */
    message: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyForJobPublicDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyForJobPublicDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyForJobPublicDto
     */
    jobSlug: string;
    /**
     * 
     * @type {string}
     * @memberof ApplyForJobPublicDto
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof ApplyForJobPublicDto
     */
    commercialConsent: boolean;
}
/**
 * 
 * @export
 * @interface ApplyForJobUserDto
 */
export interface ApplyForJobUserDto {
    /**
     * 
     * @type {string}
     * @memberof ApplyForJobUserDto
     */
    slug: string;
}
/**
 * 
 * @export
 * @interface BadRequestException
 */
export interface BadRequestException {
    /**
     * A unique code identifying the error.
     * @type {number}
     * @memberof BadRequestException
     */
    code: BadRequestException.CodeEnum;
    /**
     * Message for the exception
     * @type {string}
     * @memberof BadRequestException
     */
    message: string;
    /**
     * A description of the error message.
     * @type {string}
     * @memberof BadRequestException
     */
    description: string;
    /**
     * Timestamp of the exception
     * @type {Date}
     * @memberof BadRequestException
     */
    timestamp: Date;
    /**
     * Trace ID of the request
     * @type {string}
     * @memberof BadRequestException
     */
    traceId: string;
}

/**
 * @export
 * @namespace BadRequestException
 */
export namespace BadRequestException {
    /**
     * @export
     * @enum {string}
     */
    export enum CodeEnum {
        NUMBER_10001 = <any> 10001,
        NUMBER_10002 = <any> 10002,
        NUMBER_10003 = <any> 10003,
        NUMBER_10004 = <any> 10004,
        NUMBER_10005 = <any> 10005,
        NUMBER_10006 = <any> 10006,
        NUMBER_10007 = <any> 10007,
        NUMBER_10008 = <any> 10008,
        NUMBER_10009 = <any> 10009,
        NUMBER_10010 = <any> 10010,
        NUMBER_10011 = <any> 10011,
        NUMBER_10012 = <any> 10012,
        NUMBER_10013 = <any> 10013,
        NUMBER_10014 = <any> 10014,
        NUMBER_10015 = <any> 10015,
        NUMBER_10016 = <any> 10016,
        NUMBER_10017 = <any> 10017,
        NUMBER_10018 = <any> 10018,
        NUMBER_10019 = <any> 10019,
        NUMBER_10020 = <any> 10020,
        NUMBER_10021 = <any> 10021,
        NUMBER_10022 = <any> 10022,
        NUMBER_10023 = <any> 10023
    }
}
/**
 * 
 * @export
 * @interface BasePaginatedResponse
 */
export interface BasePaginatedResponse {
    /**
     * 
     * @type {Array<Array>}
     * @memberof BasePaginatedResponse
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof BasePaginatedResponse
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof BasePaginatedResponse
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface BasePaginatedResponseLinks
 */
export interface BasePaginatedResponseLinks {
    /**
     * 
     * @type {string}
     * @memberof BasePaginatedResponseLinks
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePaginatedResponseLinks
     */
    previous?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePaginatedResponseLinks
     */
    current?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePaginatedResponseLinks
     */
    next?: string;
    /**
     * 
     * @type {string}
     * @memberof BasePaginatedResponseLinks
     */
    last?: string;
}
/**
 * 
 * @export
 * @interface BasePaginatedResponseMeta
 */
export interface BasePaginatedResponseMeta {
    /**
     * 
     * @type {number}
     * @memberof BasePaginatedResponseMeta
     */
    itemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof BasePaginatedResponseMeta
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof BasePaginatedResponseMeta
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof BasePaginatedResponseMeta
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface BestMatchDto
 */
export interface BestMatchDto {
    /**
     * 
     * @type {string}
     * @memberof BestMatchDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BestMatchDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof BestMatchDto
     */
    positionName: BestMatchDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof BestMatchDto
     */
    country: BestMatchDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof BestMatchDto
     */
    experienceYears: BestMatchDto.ExperienceYearsEnum;
    /**
     * 
     * @type {boolean}
     * @memberof BestMatchDto
     */
    isLookingForJob: boolean;
    /**
     * 
     * @type {BestMatchUserDto}
     * @memberof BestMatchDto
     */
    user: BestMatchUserDto;
}

/**
 * @export
 * @namespace BestMatchDto
 */
export namespace BestMatchDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
}
/**
 * 
 * @export
 * @interface BestMatchUserDto
 */
export interface BestMatchUserDto {
    /**
     * 
     * @type {string}
     * @memberof BestMatchUserDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BestMatchUserDto
     */
    avatarUrl: string;
    /**
     * 
     * @type {number}
     * @memberof BestMatchUserDto
     */
    userNumber: number;
}
/**
 * 
 * @export
 * @interface CertificateFiles
 */
export interface CertificateFiles {
    /**
     * 
     * @type {string}
     * @memberof CertificateFiles
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateFiles
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateFiles
     */
    fileKey: string;
    /**
     * 
     * @type {any}
     * @memberof CertificateFiles
     */
    certificateType: any;
    /**
     * 
     * @type {string}
     * @memberof CertificateFiles
     */
    customName?: string;
}
/**
 * 
 * @export
 * @interface CertificateFilesDto
 */
export interface CertificateFilesDto {
    /**
     * 
     * @type {string}
     * @memberof CertificateFilesDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateFilesDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CertificateFilesDto
     */
    fileKey: string;
}
/**
 * 
 * @export
 * @interface CertificatesDto
 */
export interface CertificatesDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CertificatesDto
     */
    predefined?: Array<CertificatesDto.PredefinedEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CertificatesDto
     */
    other?: Array<string>;
}

/**
 * @export
 * @namespace CertificatesDto
 */
export namespace CertificatesDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PredefinedEnum {
        SEP1KV = <any> 'SEP_1KV',
        SEPABOVE1KV = <any> 'SEP_ABOVE_1KV',
        EDQUALIFICATIONS = <any> 'E_D_QUALIFICATIONS',
        UDT = <any> 'UDT',
        ROLLEROPERATOR = <any> 'ROLLER_OPERATOR',
        EXCAVATOROPERATOR = <any> 'EXCAVATOR_OPERATOR',
        GRADEROPERATOR = <any> 'GRADER_OPERATOR',
        BACKHOELOADEROPERATOR = <any> 'BACKHOE_LOADER_OPERATOR',
        BULLDOZEROPERATOR = <any> 'BULLDOZER_OPERATOR',
        REINFORCEMENTMACHINERYOPERATOR = <any> 'REINFORCEMENT_MACHINERY_OPERATOR',
        PAVEROPERATOR = <any> 'PAVER_OPERATOR',
        MAG135 = <any> 'MAG_135',
        MIG131 = <any> 'MIG_131',
        MAG136 = <any> 'MAG_136',
        TIG141 = <any> 'TIG_141',
        CERT111 = <any> 'CERT_111',
        CERT311 = <any> 'CERT_311',
        CERT114 = <any> 'CERT_114',
        MAG138 = <any> 'MAG_138',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface ChangePasswordDto
 */
export interface ChangePasswordDto {
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDto
     */
    currentPassword: string;
    /**
     * 
     * @type {string}
     * @memberof ChangePasswordDto
     */
    newPassword: string;
}
/**
 * 
 * @export
 * @interface Company
 */
export interface Company {
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    country: Company.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    logoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    tin: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    bannerUrl: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    website: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Company
     */
    industry: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Company
     */
    jobsCount: number;
    /**
     * 
     * @type {string}
     * @memberof Company
     */
    employeesNumber: string;
    /**
     * 
     * @type {User}
     * @memberof Company
     */
    manager: User;
    /**
     * 
     * @type {Array<Job>}
     * @memberof Company
     */
    jobs: Array<Job>;
    /**
     * 
     * @type {CompanyPublicReadManyDtoSocialMedia}
     * @memberof Company
     */
    socialMedia: CompanyPublicReadManyDtoSocialMedia;
    /**
     * 
     * @type {Array<CompanyGallery>}
     * @memberof Company
     */
    gallery: Array<CompanyGallery>;
    /**
     * 
     * @type {Array<CompanyFaq>}
     * @memberof Company
     */
    faqs: Array<CompanyFaq>;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    isCompanyVisible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Company
     */
    companyVerified: boolean;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof Company
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Company
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace Company
 */
export namespace Company {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface CompanyAdminCreateDto
 */
export interface CompanyAdminCreateDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    country: CompanyAdminCreateDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    employeesNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    tin?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    website?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminCreateDto
     */
    industry?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateDto
     */
    bannerUrl?: string;
    /**
     * 
     * @type {CompanyAdminCreateSocialMediaDto}
     * @memberof CompanyAdminCreateDto
     */
    socialMedia?: CompanyAdminCreateSocialMediaDto;
    /**
     * 
     * @type {Array<CompanyAdminCreateFaqDto>}
     * @memberof CompanyAdminCreateDto
     */
    faqs?: Array<CompanyAdminCreateFaqDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminCreateDto
     */
    isCompanyVisible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminCreateDto
     */
    companyVerified: boolean;
    /**
     * 
     * @type {Array<AdminCreateNoteDto>}
     * @memberof CompanyAdminCreateDto
     */
    adminNotes?: Array<AdminCreateNoteDto>;
}

/**
 * @export
 * @namespace CompanyAdminCreateDto
 */
export namespace CompanyAdminCreateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface CompanyAdminCreateFaqDto
 */
export interface CompanyAdminCreateFaqDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateFaqDto
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateFaqDto
     */
    answer: string;
}
/**
 * 
 * @export
 * @interface CompanyAdminCreateSocialMediaDto
 */
export interface CompanyAdminCreateSocialMediaDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateSocialMediaDto
     */
    facebook?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateSocialMediaDto
     */
    instagram?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateSocialMediaDto
     */
    linkedin?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminCreateSocialMediaDto
     */
    twitter?: string;
}
/**
 * 
 * @export
 * @interface CompanyAdminFaqDto
 */
export interface CompanyAdminFaqDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminFaqDto
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminFaqDto
     */
    answer: string;
}
/**
 * 
 * @export
 * @interface CompanyAdminGalleryDto
 */
export interface CompanyAdminGalleryDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminGalleryDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminGalleryDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminGalleryDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface CompanyAdminJobReadOneDto
 */
export interface CompanyAdminJobReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminJobReadOneDto
     */
    benefits: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    location: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminJobReadOneDto
     */
    requirements: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    validThru: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    workingHours: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminJobReadOneDto
     */
    contractType: Array<CompanyAdminJobReadOneDto.ContractTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    currency: CompanyAdminJobReadOneDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminJobReadOneDto
     */
    positionNames: Array<CompanyAdminJobReadOneDto.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    country: CompanyAdminJobReadOneDto.CountryEnum;
    /**
     * 
     * @type {Array<any>}
     * @memberof CompanyAdminJobReadOneDto
     */
    mustHaves: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    payoutType: CompanyAdminJobReadOneDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminJobReadOneDto
     */
    overtime: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    workingDays: CompanyAdminJobReadOneDto.WorkingDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminJobReadOneDto
     */
    active: boolean;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof CompanyAdminJobReadOneDto
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {number}
     * @memberof CompanyAdminJobReadOneDto
     */
    employeesNeeded: number;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminJobReadOneDto
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    projectDuration: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminJobReadOneDto
     */
    experienceLevel: CompanyAdminJobReadOneDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminJobReadOneDto
     */
    languages: Array<CompanyAdminJobReadOneDto.LanguagesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminJobReadOneDto
     */
    responsibilities: Array<string>;
}

/**
 * @export
 * @namespace CompanyAdminJobReadOneDto
 */
export namespace CompanyAdminJobReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface CompanyAdminReadManyDto
 */
export interface CompanyAdminReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    country: CompanyAdminReadManyDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    logoUrl: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyAdminReadManyDto
     */
    jobsCount: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    website: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminReadManyDto
     */
    industry: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    bannerUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDto
     */
    employeesNumber: string;
    /**
     * 
     * @type {CompanyPublicReadManyDtoSocialMedia}
     * @memberof CompanyAdminReadManyDto
     */
    socialMedia: CompanyPublicReadManyDtoSocialMedia;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminReadManyDto
     */
    isCompanyVisible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminReadManyDto
     */
    companyVerified: boolean;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof CompanyAdminReadManyDto
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {CompanyAdminReadManyDtoManager}
     * @memberof CompanyAdminReadManyDto
     */
    manager: CompanyAdminReadManyDtoManager;
}

/**
 * @export
 * @namespace CompanyAdminReadManyDto
 */
export namespace CompanyAdminReadManyDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface CompanyAdminReadManyDtoManager
 */
export interface CompanyAdminReadManyDtoManager {
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDtoManager
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDtoManager
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadManyDtoManager
     */
    lastName?: string;
}
/**
 * 
 * @export
 * @interface CompanyAdminReadOneDto
 */
export interface CompanyAdminReadOneDto {
    /**
     * 
     * @type {Date}
     * @memberof CompanyAdminReadOneDto
     */
    createdAt: Date;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    country: CompanyAdminReadOneDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    logoUrl: string;
    /**
     * 
     * @type {number}
     * @memberof CompanyAdminReadOneDto
     */
    jobsCount: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    website: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyAdminReadOneDto
     */
    industry: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    bannerUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    tin: string;
    /**
     * 
     * @type {CompanyPublicReadManyDtoSocialMedia}
     * @memberof CompanyAdminReadOneDto
     */
    socialMedia: CompanyPublicReadManyDtoSocialMedia;
    /**
     * 
     * @type {Array<CompanyAdminGalleryDto>}
     * @memberof CompanyAdminReadOneDto
     */
    gallery: Array<CompanyAdminGalleryDto>;
    /**
     * 
     * @type {Array<CompanyAdminFaqDto>}
     * @memberof CompanyAdminReadOneDto
     */
    faqs: Array<CompanyAdminFaqDto>;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof CompanyAdminReadOneDto
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyAdminReadOneDto
     */
    employeesNumber: string;
    /**
     * 
     * @type {Array<CompanyAdminJobReadOneDto>}
     * @memberof CompanyAdminReadOneDto
     */
    jobs: Array<CompanyAdminJobReadOneDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminReadOneDto
     */
    isCompanyVisible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyAdminReadOneDto
     */
    companyVerified: boolean;
    /**
     * 
     * @type {CompanyAdminReadManyDtoManager}
     * @memberof CompanyAdminReadOneDto
     */
    manager: CompanyAdminReadManyDtoManager;
}

/**
 * @export
 * @namespace CompanyAdminReadOneDto
 */
export namespace CompanyAdminReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface CompanyAdminUpdateDto
 */
export interface CompanyAdminUpdateDto {
}
/**
 * 
 * @export
 * @interface CompanyFaq
 */
export interface CompanyFaq {
    /**
     * 
     * @type {string}
     * @memberof CompanyFaq
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyFaq
     */
    answer: string;
}
/**
 * 
 * @export
 * @interface CompanyForJobResponseDto
 */
export interface CompanyForJobResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyForJobResponseDto
     */
    logoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyForJobResponseDto
     */
    name: string;
}
/**
 * 
 * @export
 * @interface CompanyGallery
 */
export interface CompanyGallery {
    /**
     * 
     * @type {string}
     * @memberof CompanyGallery
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyGallery
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyGallery
     */
    url: string;
}
/**
 * 
 * @export
 * @interface CompanyManagerUpdateDto
 */
export interface CompanyManagerUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    location?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    country?: CompanyManagerUpdateDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    logoUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    bannerUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    website?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyManagerUpdateDto
     */
    industry?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    employeesNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateDto
     */
    tin?: string;
    /**
     * 
     * @type {CompanyManagerUpdateSocialMediaDto}
     * @memberof CompanyManagerUpdateDto
     */
    socialMedia?: CompanyManagerUpdateSocialMediaDto;
    /**
     * 
     * @type {Array<CompanyManagerUpdateFaqDto>}
     * @memberof CompanyManagerUpdateDto
     */
    faqs?: Array<CompanyManagerUpdateFaqDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyManagerUpdateDto
     */
    isCompanyVisible?: boolean;
}

/**
 * @export
 * @namespace CompanyManagerUpdateDto
 */
export namespace CompanyManagerUpdateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface CompanyManagerUpdateFaqDto
 */
export interface CompanyManagerUpdateFaqDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateFaqDto
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateFaqDto
     */
    answer: string;
}
/**
 * 
 * @export
 * @interface CompanyManagerUpdateSocialMediaDto
 */
export interface CompanyManagerUpdateSocialMediaDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateSocialMediaDto
     */
    facebook?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateSocialMediaDto
     */
    instagram?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateSocialMediaDto
     */
    linkedin?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyManagerUpdateSocialMediaDto
     */
    twitter?: string;
}
/**
 * 
 * @export
 * @interface CompanyPublicFaqDto
 */
export interface CompanyPublicFaqDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicFaqDto
     */
    question: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicFaqDto
     */
    answer: string;
}
/**
 * 
 * @export
 * @interface CompanyPublicGalleryDto
 */
export interface CompanyPublicGalleryDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicGalleryDto
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicGalleryDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicGalleryDto
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface CompanyPublicJobDto
 */
export interface CompanyPublicJobDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicJobDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicJobDto
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyPublicJobDto
     */
    positionNames: Array<CompanyPublicJobDto.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicJobDto
     */
    country: CompanyPublicJobDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicJobDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicJobDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicJobDto
     */
    currency: CompanyPublicJobDto.CurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicJobDto
     */
    payoutType: CompanyPublicJobDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPublicJobDto
     */
    overtime: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyPublicJobDto
     */
    contractType: Array<CompanyPublicJobDto.ContractTypeEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPublicJobDto
     */
    active: boolean;
}

/**
 * @export
 * @namespace CompanyPublicJobDto
 */
export namespace CompanyPublicJobDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
}
/**
 * 
 * @export
 * @interface CompanyPublicReadManyDto
 */
export interface CompanyPublicReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    country: CompanyPublicReadManyDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    logoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    bannerUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    website: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyPublicReadManyDto
     */
    industry: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CompanyPublicReadManyDto
     */
    jobsCount: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDto
     */
    employeesNumber: string;
    /**
     * 
     * @type {CompanyPublicReadManyDtoSocialMedia}
     * @memberof CompanyPublicReadManyDto
     */
    socialMedia: CompanyPublicReadManyDtoSocialMedia;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPublicReadManyDto
     */
    isCompanyVisible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPublicReadManyDto
     */
    companyVerified: boolean;
}

/**
 * @export
 * @namespace CompanyPublicReadManyDto
 */
export namespace CompanyPublicReadManyDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface CompanyPublicReadManyDtoSocialMedia
 */
export interface CompanyPublicReadManyDtoSocialMedia {
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDtoSocialMedia
     */
    facebook?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDtoSocialMedia
     */
    instagram?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDtoSocialMedia
     */
    linkedin?: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadManyDtoSocialMedia
     */
    twitter?: string;
}
/**
 * 
 * @export
 * @interface CompanyPublicReadOneDto
 */
export interface CompanyPublicReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    location: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    country: CompanyPublicReadOneDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    logoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    bannerUrl: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    website: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CompanyPublicReadOneDto
     */
    industry: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CompanyPublicReadOneDto
     */
    jobsCount: number;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    employeesNumber: string;
    /**
     * 
     * @type {User}
     * @memberof CompanyPublicReadOneDto
     */
    manager: User;
    /**
     * 
     * @type {string}
     * @memberof CompanyPublicReadOneDto
     */
    tin: string;
    /**
     * 
     * @type {Array<CompanyPublicJobDto>}
     * @memberof CompanyPublicReadOneDto
     */
    jobs: Array<CompanyPublicJobDto>;
    /**
     * 
     * @type {CompanyPublicReadManyDtoSocialMedia}
     * @memberof CompanyPublicReadOneDto
     */
    socialMedia: CompanyPublicReadManyDtoSocialMedia;
    /**
     * 
     * @type {Array<CompanyPublicGalleryDto>}
     * @memberof CompanyPublicReadOneDto
     */
    gallery: Array<CompanyPublicGalleryDto>;
    /**
     * 
     * @type {Array<CompanyPublicFaqDto>}
     * @memberof CompanyPublicReadOneDto
     */
    faqs: Array<CompanyPublicFaqDto>;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPublicReadOneDto
     */
    isCompanyVisible: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CompanyPublicReadOneDto
     */
    companyVerified: boolean;
}

/**
 * @export
 * @namespace CompanyPublicReadOneDto
 */
export namespace CompanyPublicReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface CompleteCompanyProfileEmailDto
 */
export interface CompleteCompanyProfileEmailDto {
}
/**
 * 
 * @export
 * @interface CreateApplyPublicResponseDto
 */
export interface CreateApplyPublicResponseDto {
    /**
     * 
     * @type {string}
     * @memberof CreateApplyPublicResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplyPublicResponseDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplyPublicResponseDto
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplyPublicResponseDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplyPublicResponseDto
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateApplyPublicResponseDto
     */
    status: CreateApplyPublicResponseDto.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateApplyPublicResponseDto
     */
    description?: string;
    /**
     * 
     * @type {Date}
     * @memberof CreateApplyPublicResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof CreateApplyPublicResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {Job}
     * @memberof CreateApplyPublicResponseDto
     */
    job: Job;
    /**
     * 
     * @type {any}
     * @memberof CreateApplyPublicResponseDto
     */
    cvFile?: any;
}

/**
 * @export
 * @namespace CreateApplyPublicResponseDto
 */
export namespace CreateApplyPublicResponseDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface CreateGroupApplyUserDto
 */
export interface CreateGroupApplyUserDto {
    /**
     * 
     * @type {string}
     * @memberof CreateGroupApplyUserDto
     */
    jobSlug: string;
    /**
     * 
     * @type {Array<GroupMemberUserDto>}
     * @memberof CreateGroupApplyUserDto
     */
    members: Array<GroupMemberUserDto>;
    /**
     * 
     * @type {string}
     * @memberof CreateGroupApplyUserDto
     */
    mainApplicantId: string;
}
/**
 * 
 * @export
 * @interface CreateUserCompetencesDto
 */
export interface CreateUserCompetencesDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    country?: CreateUserCompetencesDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    positionName?: CreateUserCompetencesDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    experienceYears?: CreateUserCompetencesDto.ExperienceYearsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserCompetencesDto
     */
    drivingLicense?: Array<CreateUserCompetencesDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    nativeLanguage?: CreateUserCompetencesDto.NativeLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    availableSince?: CreateUserCompetencesDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    salaryRange?: CreateUserCompetencesDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateUserCompetencesDto
     */
    currencySalary?: CreateUserCompetencesDto.CurrencySalaryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserCompetencesDto
     */
    preferredCountries?: Array<CreateUserCompetencesDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserCompetencesDto
     */
    contractTypes?: Array<CreateUserCompetencesDto.ContractTypesEnum>;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof CreateUserCompetencesDto
     */
    experience?: Array<ExperienceDto>;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof CreateUserCompetencesDto
     */
    education?: Array<EducationDto>;
    /**
     * 
     * @type {SkillsDto}
     * @memberof CreateUserCompetencesDto
     */
    skills?: SkillsDto;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof CreateUserCompetencesDto
     */
    languages?: Array<LanguageProficiency>;
    /**
     * 
     * @type {CertificatesDto}
     * @memberof CreateUserCompetencesDto
     */
    certificates?: CertificatesDto;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserCompetencesDto
     */
    isLookingForJob: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserCompetencesDto
     */
    hasOwnCompany: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUserCompetencesDto
     */
    isProfileVisible: boolean;
    /**
     * 
     * @type {Array<AdminCreateNoteDto>}
     * @memberof CreateUserCompetencesDto
     */
    adminNotes?: Array<AdminCreateNoteDto>;
}

/**
 * @export
 * @namespace CreateUserCompetencesDto
 */
export namespace CreateUserCompetencesDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypesEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
}
/**
 * 
 * @export
 * @interface EducationDto
 */
export interface EducationDto {
    /**
     * 
     * @type {string}
     * @memberof EducationDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EducationDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof EducationDto
     */
    institution: string;
    /**
     * 
     * @type {Date}
     * @memberof EducationDto
     */
    dateFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof EducationDto
     */
    dateTo?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof EducationDto
     */
    isCurrent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof EducationDto
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ExperienceDto
 */
export interface ExperienceDto {
    /**
     * 
     * @type {string}
     * @memberof ExperienceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceDto
     */
    positionName?: ExperienceDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ExperienceDto
     */
    positionOther?: string;
    /**
     * 
     * @type {Date}
     * @memberof ExperienceDto
     */
    startDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof ExperienceDto
     */
    endDate?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ExperienceDto
     */
    isCurrent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExperienceDto
     */
    company?: string;
    /**
     * 
     * @type {string}
     * @memberof ExperienceDto
     */
    country: ExperienceDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof ExperienceDto
     */
    description?: string;
}

/**
 * @export
 * @namespace ExperienceDto
 */
export namespace ExperienceDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface ForgotPasswordRequestDto
 */
export interface ForgotPasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ForgotPasswordRequestDto
     */
    email: string;
}
/**
 * 
 * @export
 * @interface GeneratedCV
 */
export interface GeneratedCV {
    /**
     * 
     * @type {string}
     * @memberof GeneratedCV
     */
    fileKey: string;
    /**
     * 
     * @type {string}
     * @memberof GeneratedCV
     */
    fileName: string;
    /**
     * 
     * @type {Date}
     * @memberof GeneratedCV
     */
    generatedAt: Date;
}
/**
 * 
 * @export
 * @interface GroupAppliesReadManyAdminResponseDto
 */
export interface GroupAppliesReadManyAdminResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof GroupAppliesReadManyAdminResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof GroupAppliesReadManyAdminResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof GroupAppliesReadManyAdminResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface GroupAppliesReadManyManagerResponseDto
 */
export interface GroupAppliesReadManyManagerResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof GroupAppliesReadManyManagerResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof GroupAppliesReadManyManagerResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof GroupAppliesReadManyManagerResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface GroupAppliesReadManyUserResponseDto
 */
export interface GroupAppliesReadManyUserResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof GroupAppliesReadManyUserResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof GroupAppliesReadManyUserResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof GroupAppliesReadManyUserResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface GroupApply
 */
export interface GroupApply {
    /**
     * 
     * @type {string}
     * @memberof GroupApply
     */
    id: string;
    /**
     * 
     * @type {Job}
     * @memberof GroupApply
     */
    job: Job;
    /**
     * 
     * @type {User}
     * @memberof GroupApply
     */
    mainApplicant: User;
    /**
     * 
     * @type {string}
     * @memberof GroupApply
     */
    status: GroupApply.StatusEnum;
    /**
     * 
     * @type {Array<any>}
     * @memberof GroupApply
     */
    members: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof GroupApply
     */
    description: string;
    /**
     * 
     * @type {Date}
     * @memberof GroupApply
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupApply
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof GroupApply
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace GroupApply
 */
export namespace GroupApply {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface GroupMemberUserDto
 */
export interface GroupMemberUserDto {
    /**
     * 
     * @type {string}
     * @memberof GroupMemberUserDto
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberUserDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberUserDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberUserDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberUserDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof GroupMemberUserDto
     */
    positionName: GroupMemberUserDto.PositionNameEnum;
    /**
     * 
     * @type {number}
     * @memberof GroupMemberUserDto
     */
    yearsOfExperience: number;
}

/**
 * @export
 * @namespace GroupMemberUserDto
 */
export namespace GroupMemberUserDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface HelpOfferEmailDto
 */
export interface HelpOfferEmailDto {
}
/**
 * 
 * @export
 * @interface HelpOfferManagerEmailDto
 */
export interface HelpOfferManagerEmailDto {
}
/**
 * 
 * @export
 * @interface InlineResponse200
 */
export interface InlineResponse200 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<UserAdminReadManyDto>}
     * @memberof InlineResponse200
     */
    data?: Array<UserAdminReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse200
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2001
 */
export interface InlineResponse2001 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<CompanyPublicReadManyDto>}
     * @memberof InlineResponse2001
     */
    data?: Array<CompanyPublicReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse2001
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse20010
 */
export interface InlineResponse20010 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<TalentPublicReadManyDto>}
     * @memberof InlineResponse20010
     */
    data?: Array<TalentPublicReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse20010
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse20011
 */
export interface InlineResponse20011 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<WorkerRequestAdminReadManyDto>}
     * @memberof InlineResponse20011
     */
    data?: Array<WorkerRequestAdminReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse20011
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<WorkerRequestManagerReadManyResponseDto>}
     * @memberof InlineResponse20012
     */
    data?: Array<WorkerRequestManagerReadManyResponseDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse20012
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse20013
 */
export interface InlineResponse20013 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<GroupAppliesReadManyUserResponseDto>}
     * @memberof InlineResponse20013
     */
    data?: Array<GroupAppliesReadManyUserResponseDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse20013
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse20014
 */
export interface InlineResponse20014 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<GroupAppliesReadManyManagerResponseDto>}
     * @memberof InlineResponse20014
     */
    data?: Array<GroupAppliesReadManyManagerResponseDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse20014
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse20015
 */
export interface InlineResponse20015 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<GroupAppliesReadManyAdminResponseDto>}
     * @memberof InlineResponse20015
     */
    data?: Array<GroupAppliesReadManyAdminResponseDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse20015
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2002
 */
export interface InlineResponse2002 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<CompanyAdminReadManyDto>}
     * @memberof InlineResponse2002
     */
    data?: Array<CompanyAdminReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse2002
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2003
 */
export interface InlineResponse2003 extends PaginatedDocumented {
    /**
     * 
     * @type {Array<AppliesReadManyAdminResponseDto>}
     * @memberof InlineResponse2003
     */
    data?: Array<AppliesReadManyAdminResponseDto>;
    /**
     * 
     * @type {InlineResponse2003Meta}
     * @memberof InlineResponse2003
     */
    meta?: InlineResponse2003Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2003Meta
 */
export interface InlineResponse2003Meta {
    /**
     * 
     * @type {Array<string>}
     * @memberof InlineResponse2003Meta
     */
    select?: Array<string>;
    /**
     * 
     * @type {InlineResponse2003MetaFilter}
     * @memberof InlineResponse2003Meta
     */
    filter?: InlineResponse2003MetaFilter;
}
/**
 * 
 * @export
 * @interface InlineResponse2003MetaFilter
 */
export interface InlineResponse2003MetaFilter {
    /**
     * 
     * @type {string | Array<string>}
     * @memberof InlineResponse2003MetaFilter
     */
    name?: string | Array<string>;
    /**
     * 
     * @type {string | Array<string>}
     * @memberof InlineResponse2003MetaFilter
     */
    email?: string | Array<string>;
}
/**
 * 
 * @export
 * @interface InlineResponse2004
 */
export interface InlineResponse2004 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<AppliesReadManyUserResponseDto>}
     * @memberof InlineResponse2004
     */
    data?: Array<AppliesReadManyUserResponseDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse2004
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2005
 */
export interface InlineResponse2005 extends PaginatedDocumented {
    /**
     * 
     * @type {Array<AppliesReadManyManagerResponseDto>}
     * @memberof InlineResponse2005
     */
    data?: Array<AppliesReadManyManagerResponseDto>;
    /**
     * 
     * @type {InlineResponse2003Meta}
     * @memberof InlineResponse2005
     */
    meta?: InlineResponse2003Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2006
 */
export interface InlineResponse2006 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<JobPublicReadManyDto>}
     * @memberof InlineResponse2006
     */
    data?: Array<JobPublicReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse2006
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2007
 */
export interface InlineResponse2007 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<JobManagerReadManyResponseDto>}
     * @memberof InlineResponse2007
     */
    data?: Array<JobManagerReadManyResponseDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse2007
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2008
 */
export interface InlineResponse2008 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<JobAdminReadManyDto>}
     * @memberof InlineResponse2008
     */
    data?: Array<JobAdminReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse2008
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse2009
 */
export interface InlineResponse2009 extends BasePaginatedResponse {
    /**
     * 
     * @type {Array<TalentAdminReadManyDto>}
     * @memberof InlineResponse2009
     */
    data?: Array<TalentAdminReadManyDto>;
    /**
     * 
     * @type {InlineResponse200Meta}
     * @memberof InlineResponse2009
     */
    meta?: InlineResponse200Meta;
}
/**
 * 
 * @export
 * @interface InlineResponse200Meta
 */
export interface InlineResponse200Meta {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200Meta
     */
    totalItems?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200Meta
     */
    itemsPerPage?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200Meta
     */
    currentPage?: number;
    /**
     * 
     * @type {number}
     * @memberof InlineResponse200Meta
     */
    totalPages?: number;
}
/**
 * 
 * @export
 * @interface Job
 */
export interface Job {
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Job
     */
    positionNames: Array<Job.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    country: Job.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    currency: Job.CurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    payoutType: Job.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof Job
     */
    overtime: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Job
     */
    requirements: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Job
     */
    responsibilities: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Job
     */
    benefits: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    workingHours: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    workingDays: Job.WorkingDaysEnum;
    /**
     * 
     * @type {Date}
     * @memberof Job
     */
    validThru: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof Job
     */
    contractType: Array<Job.ContractTypeEnum>;
    /**
     * 
     * @type {Array<any>}
     * @memberof Job
     */
    mustHaves: Array<any>;
    /**
     * 
     * @type {any}
     * @memberof Job
     */
    offerOptions: any;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    phoneNumber: string;
    /**
     * 
     * @type {number}
     * @memberof Job
     */
    employeesNeeded: number;
    /**
     * 
     * @type {boolean}
     * @memberof Job
     */
    active: boolean;
    /**
     * 
     * @type {User}
     * @memberof Job
     */
    createdBy: User;
    /**
     * 
     * @type {Company}
     * @memberof Job
     */
    company: Company;
    /**
     * 
     * @type {Array<Apply>}
     * @memberof Job
     */
    applies: Array<Apply>;
    /**
     * 
     * @type {Array<GroupApply>}
     * @memberof Job
     */
    groupApplies: Array<GroupApply>;
    /**
     * 
     * @type {boolean}
     * @memberof Job
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    projectDuration: string;
    /**
     * 
     * @type {string}
     * @memberof Job
     */
    experienceLevel: Job.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof Job
     */
    languages: Array<Job.LanguagesEnum>;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof Job
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {Date}
     * @memberof Job
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Job
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof Job
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace Job
 */
export namespace Job {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface JobAdminReadManyDto
 */
export interface JobAdminReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadManyDto
     */
    benefits: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadManyDto
     */
    requirements: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof JobAdminReadManyDto
     */
    validThru: Date;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    workingHours: string;
    /**
     * 
     * @type {CompanyForJobResponseDto}
     * @memberof JobAdminReadManyDto
     */
    company: CompanyForJobResponseDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadManyDto
     */
    contractType: Array<JobAdminReadManyDto.ContractTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    currency: JobAdminReadManyDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadManyDto
     */
    positionNames: Array<JobAdminReadManyDto.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    country: JobAdminReadManyDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    payoutType: JobAdminReadManyDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobAdminReadManyDto
     */
    overtime: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    workingDays: JobAdminReadManyDto.WorkingDaysEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobAdminReadManyDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobAdminReadManyDto
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    projectDuration: string;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadManyDto
     */
    experienceLevel: JobAdminReadManyDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadManyDto
     */
    languages: Array<JobAdminReadManyDto.LanguagesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadManyDto
     */
    responsibilities: Array<string>;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof JobAdminReadManyDto
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {number}
     * @memberof JobAdminReadManyDto
     */
    appliesCount: number;
    /**
     * 
     * @type {number}
     * @memberof JobAdminReadManyDto
     */
    groupAppliesCount: number;
    /**
     * 
     * @type {Date}
     * @memberof JobAdminReadManyDto
     */
    createdAt: Date;
}

/**
 * @export
 * @namespace JobAdminReadManyDto
 */
export namespace JobAdminReadManyDto {
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface JobAdminReadOneDto
 */
export interface JobAdminReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadOneDto
     */
    benefits: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadOneDto
     */
    requirements: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof JobAdminReadOneDto
     */
    validThru: Date;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    workingHours: string;
    /**
     * 
     * @type {CompanyForJobResponseDto}
     * @memberof JobAdminReadOneDto
     */
    company: CompanyForJobResponseDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadOneDto
     */
    contractType: Array<JobAdminReadOneDto.ContractTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    currency: JobAdminReadOneDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadOneDto
     */
    positionNames: Array<JobAdminReadOneDto.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    country: JobAdminReadOneDto.CountryEnum;
    /**
     * 
     * @type {any}
     * @memberof JobAdminReadOneDto
     */
    offerOptions: any;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    payoutType: JobAdminReadOneDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobAdminReadOneDto
     */
    overtime: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    workingDays: JobAdminReadOneDto.WorkingDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {boolean}
     * @memberof JobAdminReadOneDto
     */
    active: boolean;
    /**
     * 
     * @type {Array<CreateApplyPublicResponseDto>}
     * @memberof JobAdminReadOneDto
     */
    applies: Array<CreateApplyPublicResponseDto>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadOneDto
     */
    responsibilities: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof JobAdminReadOneDto
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    projectDuration: string;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof JobAdminReadOneDto
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {string}
     * @memberof JobAdminReadOneDto
     */
    experienceLevel: JobAdminReadOneDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobAdminReadOneDto
     */
    languages: Array<JobAdminReadOneDto.LanguagesEnum>;
    /**
     * 
     * @type {number}
     * @memberof JobAdminReadOneDto
     */
    employeesNeeded: number;
    /**
     * 
     * @type {User}
     * @memberof JobAdminReadOneDto
     */
    createdBy: User;
    /**
     * 
     * @type {Array<GroupApply>}
     * @memberof JobAdminReadOneDto
     */
    groupApplies: Array<GroupApply>;
}

/**
 * @export
 * @namespace JobAdminReadOneDto
 */
export namespace JobAdminReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface JobManagerCompanyDto
 */
export interface JobManagerCompanyDto {
    /**
     * 
     * @type {string}
     * @memberof JobManagerCompanyDto
     */
    logoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof JobManagerCompanyDto
     */
    name: string;
}
/**
 * 
 * @export
 * @interface JobManagerDto
 */
export interface JobManagerDto {
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobManagerDto
     */
    benefits: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    description: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobManagerDto
     */
    requirements: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    title: string;
    /**
     * 
     * @type {Date}
     * @memberof JobManagerDto
     */
    validThru: Date;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    workingHours: string;
    /**
     * 
     * @type {JobManagerCompanyDto}
     * @memberof JobManagerDto
     */
    company: JobManagerCompanyDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobManagerDto
     */
    contractType: Array<JobManagerDto.ContractTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    currency: JobManagerDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobManagerDto
     */
    positionNames: Array<JobManagerDto.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    country: JobManagerDto.CountryEnum;
    /**
     * 
     * @type {Array<any>}
     * @memberof JobManagerDto
     */
    mustHaves: Array<any>;
    /**
     * 
     * @type {any}
     * @memberof JobManagerDto
     */
    offerOptions: any;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    payoutType: JobManagerDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobManagerDto
     */
    overtime: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    workingDays: JobManagerDto.WorkingDaysEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobManagerDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {number}
     * @memberof JobManagerDto
     */
    employeesNeeded: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobManagerDto
     */
    responsibilities: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof JobManagerDto
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    projectDuration: string;
    /**
     * 
     * @type {string}
     * @memberof JobManagerDto
     */
    experienceLevel: JobManagerDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobManagerDto
     */
    languages: Array<JobManagerDto.LanguagesEnum>;
    /**
     * 
     * @type {Array<CreateApplyPublicResponseDto>}
     * @memberof JobManagerDto
     */
    applies: Array<CreateApplyPublicResponseDto>;
    /**
     * 
     * @type {number}
     * @memberof JobManagerDto
     */
    applicationsCount: number;
    /**
     * 
     * @type {number}
     * @memberof JobManagerDto
     */
    groupAppliesCount: number;
}

/**
 * @export
 * @namespace JobManagerDto
 */
export namespace JobManagerDto {
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface JobManagerReadManyResponseDto
 */
export interface JobManagerReadManyResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof JobManagerReadManyResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof JobManagerReadManyResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof JobManagerReadManyResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface JobPublicCompanyReadManyDto
 */
export interface JobPublicCompanyReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof JobPublicCompanyReadManyDto
     */
    logoUrl: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicCompanyReadManyDto
     */
    name: string;
}
/**
 * 
 * @export
 * @interface JobPublicOfferOptionsReadManyDto
 */
export interface JobPublicOfferOptionsReadManyDto {
    /**
     * 
     * @type {boolean}
     * @memberof JobPublicOfferOptionsReadManyDto
     */
    ensuredAccommodation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobPublicOfferOptionsReadManyDto
     */
    ensuredFeeding: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobPublicOfferOptionsReadManyDto
     */
    ensuredTransport: boolean;
}
/**
 * 
 * @export
 * @interface JobPublicReadManyDto
 */
export interface JobPublicReadManyDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadManyDto
     */
    benefits: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadManyDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadManyDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadManyDto
     */
    title: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadManyDto
     */
    contractType: Array<JobPublicReadManyDto.ContractTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadManyDto
     */
    currency: JobPublicReadManyDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadManyDto
     */
    positionNames: Array<JobPublicReadManyDto.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadManyDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadManyDto
     */
    country: JobPublicReadManyDto.CountryEnum;
    /**
     * 
     * @type {JobPublicCompanyReadManyDto}
     * @memberof JobPublicReadManyDto
     */
    company: JobPublicCompanyReadManyDto;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadManyDto
     */
    experienceLevel: JobPublicReadManyDto.ExperienceLevelEnum;
    /**
     * 
     * @type {JobPublicOfferOptionsReadManyDto}
     * @memberof JobPublicReadManyDto
     */
    offerOptions: JobPublicOfferOptionsReadManyDto;
    /**
     * 
     * @type {boolean}
     * @memberof JobPublicReadManyDto
     */
    overtime: boolean;
}

/**
 * @export
 * @namespace JobPublicReadManyDto
 */
export namespace JobPublicReadManyDto {
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
}
/**
 * 
 * @export
 * @interface JobPublicReadOneDto
 */
export interface JobPublicReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    id: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadOneDto
     */
    contractType: Array<JobPublicReadOneDto.ContractTypeEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadOneDto
     */
    benefits: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    currency: JobPublicReadOneDto.CurrencyEnum;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    location: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadOneDto
     */
    requirements: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    validThru: string;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    workingHours: string;
    /**
     * 
     * @type {CompanyPublicReadOneDto}
     * @memberof JobPublicReadOneDto
     */
    company: CompanyPublicReadOneDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadOneDto
     */
    positionNames: Array<JobPublicReadOneDto.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    country: JobPublicReadOneDto.CountryEnum;
    /**
     * 
     * @type {any}
     * @memberof JobPublicReadOneDto
     */
    offerOptions: any;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    payoutType: JobPublicReadOneDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobPublicReadOneDto
     */
    overtime: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    workingDays: JobPublicReadOneDto.WorkingDaysEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobPublicReadOneDto
     */
    active: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    tin: string;
    /**
     * 
     * @type {Array<CreateApplyPublicResponseDto>}
     * @memberof JobPublicReadOneDto
     */
    applies: Array<CreateApplyPublicResponseDto>;
    /**
     * 
     * @type {boolean}
     * @memberof JobPublicReadOneDto
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    projectDuration: string;
    /**
     * 
     * @type {number}
     * @memberof JobPublicReadOneDto
     */
    employeesNeeded: number;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    experienceLevel: JobPublicReadOneDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadOneDto
     */
    languages: Array<JobPublicReadOneDto.LanguagesEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    city: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobPublicReadOneDto
     */
    responsibilities: Array<string>;
    /**
     * 
     * @type {Array<any>}
     * @memberof JobPublicReadOneDto
     */
    mustHaves: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof JobPublicReadOneDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {User}
     * @memberof JobPublicReadOneDto
     */
    createdBy: User;
    /**
     * 
     * @type {Array<GroupApply>}
     * @memberof JobPublicReadOneDto
     */
    groupApplies: Array<GroupApply>;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof JobPublicReadOneDto
     */
    adminNotes: Array<AdminNote>;
}

/**
 * @export
 * @namespace JobPublicReadOneDto
 */
export namespace JobPublicReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface JobsAdminCreateDto
 */
export interface JobsAdminCreateDto {
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    currency: JobsAdminCreateDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsAdminCreateDto
     */
    requirements?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsAdminCreateDto
     */
    responsibilities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsAdminCreateDto
     */
    benefits?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    workingHours?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    slug: string;
    /**
     * 
     * @type {Date}
     * @memberof JobsAdminCreateDto
     */
    validThru: Date;
    /**
     * 
     * @type {any}
     * @memberof JobsAdminCreateDto
     */
    company: any;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsAdminCreateDto
     */
    positionNames: Array<JobsAdminCreateDto.PositionNamesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsAdminCreateDto
     */
    contractType: Array<JobsAdminCreateDto.ContractTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    country: JobsAdminCreateDto.CountryEnum;
    /**
     * 
     * @type {OfferOptionsDto}
     * @memberof JobsAdminCreateDto
     */
    offerOptions: OfferOptionsDto;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    payoutType: JobsAdminCreateDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobsAdminCreateDto
     */
    overtime: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {number}
     * @memberof JobsAdminCreateDto
     */
    employeesNeeded?: number;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    workingDays: JobsAdminCreateDto.WorkingDaysEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobsAdminCreateDto
     */
    active: boolean;
    /**
     * 
     * @type {any}
     * @memberof JobsAdminCreateDto
     */
    createdBy: any;
    /**
     * 
     * @type {boolean}
     * @memberof JobsAdminCreateDto
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    projectDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsAdminCreateDto
     */
    experienceLevel: JobsAdminCreateDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsAdminCreateDto
     */
    languages: Array<JobsAdminCreateDto.LanguagesEnum>;
    /**
     * 
     * @type {Array<AdminCreateNoteDto>}
     * @memberof JobsAdminCreateDto
     */
    adminNotes?: Array<AdminCreateNoteDto>;
}

/**
 * @export
 * @namespace JobsAdminCreateDto
 */
export namespace JobsAdminCreateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface JobsAdminUpdateDto
 */
export interface JobsAdminUpdateDto {
}
/**
 * 
 * @export
 * @interface JobsManagerCreateDto
 */
export interface JobsManagerCreateDto {
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    currency: JobsManagerCreateDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerCreateDto
     */
    requirements?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerCreateDto
     */
    responsibilities?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerCreateDto
     */
    benefits?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    workingHours?: string;
    /**
     * 
     * @type {Date}
     * @memberof JobsManagerCreateDto
     */
    validThru: Date;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerCreateDto
     */
    positionNames: Array<JobsManagerCreateDto.PositionNamesEnum>;
    /**
     * 
     * @type {number}
     * @memberof JobsManagerCreateDto
     */
    employeesNeeded?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerCreateDto
     */
    contractType: Array<JobsManagerCreateDto.ContractTypeEnum>;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    country: JobsManagerCreateDto.CountryEnum;
    /**
     * 
     * @type {OfferOptionsDto}
     * @memberof JobsManagerCreateDto
     */
    offerOptions: OfferOptionsDto;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    payoutType: JobsManagerCreateDto.PayoutTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerCreateDto
     */
    overtime: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    workingDays: JobsManagerCreateDto.WorkingDaysEnum;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerCreateDto
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerCreateDto
     */
    requiredTools: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    projectDuration?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerCreateDto
     */
    experienceLevel: JobsManagerCreateDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerCreateDto
     */
    languages: Array<JobsManagerCreateDto.LanguagesEnum>;
}

/**
 * @export
 * @namespace JobsManagerCreateDto
 */
export namespace JobsManagerCreateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface JobsManagerUpdateDto
 */
export interface JobsManagerUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    country: JobsManagerUpdateDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    description?: string;
    /**
     * 
     * @type {Array<JobsManagerUpdateMustHavesDto>}
     * @memberof JobsManagerUpdateDto
     */
    mustHaves?: Array<JobsManagerUpdateMustHavesDto>;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerUpdateDto
     */
    requiredTools?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerUpdateDto
     */
    requirements?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerUpdateDto
     */
    active?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerUpdateDto
     */
    benefits?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    payoutType?: JobsManagerUpdateDto.PayoutTypeEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerUpdateDto
     */
    positionNames?: Array<JobsManagerUpdateDto.PositionNamesEnum>;
    /**
     * 
     * @type {JobsManagerUpdateOfferOptionsDto}
     * @memberof JobsManagerUpdateDto
     */
    offerOptions?: JobsManagerUpdateOfferOptionsDto;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerUpdateDto
     */
    responsibilities?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    workingDays?: JobsManagerUpdateDto.WorkingDaysEnum;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    workingHours?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {Date}
     * @memberof JobsManagerUpdateDto
     */
    validThru?: Date;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    salaryRange?: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    experienceLevel?: JobsManagerUpdateDto.ExperienceLevelEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerUpdateDto
     */
    languages?: Array<JobsManagerUpdateDto.LanguagesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerUpdateDto
     */
    overtime?: boolean;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    projectDuration?: string;
    /**
     * 
     * @type {number}
     * @memberof JobsManagerUpdateDto
     */
    employeesNeeded?: number;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateDto
     */
    currency?: JobsManagerUpdateDto.CurrencyEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobsManagerUpdateDto
     */
    contractType?: Array<JobsManagerUpdateDto.ContractTypeEnum>;
}

/**
 * @export
 * @namespace JobsManagerUpdateDto
 */
export namespace JobsManagerUpdateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PayoutTypeEnum {
        Hourly = <any> 'hourly',
        Weekly = <any> 'weekly',
        Monthly = <any> 'monthly',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum WorkingDaysEnum {
        MonFri = <any> 'mon-fri',
        MonSat = <any> 'mon-sat',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceLevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LanguagesEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypeEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
}
/**
 * 
 * @export
 * @interface JobsManagerUpdateMustHavesDto
 */
export interface JobsManagerUpdateMustHavesDto {
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateMustHavesDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof JobsManagerUpdateMustHavesDto
     */
    level: string;
}
/**
 * 
 * @export
 * @interface JobsManagerUpdateOfferOptionsDto
 */
export interface JobsManagerUpdateOfferOptionsDto {
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerUpdateOfferOptionsDto
     */
    ensuredTransport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerUpdateOfferOptionsDto
     */
    ensuredAccommodation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof JobsManagerUpdateOfferOptionsDto
     */
    ensuredFeeding: boolean;
}
/**
 * 
 * @export
 * @interface LanguageProficiency
 */
export interface LanguageProficiency {
    /**
     * 
     * @type {string}
     * @memberof LanguageProficiency
     */
    language: LanguageProficiency.LanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof LanguageProficiency
     */
    level: LanguageProficiency.LevelEnum;
}

/**
 * @export
 * @namespace LanguageProficiency
 */
export namespace LanguageProficiency {
    /**
     * @export
     * @enum {string}
     */
    export enum LanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LevelEnum {
        Beginner = <any> 'beginner',
        Intermediate = <any> 'intermediate',
        Expert = <any> 'expert'
    }
}
/**
 * 
 * @export
 * @interface LinkUserWith3rdProviderRequestDto
 */
export interface LinkUserWith3rdProviderRequestDto {
    /**
     * 
     * @type {string}
     * @memberof LinkUserWith3rdProviderRequestDto
     */
    signInProvider: LinkUserWith3rdProviderRequestDto.SignInProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof LinkUserWith3rdProviderRequestDto
     */
    providerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof LinkUserWith3rdProviderRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof LinkUserWith3rdProviderRequestDto
     */
    cognitoSub: string;
}

/**
 * @export
 * @namespace LinkUserWith3rdProviderRequestDto
 */
export namespace LinkUserWith3rdProviderRequestDto {
    /**
     * @export
     * @enum {string}
     */
    export enum SignInProviderEnum {
        Google = <any> 'google',
        Facebook = <any> 'facebook'
    }
}
/**
 * 
 * @export
 * @interface LlmRequestDto
 */
export interface LlmRequestDto {
}
/**
 * 
 * @export
 * @interface ManagerCompanyGalleryRemoveDto
 */
export interface ManagerCompanyGalleryRemoveDto {
    /**
     * 
     * @type {string}
     * @memberof ManagerCompanyGalleryRemoveDto
     */
    url: string;
}
/**
 * 
 * @export
 * @interface ManagerCompanyGalleryUpdateDto
 */
export interface ManagerCompanyGalleryUpdateDto {
    /**
     * 
     * @type {Blob}
     * @memberof ManagerCompanyGalleryUpdateDto
     */
    file?: Blob;
    /**
     * 
     * @type {string}
     * @memberof ManagerCompanyGalleryUpdateDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ManagerCompanyGalleryUpdateDto
     */
    description?: string;
}
/**
 * 
 * @export
 * @interface ManagerUpdateApplicationStatusDto
 */
export interface ManagerUpdateApplicationStatusDto {
    /**
     * 
     * @type {string}
     * @memberof ManagerUpdateApplicationStatusDto
     */
    status: ManagerUpdateApplicationStatusDto.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ManagerUpdateApplicationStatusDto
     */
    description?: string;
}

/**
 * @export
 * @namespace ManagerUpdateApplicationStatusDto
 */
export namespace ManagerUpdateApplicationStatusDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface ModelFile
 */
export interface ModelFile {
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof ModelFile
     */
    resourceId: string;
    /**
     * 
     * @type {number}
     * @memberof ModelFile
     */
    fileSize: number;
    /**
     * 
     * @type {Apply}
     * @memberof ModelFile
     */
    applies: Apply;
}
/**
 * 
 * @export
 * @interface NewPasswordRequestDto
 */
export interface NewPasswordRequestDto {
    /**
     * 
     * @type {string}
     * @memberof NewPasswordRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof NewPasswordRequestDto
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof NewPasswordRequestDto
     */
    code: string;
}
/**
 * 
 * @export
 * @interface OfferOptionsDto
 */
export interface OfferOptionsDto {
    /**
     * 
     * @type {boolean}
     * @memberof OfferOptionsDto
     */
    ensuredTransport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfferOptionsDto
     */
    ensuredAccommodation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof OfferOptionsDto
     */
    ensuredFeeding: boolean;
}
/**
 * 
 * @export
 * @interface PaginatedDocumented
 */
export interface PaginatedDocumented {
    /**
     * 
     * @type {Array<any>}
     * @memberof PaginatedDocumented
     */
    data: Array<any>;
    /**
     * 
     * @type {PaginatedMetaDocumented}
     * @memberof PaginatedDocumented
     */
    meta: PaginatedMetaDocumented;
    /**
     * 
     * @type {PaginatedLinksDocumented}
     * @memberof PaginatedDocumented
     */
    links: PaginatedLinksDocumented;
}
/**
 * 
 * @export
 * @interface PaginatedLinksDocumented
 */
export interface PaginatedLinksDocumented {
    /**
     * 
     * @type {string}
     * @memberof PaginatedLinksDocumented
     */
    first?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLinksDocumented
     */
    previous?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLinksDocumented
     */
    current?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLinksDocumented
     */
    next?: string;
    /**
     * 
     * @type {string}
     * @memberof PaginatedLinksDocumented
     */
    last?: string;
}
/**
 * 
 * @export
 * @interface PaginatedMetaDocumented
 */
export interface PaginatedMetaDocumented {
    /**
     * 
     * @type {number}
     * @memberof PaginatedMetaDocumented
     */
    itemsPerPage: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMetaDocumented
     */
    totalItems: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMetaDocumented
     */
    currentPage: number;
    /**
     * 
     * @type {number}
     * @memberof PaginatedMetaDocumented
     */
    totalPages: number;
    /**
     * 
     * @type {Array<Array<string>>}
     * @memberof PaginatedMetaDocumented
     */
    sortBy?: Array<Array<string>>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaginatedMetaDocumented
     */
    searchBy?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof PaginatedMetaDocumented
     */
    search?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof PaginatedMetaDocumented
     */
    select?: Array<string>;
    /**
     * 
     * @type {any}
     * @memberof PaginatedMetaDocumented
     */
    filter?: any;
}
/**
 * 
 * @export
 * @interface PredefinedSkills
 */
export interface PredefinedSkills {
    /**
     * 
     * @type {string}
     * @memberof PredefinedSkills
     */
    positionName: PredefinedSkills.PositionNameEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof PredefinedSkills
     */
    positionSkills: Array<string>;
}

/**
 * @export
 * @namespace PredefinedSkills
 */
export namespace PredefinedSkills {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface ProfileCompletionEmailDto
 */
export interface ProfileCompletionEmailDto {
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyAdminDto
 */
export interface ReadOneGroupApplyAdminDto {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDto
     */
    status: ReadOneGroupApplyAdminDto.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDto
     */
    description: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof ReadOneGroupApplyAdminDto
     */
    members: Array<any>;
    /**
     * 
     * @type {ReadOneGroupApplyAdminDtoMainApplicant}
     * @memberof ReadOneGroupApplyAdminDto
     */
    mainApplicant: ReadOneGroupApplyAdminDtoMainApplicant;
    /**
     * 
     * @type {ReadOneGroupApplyAdminDtoJob}
     * @memberof ReadOneGroupApplyAdminDto
     */
    job: ReadOneGroupApplyAdminDtoJob;
    /**
     * 
     * @type {Date}
     * @memberof ReadOneGroupApplyAdminDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOneGroupApplyAdminDto
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace ReadOneGroupApplyAdminDto
 */
export namespace ReadOneGroupApplyAdminDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyAdminDtoJob
 */
export interface ReadOneGroupApplyAdminDtoJob {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    companyLogo?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    positionNames?: Array<ReadOneGroupApplyAdminDtoJob.PositionNamesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoJob
     */
    country?: string;
}

/**
 * @export
 * @namespace ReadOneGroupApplyAdminDtoJob
 */
export namespace ReadOneGroupApplyAdminDtoJob {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNamesEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyAdminDtoMainApplicant
 */
export interface ReadOneGroupApplyAdminDtoMainApplicant {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    userId?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    positionName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    experienceYears?: ReadOneGroupApplyAdminDtoMainApplicant.ExperienceYearsEnum;
    /**
     * 
     * @type {number}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    userNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    userAvatar?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOneGroupApplyAdminDtoMainApplicant
     */
    emailConfirmed?: boolean;
}

/**
 * @export
 * @namespace ReadOneGroupApplyAdminDtoMainApplicant
 */
export namespace ReadOneGroupApplyAdminDtoMainApplicant {
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyManagerDto
 */
export interface ReadOneGroupApplyManagerDto {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDto
     */
    status: ReadOneGroupApplyManagerDto.StatusEnum;
    /**
     * 
     * @type {Array<any>}
     * @memberof ReadOneGroupApplyManagerDto
     */
    members: Array<any>;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDto
     */
    description: string;
    /**
     * 
     * @type {ReadOneGroupApplyManagerDtoMainApplicant}
     * @memberof ReadOneGroupApplyManagerDto
     */
    mainApplicant: ReadOneGroupApplyManagerDtoMainApplicant;
    /**
     * 
     * @type {ReadOneGroupApplyManagerDtoJob}
     * @memberof ReadOneGroupApplyManagerDto
     */
    job: ReadOneGroupApplyManagerDtoJob;
    /**
     * 
     * @type {Date}
     * @memberof ReadOneGroupApplyManagerDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ReadOneGroupApplyManagerDto
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace ReadOneGroupApplyManagerDto
 */
export namespace ReadOneGroupApplyManagerDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyManagerDtoJob
 */
export interface ReadOneGroupApplyManagerDtoJob {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoJob
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoJob
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoJob
     */
    slug?: string;
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyManagerDtoMainApplicant
 */
export interface ReadOneGroupApplyManagerDtoMainApplicant {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    positionName?: ReadOneGroupApplyManagerDtoMainApplicant.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    experienceYears?: ReadOneGroupApplyManagerDtoMainApplicant.ExperienceYearsEnum;
    /**
     * 
     * @type {number}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    userNumber?: number;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    userAvatar?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ReadOneGroupApplyManagerDtoMainApplicant
     */
    emailConfirmed?: boolean;
}

/**
 * @export
 * @namespace ReadOneGroupApplyManagerDtoMainApplicant
 */
export namespace ReadOneGroupApplyManagerDtoMainApplicant {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyUserDto
 */
export interface ReadOneGroupApplyUserDto {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDto
     */
    status: ReadOneGroupApplyUserDto.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDto
     */
    description: string;
    /**
     * 
     * @type {Array<any>}
     * @memberof ReadOneGroupApplyUserDto
     */
    members: Array<any>;
    /**
     * 
     * @type {ReadOneGroupApplyUserDtoMainApplicant}
     * @memberof ReadOneGroupApplyUserDto
     */
    mainApplicant: ReadOneGroupApplyUserDtoMainApplicant;
    /**
     * 
     * @type {ReadOneGroupApplyUserDtoJob}
     * @memberof ReadOneGroupApplyUserDto
     */
    job: ReadOneGroupApplyUserDtoJob;
    /**
     * 
     * @type {Date}
     * @memberof ReadOneGroupApplyUserDto
     */
    createdAt: Date;
}

/**
 * @export
 * @namespace ReadOneGroupApplyUserDto
 */
export namespace ReadOneGroupApplyUserDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyUserDtoJob
 */
export interface ReadOneGroupApplyUserDtoJob {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    companyName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    companyLogo?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    positionNames?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoJob
     */
    country?: string;
}
/**
 * 
 * @export
 * @interface ReadOneGroupApplyUserDtoMainApplicant
 */
export interface ReadOneGroupApplyUserDtoMainApplicant {
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    userAvatar?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    positionName?: ReadOneGroupApplyUserDtoMainApplicant.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof ReadOneGroupApplyUserDtoMainApplicant
     */
    experienceYears?: ReadOneGroupApplyUserDtoMainApplicant.ExperienceYearsEnum;
}

/**
 * @export
 * @namespace ReadOneGroupApplyUserDtoMainApplicant
 */
export namespace ReadOneGroupApplyUserDtoMainApplicant {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
}
/**
 * 
 * @export
 * @interface RefreshTokenRequestDto
 */
export interface RefreshTokenRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenRequestDto
     */
    refreshToken: string;
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenRequestDto
     */
    cognitoSub: string;
}
/**
 * 
 * @export
 * @interface RefreshTokenResponseDto
 */
export interface RefreshTokenResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RefreshTokenResponseDto
     */
    idToken: string;
}
/**
 * 
 * @export
 * @interface ResendRequestDto
 */
export interface ResendRequestDto {
    /**
     * 
     * @type {string}
     * @memberof ResendRequestDto
     */
    email: string;
}
/**
 * 
 * @export
 * @interface RespondChallengeRequestDto
 */
export interface RespondChallengeRequestDto {
    /**
     * 
     * @type {string}
     * @memberof RespondChallengeRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof RespondChallengeRequestDto
     */
    newPassword: string;
    /**
     * 
     * @type {string}
     * @memberof RespondChallengeRequestDto
     */
    session: string;
}
/**
 * 
 * @export
 * @interface SignInRequestDto
 */
export interface SignInRequestDto {
    /**
     * 
     * @type {string}
     * @memberof SignInRequestDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SignInRequestDto
     */
    password: string;
}
/**
 * 
 * @export
 * @interface SignInResponseDto
 */
export interface SignInResponseDto {
    /**
     * 
     * @type {string}
     * @memberof SignInResponseDto
     */
    idToken: string;
    /**
     * 
     * @type {string}
     * @memberof SignInResponseDto
     */
    refreshToken: string;
    /**
     * 
     * @type {UserResponse}
     * @memberof SignInResponseDto
     */
    user: UserResponse;
}
/**
 * 
 * @export
 * @interface SignupDto
 */
export interface SignupDto {
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SignupDto
     */
    password: string;
    /**
     * 
     * @type {boolean}
     * @memberof SignupDto
     */
    isManager?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignupDto
     */
    commercialConsent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SignupDto
     */
    consent: boolean;
}
/**
 * 
 * @export
 * @interface SignupFromProviderDto
 */
export interface SignupFromProviderDto {
    /**
     * 
     * @type {string}
     * @memberof SignupFromProviderDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof SignupFromProviderDto
     */
    externalAuthProviderId: string;
    /**
     * 
     * @type {boolean}
     * @memberof SignupFromProviderDto
     */
    isManager?: boolean;
}
/**
 * 
 * @export
 * @interface SkillsDto
 */
export interface SkillsDto {
    /**
     * 
     * @type {Array<PredefinedSkills>}
     * @memberof SkillsDto
     */
    predefined?: Array<PredefinedSkills>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SkillsDto
     */
    other?: Array<string>;
}
/**
 * 
 * @export
 * @interface TalentAdminReadManyDto
 */
export interface TalentAdminReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    slug: string;
    /**
     * 
     * @type {TalentAdminReadManyDtoUser}
     * @memberof TalentAdminReadManyDto
     */
    user: TalentAdminReadManyDtoUser;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    country?: TalentAdminReadManyDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    positionName?: TalentAdminReadManyDto.PositionNameEnum;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof TalentAdminReadManyDto
     */
    experience?: Array<ExperienceDto>;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    experienceYears?: TalentAdminReadManyDto.ExperienceYearsEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    availableSince?: TalentAdminReadManyDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    salaryRange?: TalentAdminReadManyDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDto
     */
    currencySalary?: TalentAdminReadManyDto.CurrencySalaryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentAdminReadManyDto
     */
    preferredCountries?: Array<TalentAdminReadManyDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadManyDto
     */
    isLookingForJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadManyDto
     */
    isProfileVisible?: boolean;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof TalentAdminReadManyDto
     */
    adminNotes?: Array<AdminNote>;
}

/**
 * @export
 * @namespace TalentAdminReadManyDto
 */
export namespace TalentAdminReadManyDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
}
/**
 * 
 * @export
 * @interface TalentAdminReadManyDtoUser
 */
export interface TalentAdminReadManyDtoUser {
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDtoUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDtoUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDtoUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDtoUser
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDtoUser
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDtoUser
     */
    group?: string;
    /**
     * 
     * @type {Date}
     * @memberof TalentAdminReadManyDtoUser
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadManyDtoUser
     */
    cognitoSub?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadManyDtoUser
     */
    createdByAdmin?: boolean;
}
/**
 * 
 * @export
 * @interface TalentAdminReadOneDto
 */
export interface TalentAdminReadOneDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentAdminReadOneDto
     */
    drivingLicense?: Array<TalentAdminReadOneDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof TalentAdminReadOneDto
     */
    languages?: Array<LanguageProficiency>;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    country?: TalentAdminReadOneDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    positionName?: TalentAdminReadOneDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    experienceYears?: TalentAdminReadOneDto.ExperienceYearsEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    availableSince?: TalentAdminReadOneDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    salaryRange?: TalentAdminReadOneDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    currencySalary?: TalentAdminReadOneDto.CurrencySalaryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDto
     */
    nativeLanguage?: TalentAdminReadOneDto.NativeLanguageEnum;
    /**
     * 
     * @type {TalentAdminReadOneDtoUser}
     * @memberof TalentAdminReadOneDto
     */
    user: TalentAdminReadOneDtoUser;
    /**
     * 
     * @type {UserCompetencesSkills}
     * @memberof TalentAdminReadOneDto
     */
    skills: UserCompetencesSkills;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof TalentAdminReadOneDto
     */
    experience?: Array<ExperienceDto>;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof TalentAdminReadOneDto
     */
    education?: Array<EducationDto>;
    /**
     * 
     * @type {AppliedUserInfoCompetencesManagerDtoCertificates}
     * @memberof TalentAdminReadOneDto
     */
    certificates: AppliedUserInfoCompetencesManagerDtoCertificates;
    /**
     * 
     * @type {Array<CertificateFiles>}
     * @memberof TalentAdminReadOneDto
     */
    certificateFiles?: Array<CertificateFiles>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentAdminReadOneDto
     */
    preferredCountries?: Array<TalentAdminReadOneDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentAdminReadOneDto
     */
    contractTypes?: Array<TalentAdminReadOneDto.ContractTypesEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadOneDto
     */
    isLookingForJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadOneDto
     */
    isProfileVisible?: boolean;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof TalentAdminReadOneDto
     */
    adminNotes?: Array<AdminNote>;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadOneDto
     */
    hasOwnCompany?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof TalentAdminReadOneDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof TalentAdminReadOneDto
     */
    updatedAt: Date;
}

/**
 * @export
 * @namespace TalentAdminReadOneDto
 */
export namespace TalentAdminReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypesEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
}
/**
 * 
 * @export
 * @interface TalentAdminReadOneDtoUser
 */
export interface TalentAdminReadOneDtoUser {
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    group?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadOneDtoUser
     */
    consent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadOneDtoUser
     */
    commercialConsent?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    cvKey?: string;
    /**
     * 
     * @type {Date}
     * @memberof TalentAdminReadOneDtoUser
     */
    createdAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof TalentAdminReadOneDtoUser
     */
    cognitoSub?: string;
    /**
     * 
     * @type {number}
     * @memberof TalentAdminReadOneDtoUser
     */
    candidateNumber?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TalentAdminReadOneDtoUser
     */
    createdByAdmin?: boolean;
}
/**
 * 
 * @export
 * @interface TalentPoolUserReadOneDto
 */
export interface TalentPoolUserReadOneDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPoolUserReadOneDto
     */
    drivingLicense: Array<TalentPoolUserReadOneDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    nativeLanguage: TalentPoolUserReadOneDto.NativeLanguageEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPoolUserReadOneDto
     */
    preferredCountries: Array<TalentPoolUserReadOneDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPoolUserReadOneDto
     */
    contractTypes: Array<TalentPoolUserReadOneDto.ContractTypesEnum>;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    country: TalentPoolUserReadOneDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    positionName: TalentPoolUserReadOneDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    experienceYears: TalentPoolUserReadOneDto.ExperienceYearsEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    availableSince: TalentPoolUserReadOneDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    salaryRange: TalentPoolUserReadOneDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserReadOneDto
     */
    currencySalary: TalentPoolUserReadOneDto.CurrencySalaryEnum;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof TalentPoolUserReadOneDto
     */
    experience: Array<ExperienceDto>;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof TalentPoolUserReadOneDto
     */
    education: Array<EducationDto>;
    /**
     * 
     * @type {UserCompetencesSkills}
     * @memberof TalentPoolUserReadOneDto
     */
    skills: UserCompetencesSkills;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof TalentPoolUserReadOneDto
     */
    languages: Array<LanguageProficiency>;
    /**
     * 
     * @type {AppliedUserInfoCompetencesManagerDtoCertificates}
     * @memberof TalentPoolUserReadOneDto
     */
    certificates: AppliedUserInfoCompetencesManagerDtoCertificates;
    /**
     * 
     * @type {Array<CertificateFiles>}
     * @memberof TalentPoolUserReadOneDto
     */
    certificateFiles: Array<CertificateFiles>;
    /**
     * 
     * @type {Array<GeneratedCV>}
     * @memberof TalentPoolUserReadOneDto
     */
    generatedCV: Array<GeneratedCV>;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPoolUserReadOneDto
     */
    isLookingForJob: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPoolUserReadOneDto
     */
    hasOwnCompany: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPoolUserReadOneDto
     */
    isProfileVisible: boolean;
    /**
     * 
     * @type {TalentPoolUserUserReadOneDto}
     * @memberof TalentPoolUserReadOneDto
     */
    user: TalentPoolUserUserReadOneDto;
}

/**
 * @export
 * @namespace TalentPoolUserReadOneDto
 */
export namespace TalentPoolUserReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypesEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
}
/**
 * 
 * @export
 * @interface TalentPoolUserUserReadOneDto
 */
export interface TalentPoolUserUserReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserUserReadOneDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserUserReadOneDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserUserReadOneDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserUserReadOneDto
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserUserReadOneDto
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPoolUserUserReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof TalentPoolUserUserReadOneDto
     */
    candidateNumber: number;
}
/**
 * 
 * @export
 * @interface TalentPublicReadManyDto
 */
export interface TalentPublicReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    slug: string;
    /**
     * 
     * @type {TalentPublicReadManyDtoUser}
     * @memberof TalentPublicReadManyDto
     */
    user: TalentPublicReadManyDtoUser;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    country?: TalentPublicReadManyDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    positionName?: TalentPublicReadManyDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    experienceYears?: TalentPublicReadManyDto.ExperienceYearsEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    availableSince?: TalentPublicReadManyDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    salaryRange?: TalentPublicReadManyDto.SalaryRangeEnum;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof TalentPublicReadManyDto
     */
    experience?: Array<ExperienceDto>;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    currencySalary?: TalentPublicReadManyDto.CurrencySalaryEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPublicReadManyDto
     */
    preferredCountries?: Array<TalentPublicReadManyDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof TalentPublicReadManyDto
     */
    languages?: Array<LanguageProficiency>;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDto
     */
    nativeLanguage?: TalentPublicReadManyDto.NativeLanguageEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPublicReadManyDto
     */
    drivingLicense?: Array<TalentPublicReadManyDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPublicReadManyDto
     */
    isLookingForJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPublicReadManyDto
     */
    isProfileVisible?: boolean;
}

/**
 * @export
 * @namespace TalentPublicReadManyDto
 */
export namespace TalentPublicReadManyDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
}
/**
 * 
 * @export
 * @interface TalentPublicReadManyDtoUser
 */
export interface TalentPublicReadManyDtoUser {
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadManyDtoUser
     */
    avatar?: string;
    /**
     * 
     * @type {number}
     * @memberof TalentPublicReadManyDtoUser
     */
    userNumber?: number;
}
/**
 * 
 * @export
 * @interface TalentPublicReadOneDto
 */
export interface TalentPublicReadOneDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPublicReadOneDto
     */
    drivingLicense?: Array<TalentPublicReadOneDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    country?: TalentPublicReadOneDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    positionName?: TalentPublicReadOneDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    experienceYears?: TalentPublicReadOneDto.ExperienceYearsEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    availableSince?: TalentPublicReadOneDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    salaryRange?: TalentPublicReadOneDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    currencySalary?: TalentPublicReadOneDto.CurrencySalaryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDto
     */
    nativeLanguage?: TalentPublicReadOneDto.NativeLanguageEnum;
    /**
     * 
     * @type {TalentPublicReadOneDtoUser}
     * @memberof TalentPublicReadOneDto
     */
    user: TalentPublicReadOneDtoUser;
    /**
     * 
     * @type {UserCompetencesSkills}
     * @memberof TalentPublicReadOneDto
     */
    skills: UserCompetencesSkills;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof TalentPublicReadOneDto
     */
    experience?: Array<ExperienceDto>;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof TalentPublicReadOneDto
     */
    education?: Array<EducationDto>;
    /**
     * 
     * @type {AppliedUserInfoCompetencesManagerDtoCertificates}
     * @memberof TalentPublicReadOneDto
     */
    certificates: AppliedUserInfoCompetencesManagerDtoCertificates;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPublicReadOneDto
     */
    preferredCountries?: Array<TalentPublicReadOneDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentPublicReadOneDto
     */
    contractTypes?: Array<TalentPublicReadOneDto.ContractTypesEnum>;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof TalentPublicReadOneDto
     */
    languages?: Array<LanguageProficiency>;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPublicReadOneDto
     */
    isLookingForJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPublicReadOneDto
     */
    isProfileVisible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentPublicReadOneDto
     */
    hasOwnCompany?: boolean;
}

/**
 * @export
 * @namespace TalentPublicReadOneDto
 */
export namespace TalentPublicReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypesEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
}
/**
 * 
 * @export
 * @interface TalentPublicReadOneDtoUser
 */
export interface TalentPublicReadOneDtoUser {
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDtoUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDtoUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDtoUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDtoUser
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentPublicReadOneDtoUser
     */
    avatar?: string;
    /**
     * 
     * @type {number}
     * @memberof TalentPublicReadOneDtoUser
     */
    userNumber?: number;
}
/**
 * 
 * @export
 * @interface TalentUserUpdateDto
 */
export interface TalentUserUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    country?: TalentUserUpdateDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    positionName?: TalentUserUpdateDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    experienceYears?: TalentUserUpdateDto.ExperienceYearsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentUserUpdateDto
     */
    drivingLicense?: Array<TalentUserUpdateDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    nativeLanguage?: TalentUserUpdateDto.NativeLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    availableSince?: TalentUserUpdateDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    salaryRange?: TalentUserUpdateDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof TalentUserUpdateDto
     */
    currencySalary?: TalentUserUpdateDto.CurrencySalaryEnum;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof TalentUserUpdateDto
     */
    languages?: Array<LanguageProficiency>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentUserUpdateDto
     */
    preferredCountries?: Array<TalentUserUpdateDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TalentUserUpdateDto
     */
    contractTypes?: Array<TalentUserUpdateDto.ContractTypesEnum>;
    /**
     * 
     * @type {SkillsDto}
     * @memberof TalentUserUpdateDto
     */
    skills?: SkillsDto;
    /**
     * 
     * @type {CertificatesDto}
     * @memberof TalentUserUpdateDto
     */
    certificates?: CertificatesDto;
    /**
     * 
     * @type {Array<CertificateFilesDto>}
     * @memberof TalentUserUpdateDto
     */
    certificateFiles?: Array<CertificateFilesDto>;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof TalentUserUpdateDto
     */
    education?: Array<EducationDto>;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof TalentUserUpdateDto
     */
    experience?: Array<ExperienceDto>;
    /**
     * 
     * @type {boolean}
     * @memberof TalentUserUpdateDto
     */
    isLookingForJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentUserUpdateDto
     */
    hasOwnCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TalentUserUpdateDto
     */
    isProfileVisible?: boolean;
}

/**
 * @export
 * @namespace TalentUserUpdateDto
 */
export namespace TalentUserUpdateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypesEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
}
/**
 * 
 * @export
 * @interface UpdateApplyAdminDto
 */
export interface UpdateApplyAdminDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateApplyAdminDto
     */
    status?: UpdateApplyAdminDto.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateApplyAdminDto
     */
    description?: string;
}

/**
 * @export
 * @namespace UpdateApplyAdminDto
 */
export namespace UpdateApplyAdminDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface UpdateGroupApplyAdminDto
 */
export interface UpdateGroupApplyAdminDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupApplyAdminDto
     */
    status?: UpdateGroupApplyAdminDto.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupApplyAdminDto
     */
    description?: string;
}

/**
 * @export
 * @namespace UpdateGroupApplyAdminDto
 */
export namespace UpdateGroupApplyAdminDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface UpdateGroupApplyManagerDto
 */
export interface UpdateGroupApplyManagerDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupApplyManagerDto
     */
    status: UpdateGroupApplyManagerDto.StatusEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateGroupApplyManagerDto
     */
    description: string;
}

/**
 * @export
 * @namespace UpdateGroupApplyManagerDto
 */
export namespace UpdateGroupApplyManagerDto {
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Applied = <any> 'applied',
        Contacted = <any> 'contacted',
        Approved = <any> 'approved',
        Hired = <any> 'hired',
        Rejected = <any> 'rejected',
        Confirmed = <any> 'confirmed',
        Completed = <any> 'completed'
    }
}
/**
 * 
 * @export
 * @interface UpdateTalentAdminDto
 */
export interface UpdateTalentAdminDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    country?: UpdateTalentAdminDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    positionName?: UpdateTalentAdminDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    experienceYears?: UpdateTalentAdminDto.ExperienceYearsEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTalentAdminDto
     */
    drivingLicense?: Array<UpdateTalentAdminDto.DrivingLicenseEnum>;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    nativeLanguage?: UpdateTalentAdminDto.NativeLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    availableSince?: UpdateTalentAdminDto.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    salaryRange?: UpdateTalentAdminDto.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateTalentAdminDto
     */
    currencySalary?: UpdateTalentAdminDto.CurrencySalaryEnum;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof UpdateTalentAdminDto
     */
    languages?: Array<LanguageProficiency>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTalentAdminDto
     */
    preferredCountries?: Array<UpdateTalentAdminDto.PreferredCountriesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateTalentAdminDto
     */
    contractTypes?: Array<UpdateTalentAdminDto.ContractTypesEnum>;
    /**
     * 
     * @type {SkillsDto}
     * @memberof UpdateTalentAdminDto
     */
    skills?: SkillsDto;
    /**
     * 
     * @type {CertificatesDto}
     * @memberof UpdateTalentAdminDto
     */
    certificates?: CertificatesDto;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof UpdateTalentAdminDto
     */
    education?: Array<EducationDto>;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof UpdateTalentAdminDto
     */
    experience?: Array<ExperienceDto>;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTalentAdminDto
     */
    isLookingForJob?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTalentAdminDto
     */
    hasOwnCompany?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTalentAdminDto
     */
    isProfileVisible?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTalentAdminDto
     */
    consent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateTalentAdminDto
     */
    commercialConsent?: boolean;
    /**
     * 
     * @type {Array<AdminCreateNoteDto>}
     * @memberof UpdateTalentAdminDto
     */
    adminNotes?: Array<AdminCreateNoteDto>;
}

/**
 * @export
 * @namespace UpdateTalentAdminDto
 */
export namespace UpdateTalentAdminDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum DrivingLicenseEnum {
        A = <any> 'A',
        B = <any> 'B',
        C = <any> 'C',
        D = <any> 'D',
        E = <any> 'E'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PreferredCountriesEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ContractTypesEnum {
        B2b = <any> 'b2b',
        EmploymentContract = <any> 'employment_contract',
        MandateContract = <any> 'mandate_contract',
        ContractForWork = <any> 'contract_for_work'
    }
}
/**
 * 
 * @export
 * @interface UpdateUserDto
 */
export interface UpdateUserDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    consent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateUserDto
     */
    commercialConsent?: boolean;
}
/**
 * 
 * @export
 * @interface User
 */
export interface User {
    /**
     * 
     * @type {string}
     * @memberof User
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof User
     */
    userNumber: number;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    cognitoSub?: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    cvKey: string;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    group: User.GroupEnum;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    emailConfirmed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    consent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    commercialConsent: boolean;
    /**
     * 
     * @type {string}
     * @memberof User
     */
    loginProvider: User.LoginProviderEnum;
    /**
     * 
     * @type {Array<Apply>}
     * @memberof User
     */
    applies: Array<Apply>;
    /**
     * 
     * @type {Company}
     * @memberof User
     */
    company: Company;
    /**
     * 
     * @type {UserCompetences}
     * @memberof User
     */
    userCompetences: UserCompetences;
    /**
     * 
     * @type {Array<Job>}
     * @memberof User
     */
    jobs: Array<Job>;
    /**
     * 
     * @type {Array<WorkerRequest>}
     * @memberof User
     */
    workerRequests: Array<WorkerRequest>;
    /**
     * 
     * @type {boolean}
     * @memberof User
     */
    createdByAdmin: boolean;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof User
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace User
 */
export namespace User {
    /**
     * @export
     * @enum {string}
     */
    export enum GroupEnum {
        Admin = <any> 'admin',
        User = <any> 'user',
        Manager = <any> 'manager'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum LoginProviderEnum {
        Google = <any> 'google',
        Facebook = <any> 'facebook'
    }
}
/**
 * 
 * @export
 * @interface UserAdminCreateDto
 */
export interface UserAdminCreateDto {
    /**
     * 
     * @type {string}
     * @memberof UserAdminCreateDto
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminCreateDto
     */
    group: UserAdminCreateDto.GroupEnum;
}

/**
 * @export
 * @namespace UserAdminCreateDto
 */
export namespace UserAdminCreateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum GroupEnum {
        Admin = <any> 'admin',
        User = <any> 'user',
        Manager = <any> 'manager'
    }
}
/**
 * 
 * @export
 * @interface UserAdminManagerReadOneDto
 */
export interface UserAdminManagerReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDto
     */
    cognitoSub?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDto
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDto
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDto
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDto
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminManagerReadOneDto
     */
    consent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminManagerReadOneDto
     */
    commercialConsent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminManagerReadOneDto
     */
    createdByAdmin?: boolean;
    /**
     * 
     * @type {UserAdminManagerReadOneDtoCompany}
     * @memberof UserAdminManagerReadOneDto
     */
    company: UserAdminManagerReadOneDtoCompany;
}
/**
 * 
 * @export
 * @interface UserAdminManagerReadOneDtoCompany
 */
export interface UserAdminManagerReadOneDtoCompany {
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerReadOneDtoCompany
     */
    id?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminManagerReadOneDtoCompany
     */
    isCompanyVisible?: boolean;
}
/**
 * 
 * @export
 * @interface UserAdminManagerUpdateDto
 */
export interface UserAdminManagerUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerUpdateDto
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerUpdateDto
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerUpdateDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerUpdateDto
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminManagerUpdateDto
     */
    avatar?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminManagerUpdateDto
     */
    consent?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminManagerUpdateDto
     */
    commercialConsent?: boolean;
}
/**
 * 
 * @export
 * @interface UserAdminReadManyDto
 */
export interface UserAdminReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDto
     */
    id: string;
    /**
     * 
     * @type {UserAdminReadManyDtoUser}
     * @memberof UserAdminReadManyDto
     */
    user: UserAdminReadManyDtoUser;
    /**
     * 
     * @type {UserAdminReadManyDtoCompany}
     * @memberof UserAdminReadManyDto
     */
    company: UserAdminReadManyDtoCompany;
}
/**
 * 
 * @export
 * @interface UserAdminReadManyDtoCompany
 */
export interface UserAdminReadManyDtoCompany {
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoCompany
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoCompany
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoCompany
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoCompany
     */
    country?: string;
}
/**
 * 
 * @export
 * @interface UserAdminReadManyDtoUser
 */
export interface UserAdminReadManyDtoUser {
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoUser
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoUser
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoUser
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoUser
     */
    phoneNumber?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoUser
     */
    avatar?: string;
    /**
     * 
     * @type {string}
     * @memberof UserAdminReadManyDtoUser
     */
    group?: string;
    /**
     * 
     * @type {Date}
     * @memberof UserAdminReadManyDtoUser
     */
    createdAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof UserAdminReadManyDtoUser
     */
    createdByAdmin?: boolean;
}
/**
 * 
 * @export
 * @interface UserCompetences
 */
export interface UserCompetences {
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    id: string;
    /**
     * 
     * @type {User}
     * @memberof UserCompetences
     */
    user: User;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    country: UserCompetences.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    positionName: UserCompetences.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    experienceYears: UserCompetences.ExperienceYearsEnum;
    /**
     * 
     * @type {any}
     * @memberof UserCompetences
     */
    drivingLicense: any;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    nativeLanguage: UserCompetences.NativeLanguageEnum;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    availableSince: UserCompetences.AvailableSinceEnum;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    salaryRange: UserCompetences.SalaryRangeEnum;
    /**
     * 
     * @type {string}
     * @memberof UserCompetences
     */
    currencySalary: UserCompetences.CurrencySalaryEnum;
    /**
     * 
     * @type {any}
     * @memberof UserCompetences
     */
    preferredCountries: any;
    /**
     * 
     * @type {any}
     * @memberof UserCompetences
     */
    contractTypes: any;
    /**
     * 
     * @type {Array<ExperienceDto>}
     * @memberof UserCompetences
     */
    experience: Array<ExperienceDto>;
    /**
     * 
     * @type {Array<EducationDto>}
     * @memberof UserCompetences
     */
    education: Array<EducationDto>;
    /**
     * 
     * @type {UserCompetencesSkills}
     * @memberof UserCompetences
     */
    skills: UserCompetencesSkills;
    /**
     * 
     * @type {Array<LanguageProficiency>}
     * @memberof UserCompetences
     */
    languages: Array<LanguageProficiency>;
    /**
     * 
     * @type {AppliedUserInfoCompetencesManagerDtoCertificates}
     * @memberof UserCompetences
     */
    certificates: AppliedUserInfoCompetencesManagerDtoCertificates;
    /**
     * 
     * @type {Array<CertificateFiles>}
     * @memberof UserCompetences
     */
    certificateFiles: Array<CertificateFiles>;
    /**
     * 
     * @type {Array<GeneratedCV>}
     * @memberof UserCompetences
     */
    generatedCV: Array<GeneratedCV>;
    /**
     * 
     * @type {boolean}
     * @memberof UserCompetences
     */
    isLookingForJob: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCompetences
     */
    hasOwnCompany: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserCompetences
     */
    isProfileVisible: boolean;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof UserCompetences
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {Date}
     * @memberof UserCompetences
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserCompetences
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof UserCompetences
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace UserCompetences
 */
export namespace UserCompetences {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum ExperienceYearsEnum {
        _0 = <any> '0',
        _05 = <any> '0_5',
        _1 = <any> '1',
        _2 = <any> '2',
        _3 = <any> '3',
        _4 = <any> '4',
        _5 = <any> '5',
        _6 = <any> '6',
        _7 = <any> '7',
        _10 = <any> '10+'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum NativeLanguageEnum {
        Polish = <any> 'polish',
        English = <any> 'english',
        German = <any> 'german',
        French = <any> 'french',
        Spanish = <any> 'spanish',
        Italian = <any> 'italian',
        Dutch = <any> 'dutch',
        Norwegian = <any> 'norwegian',
        Swedish = <any> 'swedish',
        Danish = <any> 'danish',
        Other = <any> 'other'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum AvailableSinceEnum {
        Asap = <any> 'asap',
        _2Weeks = <any> '2_weeks',
        _1Month = <any> '1_month',
        _2Months = <any> '2_months',
        _3Months = <any> '3_months'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum SalaryRangeEnum {
        _42005700 = <any> '4200-5700',
        _57007200 = <any> '5700-7200',
        _72008700 = <any> '7200-8700',
        _870010200 = <any> '8700-10200',
        _1020011700 = <any> '10200-11700',
        _1170013200 = <any> '11700-13200',
        _1320014700 = <any> '13200-14700',
        _1470016200 = <any> '14700-16200',
        _1620017700 = <any> '16200-17700',
        _1770019200 = <any> '17700-19200',
        _1920020000 = <any> '19200-20000',
        Negotiable = <any> 'negotiable'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencySalaryEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
}
/**
 * 
 * @export
 * @interface UserCompetencesSkills
 */
export interface UserCompetencesSkills {
    /**
     * 
     * @type {Array<PredefinedSkills>}
     * @memberof UserCompetencesSkills
     */
    predefined?: Array<PredefinedSkills>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UserCompetencesSkills
     */
    other?: Array<string>;
}
/**
 * 
 * @export
 * @interface UserInfoResponseDto
 */
export interface UserInfoResponseDto {
    /**
     * 
     * @type {string}
     * @memberof UserInfoResponseDto
     */
    loginProvider: UserInfoResponseDto.LoginProviderEnum;
    /**
     * 
     * @type {boolean}
     * @memberof UserInfoResponseDto
     */
    userExistsInApp: boolean;
}

/**
 * @export
 * @namespace UserInfoResponseDto
 */
export namespace UserInfoResponseDto {
    /**
     * @export
     * @enum {string}
     */
    export enum LoginProviderEnum {
        Google = <any> 'google',
        Facebook = <any> 'facebook'
    }
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    phoneNumber: string;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    experience: number;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    cognitoSub: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    avatar: string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    group: UserResponse.GroupEnum;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    email: string;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    emailConfirmed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    consent: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UserResponse
     */
    commercialConsent: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    slug: string;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    userNumber: number;
}

/**
 * @export
 * @namespace UserResponse
 */
export namespace UserResponse {
    /**
     * @export
     * @enum {string}
     */
    export enum GroupEnum {
        Admin = <any> 'admin',
        User = <any> 'user',
        Manager = <any> 'manager'
    }
}
/**
 * 
 * @export
 * @interface VerifyRequestDto
 */
export interface VerifyRequestDto {
    /**
     * 
     * @type {string}
     * @memberof VerifyRequestDto
     */
    code: string;
    /**
     * 
     * @type {string}
     * @memberof VerifyRequestDto
     */
    email: string;
}
/**
 * 
 * @export
 * @interface WeeklyJobRecommendationsDto
 */
export interface WeeklyJobRecommendationsDto {
}
/**
 * 
 * @export
 * @interface WorkerRequest
 */
export interface WorkerRequest {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    companyName: string;
    /**
     * 
     * @type {Array<WorkerRequestPosition>}
     * @memberof WorkerRequest
     */
    positions: Array<WorkerRequestPosition>;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    duration: WorkerRequest.DurationEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    country: WorkerRequest.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    managerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    managerPhone: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    currency: WorkerRequest.CurrencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequest
     */
    ensuredTransport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequest
     */
    ensuredAccommodation: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    status: WorkerRequest.StatusEnum;
    /**
     * 
     * @type {Array<AdminNote>}
     * @memberof WorkerRequest
     */
    adminNotes: Array<AdminNote>;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequest
     */
    requestNumber: string;
    /**
     * 
     * @type {User}
     * @memberof WorkerRequest
     */
    createdBy: User;
    /**
     * 
     * @type {Date}
     * @memberof WorkerRequest
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkerRequest
     */
    updatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkerRequest
     */
    deletedAt: Date;
}

/**
 * @export
 * @namespace WorkerRequest
 */
export namespace WorkerRequest {
    /**
     * @export
     * @enum {string}
     */
    export enum DurationEnum {
        Less90 = <any> 'less_90',
        Less180 = <any> 'less_180',
        More180 = <any> 'more_180'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Submitted = <any> 'submitted',
        InReview = <any> 'in_review',
        Contacted = <any> 'contacted',
        PendingApproval = <any> 'pending_approval',
        Approved = <any> 'approved',
        Rejected = <any> 'rejected'
    }
}
/**
 * 
 * @export
 * @interface WorkerRequestAdminReadManyDto
 */
export interface WorkerRequestAdminReadManyDto {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadManyDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadManyDto
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadManyDto
     */
    requestNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadManyDto
     */
    country: WorkerRequestAdminReadManyDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadManyDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadManyDto
     */
    status: WorkerRequestAdminReadManyDto.StatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof WorkerRequestAdminReadManyDto
     */
    createdAt: Date;
}

/**
 * @export
 * @namespace WorkerRequestAdminReadManyDto
 */
export namespace WorkerRequestAdminReadManyDto {
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Submitted = <any> 'submitted',
        InReview = <any> 'in_review',
        Contacted = <any> 'contacted',
        PendingApproval = <any> 'pending_approval',
        Approved = <any> 'approved',
        Rejected = <any> 'rejected'
    }
}
/**
 * 
 * @export
 * @interface WorkerRequestAdminReadOneDto
 */
export interface WorkerRequestAdminReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    companyName: string;
    /**
     * 
     * @type {Array<WorkerRequestPositionDto>}
     * @memberof WorkerRequestAdminReadOneDto
     */
    positions: Array<WorkerRequestPositionDto>;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    duration: WorkerRequestAdminReadOneDto.DurationEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    country: WorkerRequestAdminReadOneDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    requestNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    managerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    managerPhone: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    currency: WorkerRequestAdminReadOneDto.CurrencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestAdminReadOneDto
     */
    ensuredTransport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestAdminReadOneDto
     */
    ensuredAccommodation: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDto
     */
    status: WorkerRequestAdminReadOneDto.StatusEnum;
    /**
     * 
     * @type {Array<AdminNoteDto>}
     * @memberof WorkerRequestAdminReadOneDto
     */
    adminNotes: Array<AdminNoteDto>;
    /**
     * 
     * @type {Date}
     * @memberof WorkerRequestAdminReadOneDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkerRequestAdminReadOneDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {WorkerRequestAdminReadOneDtoCreatedBy}
     * @memberof WorkerRequestAdminReadOneDto
     */
    createdBy: WorkerRequestAdminReadOneDtoCreatedBy;
}

/**
 * @export
 * @namespace WorkerRequestAdminReadOneDto
 */
export namespace WorkerRequestAdminReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DurationEnum {
        Less90 = <any> 'less_90',
        Less180 = <any> 'less_180',
        More180 = <any> 'more_180'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Submitted = <any> 'submitted',
        InReview = <any> 'in_review',
        Contacted = <any> 'contacted',
        PendingApproval = <any> 'pending_approval',
        Approved = <any> 'approved',
        Rejected = <any> 'rejected'
    }
}
/**
 * 
 * @export
 * @interface WorkerRequestAdminReadOneDtoCreatedBy
 */
export interface WorkerRequestAdminReadOneDtoCreatedBy {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDtoCreatedBy
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDtoCreatedBy
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDtoCreatedBy
     */
    firstName?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminReadOneDtoCreatedBy
     */
    lastName?: string;
}
/**
 * 
 * @export
 * @interface WorkerRequestAdminUpdateDto
 */
export interface WorkerRequestAdminUpdateDto {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    companyName?: string;
    /**
     * 
     * @type {Array<WorkerRequestPositionDto>}
     * @memberof WorkerRequestAdminUpdateDto
     */
    positions?: Array<WorkerRequestPositionDto>;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    duration?: WorkerRequestAdminUpdateDto.DurationEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    country?: WorkerRequestAdminUpdateDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    managerEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    managerPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    salaryRange?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    currency?: WorkerRequestAdminUpdateDto.CurrencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestAdminUpdateDto
     */
    ensuredTransport?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestAdminUpdateDto
     */
    ensuredAccommodation?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestAdminUpdateDto
     */
    status?: WorkerRequestAdminUpdateDto.StatusEnum;
    /**
     * 
     * @type {Array<AdminCreateNoteDto>}
     * @memberof WorkerRequestAdminUpdateDto
     */
    adminNotes?: Array<AdminCreateNoteDto>;
}

/**
 * @export
 * @namespace WorkerRequestAdminUpdateDto
 */
export namespace WorkerRequestAdminUpdateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DurationEnum {
        Less90 = <any> 'less_90',
        Less180 = <any> 'less_180',
        More180 = <any> 'more_180'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Submitted = <any> 'submitted',
        InReview = <any> 'in_review',
        Contacted = <any> 'contacted',
        PendingApproval = <any> 'pending_approval',
        Approved = <any> 'approved',
        Rejected = <any> 'rejected'
    }
}
/**
 * 
 * @export
 * @interface WorkerRequestCreateDto
 */
export interface WorkerRequestCreateDto {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    companyName: string;
    /**
     * 
     * @type {Array<WorkerRequestPositionDto>}
     * @memberof WorkerRequestCreateDto
     */
    positions: Array<WorkerRequestPositionDto>;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    duration: WorkerRequestCreateDto.DurationEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    country: WorkerRequestCreateDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    managerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    managerPhone?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    salaryRange?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    currency?: WorkerRequestCreateDto.CurrencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestCreateDto
     */
    ensuredTransport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestCreateDto
     */
    ensuredAccommodation: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestCreateDto
     */
    requestNumber?: string;
}

/**
 * @export
 * @namespace WorkerRequestCreateDto
 */
export namespace WorkerRequestCreateDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DurationEnum {
        Less90 = <any> 'less_90',
        Less180 = <any> 'less_180',
        More180 = <any> 'more_180'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
}
/**
 * 
 * @export
 * @interface WorkerRequestManagerReadManyResponseDto
 */
export interface WorkerRequestManagerReadManyResponseDto {
    /**
     * 
     * @type {Array<Array>}
     * @memberof WorkerRequestManagerReadManyResponseDto
     */
    data: Array<Array>;
    /**
     * 
     * @type {BasePaginatedResponseMeta}
     * @memberof WorkerRequestManagerReadManyResponseDto
     */
    meta: BasePaginatedResponseMeta;
    /**
     * 
     * @type {BasePaginatedResponseLinks}
     * @memberof WorkerRequestManagerReadManyResponseDto
     */
    links: BasePaginatedResponseLinks;
}
/**
 * 
 * @export
 * @interface WorkerRequestManagerReadOneDto
 */
export interface WorkerRequestManagerReadOneDto {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    companyName: string;
    /**
     * 
     * @type {Array<WorkerRequestPosition>}
     * @memberof WorkerRequestManagerReadOneDto
     */
    positions: Array<WorkerRequestPosition>;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    requestNumber: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    duration: WorkerRequestManagerReadOneDto.DurationEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    country: WorkerRequestManagerReadOneDto.CountryEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    managerEmail: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    managerPhone: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    salaryRange: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    currency: WorkerRequestManagerReadOneDto.CurrencyEnum;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestManagerReadOneDto
     */
    ensuredTransport: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkerRequestManagerReadOneDto
     */
    ensuredAccommodation: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestManagerReadOneDto
     */
    status: WorkerRequestManagerReadOneDto.StatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof WorkerRequestManagerReadOneDto
     */
    createdAt: Date;
}

/**
 * @export
 * @namespace WorkerRequestManagerReadOneDto
 */
export namespace WorkerRequestManagerReadOneDto {
    /**
     * @export
     * @enum {string}
     */
    export enum DurationEnum {
        Less90 = <any> 'less_90',
        Less180 = <any> 'less_180',
        More180 = <any> 'more_180'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CountryEnum {
        Austria = <any> 'austria',
        Belgium = <any> 'belgium',
        Bulgaria = <any> 'bulgaria',
        Croatia = <any> 'croatia',
        Cyprus = <any> 'cyprus',
        CzechRepublic = <any> 'czech_republic',
        Denmark = <any> 'denmark',
        Estonia = <any> 'estonia',
        Finland = <any> 'finland',
        France = <any> 'france',
        Greece = <any> 'greece',
        Germany = <any> 'germany',
        Hungary = <any> 'hungary',
        Ireland = <any> 'ireland',
        Italy = <any> 'italy',
        Lithuania = <any> 'lithuania',
        Luxembourg = <any> 'luxembourg',
        Latvia = <any> 'latvia',
        Malta = <any> 'malta',
        Netherlands = <any> 'netherlands',
        Norway = <any> 'norway',
        Poland = <any> 'poland',
        Portugal = <any> 'portugal',
        Romania = <any> 'romania',
        Slovakia = <any> 'slovakia',
        Slovenia = <any> 'slovenia',
        Spain = <any> 'spain',
        Sweden = <any> 'sweden',
        Switzerland = <any> 'switzerland',
        UnitedKingdom = <any> 'united_kingdom',
        UnitedStates = <any> 'united_states',
        OutsideEu = <any> 'outside_eu'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum CurrencyEnum {
        USD = <any> 'USD',
        GBP = <any> 'GBP',
        EUR = <any> 'EUR',
        PLN = <any> 'PLN',
        SEK = <any> 'SEK',
        CHF = <any> 'CHF',
        NOK = <any> 'NOK',
        DKK = <any> 'DKK',
        CZK = <any> 'CZK'
    }
    /**
     * @export
     * @enum {string}
     */
    export enum StatusEnum {
        Submitted = <any> 'submitted',
        InReview = <any> 'in_review',
        Contacted = <any> 'contacted',
        PendingApproval = <any> 'pending_approval',
        Approved = <any> 'approved',
        Rejected = <any> 'rejected'
    }
}
/**
 * 
 * @export
 * @interface WorkerRequestPosition
 */
export interface WorkerRequestPosition {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestPosition
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestPosition
     */
    positionName?: WorkerRequestPosition.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestPosition
     */
    positionOther?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkerRequestPosition
     */
    employeesCount: number;
}

/**
 * @export
 * @namespace WorkerRequestPosition
 */
export namespace WorkerRequestPosition {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
}
/**
 * 
 * @export
 * @interface WorkerRequestPositionDto
 */
export interface WorkerRequestPositionDto {
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestPositionDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestPositionDto
     */
    positionName?: WorkerRequestPositionDto.PositionNameEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkerRequestPositionDto
     */
    positionOther?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkerRequestPositionDto
     */
    employeesCount: number;
}

/**
 * @export
 * @namespace WorkerRequestPositionDto
 */
export namespace WorkerRequestPositionDto {
    /**
     * @export
     * @enum {string}
     */
    export enum PositionNameEnum {
        SteelFixer = <any> 'steel_fixer',
        FormworkCarpenter = <any> 'formwork_carpenter',
        ConcreteWorker = <any> 'concrete_worker',
        PrefabricatedStructureAssembler = <any> 'prefabricated_structure_assembler',
        Plumber = <any> 'plumber',
        Electrician = <any> 'electrician',
        VentilationFitter = <any> 'ventilation_fitter',
        Plasterer = <any> 'plasterer',
        DrywallInstaller = <any> 'drywall_installer',
        SuspendedCeilingInstaller = <any> 'suspended_ceiling_installer',
        Painter = <any> 'painter',
        WallpaperHanger = <any> 'wallpaper_hanger',
        TileSetter = <any> 'tile_setter',
        Bricklayer = <any> 'bricklayer',
        Paver = <any> 'paver',
        RoadSurfaceLayer = <any> 'road_surface_layer',
        VentilatedFacadeInstaller = <any> 'ventilated_facade_installer',
        Welder = <any> 'welder',
        SteelStructureAssembler = <any> 'steel_structure_assembler',
        MetalWorker = <any> 'metal_worker',
        RoofInsulationInstaller = <any> 'roof_insulation_installer',
        IndustrialInsulationFitter = <any> 'industrial_insulation_fitter',
        CorrugatedSheetMetalInstaller = <any> 'corrugated_sheet_metal_installer',
        Roofer = <any> 'roofer',
        ConcreteFlooringContractor = <any> 'concrete_flooring_contractor',
        ScaffoldingErector = <any> 'scaffolding_erector',
        GeneralConstructionWorker = <any> 'general_construction_worker',
        RollerOperator = <any> 'roller_operator',
        BulldozerOperator = <any> 'bulldozer_operator',
        GraderOperator = <any> 'grader_operator',
        BackhoeLoaderOperator = <any> 'backhoe_loader_operator',
        LoaderOperator = <any> 'loader_operator',
        ExcavatorOperator = <any> 'excavator_operator',
        ConstructionCraneOperator = <any> 'construction_crane_operator',
        CraneOperator = <any> 'crane_operator',
        MobileElevatedWorkPlatformOperator = <any> 'mobile_elevated_work_platform_operator',
        ForkliftOperator = <any> 'forklift_operator',
        DrillingAndHammeringEquipmentOperator = <any> 'drilling_and_hammering_equipment_operator',
        DrillingRigOperator = <any> 'drilling_rig_operator',
        PileDriverOperator = <any> 'pile_driver_operator',
        OperatorOfOtherMachines = <any> 'operator_of_other_machines',
        CivilEngineer = <any> 'civil_engineer',
        Surveyor = <any> 'surveyor',
        HealthAndSafetyTechnician = <any> 'health_and_safety_technician',
        ConstructionCoordinator = <any> 'construction_coordinator',
        CostEstimator = <any> 'cost_estimator',
        TowerCraneOperator = <any> 'tower_crane_operator',
        ThermalInsulationSpecialist = <any> 'thermal_insulation_specialist',
        BuildingAcousticsSpecialist = <any> 'building_acoustics_specialist',
        HeatingAndAcSystemsSpecialist = <any> 'heating_and_ac_systems_specialist',
        MigWelder = <any> 'mig_welder',
        MagWelder = <any> 'mag_welder',
        TigWelder = <any> 'tig_welder',
        PhysicalWork = <any> 'physical_work',
        Other = <any> 'other'
    }
}
/**
 * AdminApplyManagementApi - fetch parameter creator
 * @export
 */
export const AdminApplyManagementApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveApply(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminRemoveApply.');
            }
            const localVarPath = `/api/admin/applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByJob(jobId: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId','Required parameter jobId was null or undefined when calling findAllByJob.');
            }
            const localVarPath = `/api/admin/applies/job/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterName) {
                localVarQueryParameter['filter.name'] = filterName;
            }

            if (filterEmail) {
                localVarQueryParameter['filter.email'] = filterEmail;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrlAdmin(applyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'applyId' is not null or undefined
            if (applyId === null || applyId === undefined) {
                throw new RequiredError('applyId','Required parameter applyId was null or undefined when calling getSignedCvUrlAdmin.');
            }
            const localVarPath = `/api/admin/applies/{applyId}/cv`
                .replace(`{${"applyId"}}`, encodeURIComponent(String(applyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateApplyAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApply(body: UpdateApplyAdminDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateApply.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateApply.');
            }
            const localVarPath = `/api/admin/applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateApplyAdminDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApplyManagementApi - functional programming interface
 * @export
 */
export const AdminApplyManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveApply(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminApplyManagementApiFetchParamCreator(configuration).adminRemoveApply(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByJob(jobId: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2003> {
            const localVarFetchArgs = AdminApplyManagementApiFetchParamCreator(configuration).findAllByJob(jobId, page, limit, filterName, filterEmail, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrlAdmin(applyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminApplyManagementApiFetchParamCreator(configuration).getSignedCvUrlAdmin(applyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {UpdateApplyAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApply(body: UpdateApplyAdminDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminApplyManagementApiFetchParamCreator(configuration).updateApply(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminApplyManagementApi - factory interface
 * @export
 */
export const AdminApplyManagementApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveApply(id: string, options?: any) {
            return AdminApplyManagementApiFp(configuration).adminRemoveApply(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllByJob(jobId: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return AdminApplyManagementApiFp(configuration).findAllByJob(jobId, page, limit, filterName, filterEmail, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrlAdmin(applyId: string, options?: any) {
            return AdminApplyManagementApiFp(configuration).getSignedCvUrlAdmin(applyId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {UpdateApplyAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateApply(body: UpdateApplyAdminDto, id: string, options?: any) {
            return AdminApplyManagementApiFp(configuration).updateApply(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AdminApplyManagementApi - object-oriented interface
 * @export
 * @class AdminApplyManagementApi
 * @extends {BaseAPI}
 */
export class AdminApplyManagementApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApplyManagementApi
     */
    public adminRemoveApply(id: string, options?: any) {
        return AdminApplyManagementApiFp(this.configuration).adminRemoveApply(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} jobId 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApplyManagementApi
     */
    public findAllByJob(jobId: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return AdminApplyManagementApiFp(this.configuration).findAllByJob(jobId, page, limit, filterName, filterEmail, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} applyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApplyManagementApi
     */
    public getSignedCvUrlAdmin(applyId: string, options?: any) {
        return AdminApplyManagementApiFp(this.configuration).getSignedCvUrlAdmin(applyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {UpdateApplyAdminDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApplyManagementApi
     */
    public updateApply(body: UpdateApplyAdminDto, id: string, options?: any) {
        return AdminApplyManagementApiFp(this.configuration).updateApply(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdminJobsManagementApi - fetch parameter creator
 * @export
 */
export const AdminJobsManagementApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {JobsAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobByAdmin(body: JobsAdminCreateDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createJobByAdmin.');
            }
            const localVarPath = `/api/admin/jobs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JobsAdminCreateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobByAdmin(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteJobByAdmin.');
            }
            const localVarPath = `/api/admin/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCreatedAt] Filter by createdAt query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.createdAt&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.createdAt&#x3D;$not:$like:John Doe&amp;filter.createdAt&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$gte&lt;/li&gt; &lt;li&gt;$lte&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllJobsAdmin(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterCreatedAt?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/jobs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (filterPositionNames) {
                localVarQueryParameter['filter.positionNames'] = filterPositionNames;
            }

            if (filterCreatedAt) {
                localVarQueryParameter['filter.createdAt'] = filterCreatedAt;
            }

            if (filterActive) {
                localVarQueryParameter['filter.active'] = filterActive;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneJobByAdmin(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findOneJobByAdmin.');
            }
            const localVarPath = `/api/admin/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobsAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobByAdmin(body: JobsAdminUpdateDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateJobByAdmin.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateJobByAdmin.');
            }
            const localVarPath = `/api/admin/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JobsAdminUpdateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminJobsManagementApi - functional programming interface
 * @export
 */
export const AdminJobsManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {JobsAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobByAdmin(body: JobsAdminCreateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Job> {
            const localVarFetchArgs = AdminJobsManagementApiFetchParamCreator(configuration).createJobByAdmin(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobByAdmin(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AdminJobsManagementApiFetchParamCreator(configuration).deleteJobByAdmin(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCreatedAt] Filter by createdAt query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.createdAt&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.createdAt&#x3D;$not:$like:John Doe&amp;filter.createdAt&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$gte&lt;/li&gt; &lt;li&gt;$lte&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllJobsAdmin(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterCreatedAt?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2008> {
            const localVarFetchArgs = AdminJobsManagementApiFetchParamCreator(configuration).findAllJobsAdmin(page, limit, filterCountry, filterPositionNames, filterCreatedAt, filterActive, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneJobByAdmin(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JobAdminReadOneDto> {
            const localVarFetchArgs = AdminJobsManagementApiFetchParamCreator(configuration).findOneJobByAdmin(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {JobsAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobByAdmin(body: JobsAdminUpdateDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Job> {
            const localVarFetchArgs = AdminJobsManagementApiFetchParamCreator(configuration).updateJobByAdmin(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminJobsManagementApi - factory interface
 * @export
 */
export const AdminJobsManagementApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {JobsAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobByAdmin(body: JobsAdminCreateDto, options?: any) {
            return AdminJobsManagementApiFp(configuration).createJobByAdmin(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobByAdmin(id: string, options?: any) {
            return AdminJobsManagementApiFp(configuration).deleteJobByAdmin(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCreatedAt] Filter by createdAt query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.createdAt&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.createdAt&#x3D;$not:$like:John Doe&amp;filter.createdAt&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$gte&lt;/li&gt; &lt;li&gt;$lte&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllJobsAdmin(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterCreatedAt?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return AdminJobsManagementApiFp(configuration).findAllJobsAdmin(page, limit, filterCountry, filterPositionNames, filterCreatedAt, filterActive, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneJobByAdmin(id: string, options?: any) {
            return AdminJobsManagementApiFp(configuration).findOneJobByAdmin(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {JobsAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobByAdmin(body: JobsAdminUpdateDto, id: string, options?: any) {
            return AdminJobsManagementApiFp(configuration).updateJobByAdmin(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * AdminJobsManagementApi - object-oriented interface
 * @export
 * @class AdminJobsManagementApi
 * @extends {BaseAPI}
 */
export class AdminJobsManagementApi extends BaseAPI {
    /**
     * 
     * @param {JobsAdminCreateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminJobsManagementApi
     */
    public createJobByAdmin(body: JobsAdminCreateDto, options?: any) {
        return AdminJobsManagementApiFp(this.configuration).createJobByAdmin(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminJobsManagementApi
     */
    public deleteJobByAdmin(id: string, options?: any) {
        return AdminJobsManagementApiFp(this.configuration).deleteJobByAdmin(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterCreatedAt] Filter by createdAt query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.createdAt&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.createdAt&#x3D;$not:$like:John Doe&amp;filter.createdAt&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$gte&lt;/li&gt; &lt;li&gt;$lte&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminJobsManagementApi
     */
    public findAllJobsAdmin(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterCreatedAt?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return AdminJobsManagementApiFp(this.configuration).findAllJobsAdmin(page, limit, filterCountry, filterPositionNames, filterCreatedAt, filterActive, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminJobsManagementApi
     */
    public findOneJobByAdmin(id: string, options?: any) {
        return AdminJobsManagementApiFp(this.configuration).findOneJobByAdmin(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {JobsAdminUpdateDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminJobsManagementApi
     */
    public updateJobByAdmin(body: JobsAdminUpdateDto, id: string, options?: any) {
        return AdminJobsManagementApiFp(this.configuration).updateJobByAdmin(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * AdminQueryLlmApi - fetch parameter creator
 * @export
 */
export const AdminQueryLlmApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LlmRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        llmAdminControllerCallLlm(body: LlmRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling llmAdminControllerCallLlm.');
            }
            const localVarPath = `/api/admin/llm`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"LlmRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminQueryLlmApi - functional programming interface
 * @export
 */
export const AdminQueryLlmApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {LlmRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        llmAdminControllerCallLlm(body: LlmRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = AdminQueryLlmApiFetchParamCreator(configuration).llmAdminControllerCallLlm(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AdminQueryLlmApi - factory interface
 * @export
 */
export const AdminQueryLlmApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {LlmRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        llmAdminControllerCallLlm(body: LlmRequestDto, options?: any) {
            return AdminQueryLlmApiFp(configuration).llmAdminControllerCallLlm(body, options)(fetch, basePath);
        },
    };
};

/**
 * AdminQueryLlmApi - object-oriented interface
 * @export
 * @class AdminQueryLlmApi
 * @extends {BaseAPI}
 */
export class AdminQueryLlmApi extends BaseAPI {
    /**
     * 
     * @param {LlmRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminQueryLlmApi
     */
    public llmAdminControllerCallLlm(body: LlmRequestDto, options?: any) {
        return AdminQueryLlmApiFp(this.configuration).llmAdminControllerCallLlm(body, options)(this.fetch, this.basePath);
    }

}
/**
 * ApplyApi - fetch parameter creator
 * @export
 */
export const ApplyApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Blob} file 
         * @param {string} message 
         * @param {string} email 
         * @param {string} phone 
         * @param {string} jobSlug 
         * @param {string} name 
         * @param {boolean} commercialConsent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesPublicControllerCreate(file: Blob, message: string, email: string, phone: string, jobSlug: string, name: string, commercialConsent: boolean, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling appliesPublicControllerCreate.');
            }
            // verify required parameter 'message' is not null or undefined
            if (message === null || message === undefined) {
                throw new RequiredError('message','Required parameter message was null or undefined when calling appliesPublicControllerCreate.');
            }
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling appliesPublicControllerCreate.');
            }
            // verify required parameter 'phone' is not null or undefined
            if (phone === null || phone === undefined) {
                throw new RequiredError('phone','Required parameter phone was null or undefined when calling appliesPublicControllerCreate.');
            }
            // verify required parameter 'jobSlug' is not null or undefined
            if (jobSlug === null || jobSlug === undefined) {
                throw new RequiredError('jobSlug','Required parameter jobSlug was null or undefined when calling appliesPublicControllerCreate.');
            }
            // verify required parameter 'name' is not null or undefined
            if (name === null || name === undefined) {
                throw new RequiredError('name','Required parameter name was null or undefined when calling appliesPublicControllerCreate.');
            }
            // verify required parameter 'commercialConsent' is not null or undefined
            if (commercialConsent === null || commercialConsent === undefined) {
                throw new RequiredError('commercialConsent','Required parameter commercialConsent was null or undefined when calling appliesPublicControllerCreate.');
            }
            const localVarPath = `/api/apply-for-job`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            if (message !== undefined) {
                localVarFormParams.set('message', message as any);
            }

            if (email !== undefined) {
                localVarFormParams.set('email', email as any);
            }

            if (phone !== undefined) {
                localVarFormParams.set('phone', phone as any);
            }

            if (jobSlug !== undefined) {
                localVarFormParams.set('jobSlug', jobSlug as any);
            }

            if (name !== undefined) {
                localVarFormParams.set('name', name as any);
            }

            if (commercialConsent !== undefined) {
                localVarFormParams.set('commercialConsent', commercialConsent as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplyApi - functional programming interface
 * @export
 */
export const ApplyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {Blob} file 
         * @param {string} message 
         * @param {string} email 
         * @param {string} phone 
         * @param {string} jobSlug 
         * @param {string} name 
         * @param {boolean} commercialConsent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesPublicControllerCreate(file: Blob, message: string, email: string, phone: string, jobSlug: string, name: string, commercialConsent: boolean, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ApplyApiFetchParamCreator(configuration).appliesPublicControllerCreate(file, message, email, phone, jobSlug, name, commercialConsent, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ApplyApi - factory interface
 * @export
 */
export const ApplyApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {Blob} file 
         * @param {string} message 
         * @param {string} email 
         * @param {string} phone 
         * @param {string} jobSlug 
         * @param {string} name 
         * @param {boolean} commercialConsent 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesPublicControllerCreate(file: Blob, message: string, email: string, phone: string, jobSlug: string, name: string, commercialConsent: boolean, options?: any) {
            return ApplyApiFp(configuration).appliesPublicControllerCreate(file, message, email, phone, jobSlug, name, commercialConsent, options)(fetch, basePath);
        },
    };
};

/**
 * ApplyApi - object-oriented interface
 * @export
 * @class ApplyApi
 * @extends {BaseAPI}
 */
export class ApplyApi extends BaseAPI {
    /**
     * 
     * @param {Blob} file 
     * @param {string} message 
     * @param {string} email 
     * @param {string} phone 
     * @param {string} jobSlug 
     * @param {string} name 
     * @param {boolean} commercialConsent 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyApi
     */
    public appliesPublicControllerCreate(file: Blob, message: string, email: string, phone: string, jobSlug: string, name: string, commercialConsent: boolean, options?: any) {
        return ApplyApiFp(this.configuration).appliesPublicControllerCreate(file, message, email, phone, jobSlug, name, commercialConsent, options)(this.fetch, this.basePath);
    }

}
/**
 * ApplyModuleForUserApi - fetch parameter creator
 * @export
 */
export const ApplyModuleForUserApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplyForJobUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesUserControllerApplyForJobUser(body: ApplyForJobUserDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling appliesUserControllerApplyForJobUser.');
            }
            const localVarPath = `/api/user/applies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ApplyForJobUserDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.country,job.city,job.positionNames,job.company.name           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesUserControllerFindByUserId(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/user/applies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterJobCountry) {
                localVarQueryParameter['filter.job.country'] = filterJobCountry;
            }

            if (filterJobPositionNames) {
                localVarQueryParameter['filter.job.positionNames'] = filterJobPositionNames;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelApply(applyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'applyId' is not null or undefined
            if (applyId === null || applyId === undefined) {
                throw new RequiredError('applyId','Required parameter applyId was null or undefined when calling cancelApply.');
            }
            const localVarPath = `/api/user/applies/{applyId}`
                .replace(`{${"applyId"}}`, encodeURIComponent(String(applyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApplyModuleForUserApi - functional programming interface
 * @export
 */
export const ApplyModuleForUserApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {ApplyForJobUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesUserControllerApplyForJobUser(body: ApplyForJobUserDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Apply> {
            const localVarFetchArgs = ApplyModuleForUserApiFetchParamCreator(configuration).appliesUserControllerApplyForJobUser(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.country,job.city,job.positionNames,job.company.name           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesUserControllerFindByUserId(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2004> {
            const localVarFetchArgs = ApplyModuleForUserApiFetchParamCreator(configuration).appliesUserControllerFindByUserId(page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelApply(applyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ApplyModuleForUserApiFetchParamCreator(configuration).cancelApply(applyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ApplyModuleForUserApi - factory interface
 * @export
 */
export const ApplyModuleForUserApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {ApplyForJobUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesUserControllerApplyForJobUser(body: ApplyForJobUserDto, options?: any) {
            return ApplyModuleForUserApiFp(configuration).appliesUserControllerApplyForJobUser(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.country,job.city,job.positionNames,job.company.name           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appliesUserControllerFindByUserId(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return ApplyModuleForUserApiFp(configuration).appliesUserControllerFindByUserId(page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelApply(applyId: string, options?: any) {
            return ApplyModuleForUserApiFp(configuration).cancelApply(applyId, options)(fetch, basePath);
        },
    };
};

/**
 * ApplyModuleForUserApi - object-oriented interface
 * @export
 * @class ApplyModuleForUserApi
 * @extends {BaseAPI}
 */
export class ApplyModuleForUserApi extends BaseAPI {
    /**
     * 
     * @param {ApplyForJobUserDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyModuleForUserApi
     */
    public appliesUserControllerApplyForJobUser(body: ApplyForJobUserDto, options?: any) {
        return ApplyModuleForUserApiFp(this.configuration).appliesUserControllerApplyForJobUser(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.country,job.city,job.positionNames,job.company.name           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyModuleForUserApi
     */
    public appliesUserControllerFindByUserId(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return ApplyModuleForUserApiFp(this.configuration).appliesUserControllerFindByUserId(page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} applyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ApplyModuleForUserApi
     */
    public cancelApply(applyId: string, options?: any) {
        return ApplyModuleForUserApiFp(this.configuration).cancelApply(applyId, options)(this.fetch, this.basePath);
    }

}
/**
 * AuthenticationAndRegistrationApi - fetch parameter creator
 * @export
 */
export const AuthenticationAndRegistrationApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {VerifyRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmUser(body: VerifyRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerConfirmUser.');
            }
            const localVarPath = `/api/auth/verify`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"VerifyRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ForgotPasswordRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerForgotPassword(body: ForgotPasswordRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerForgotPassword.');
            }
            const localVarPath = `/api/auth/forgot-password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ForgotPasswordRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {LinkUserWith3rdProviderRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLinkProvider(body: LinkUserWith3rdProviderRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerLinkProvider.');
            }
            const localVarPath = `/api/auth/link-provider`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"LinkUserWith3rdProviderRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {NewPasswordRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerNewPassword(body: NewPasswordRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerNewPassword.');
            }
            const localVarPath = `/api/auth/new-password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"NewPasswordRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RefreshTokenRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefreshToken(body: RefreshTokenRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerRefreshToken.');
            }
            const localVarPath = `/api/auth/refresh-token`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RefreshTokenRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ResendRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResendConfirmationCode(body: ResendRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerResendConfirmationCode.');
            }
            const localVarPath = `/api/auth/resend`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ResendRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {RespondChallengeRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRespondToNewPassword(body: RespondChallengeRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerRespondToNewPassword.');
            }
            const localVarPath = `/api/auth/respond-challenge`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"RespondChallengeRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignInRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn(body: SignInRequestDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerSignIn.');
            }
            const localVarPath = `/api/auth/signin`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SignInRequestDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignupDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUp(body: SignupDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerSignUp.');
            }
            const localVarPath = `/api/auth/signup`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SignupDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {SignupFromProviderDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpFromProvider(body: SignupFromProviderDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling authControllerSignUpFromProvider.');
            }
            const localVarPath = `/api/auth/signup-provider`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"SignupFromProviderDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthenticationAndRegistrationApi - functional programming interface
 * @export
 */
export const AuthenticationAndRegistrationApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {VerifyRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmUser(body: VerifyRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerConfirmUser(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ForgotPasswordRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerForgotPassword(body: ForgotPasswordRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerForgotPassword(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {LinkUserWith3rdProviderRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLinkProvider(body: LinkUserWith3rdProviderRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerLinkProvider(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {NewPasswordRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerNewPassword(body: NewPasswordRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerNewPassword(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RefreshTokenRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefreshToken(body: RefreshTokenRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<RefreshTokenResponseDto> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerRefreshToken(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ResendRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResendConfirmationCode(body: ResendRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerResendConfirmationCode(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {RespondChallengeRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRespondToNewPassword(body: RespondChallengeRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerRespondToNewPassword(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SignInRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn(body: SignInRequestDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<SignInResponseDto> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerSignIn(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SignupDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUp(body: SignupDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerSignUp(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {SignupFromProviderDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpFromProvider(body: SignupFromProviderDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = AuthenticationAndRegistrationApiFetchParamCreator(configuration).authControllerSignUpFromProvider(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * AuthenticationAndRegistrationApi - factory interface
 * @export
 */
export const AuthenticationAndRegistrationApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {VerifyRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerConfirmUser(body: VerifyRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerConfirmUser(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ForgotPasswordRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerForgotPassword(body: ForgotPasswordRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerForgotPassword(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {LinkUserWith3rdProviderRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLinkProvider(body: LinkUserWith3rdProviderRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerLinkProvider(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {NewPasswordRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerNewPassword(body: NewPasswordRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerNewPassword(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {RefreshTokenRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRefreshToken(body: RefreshTokenRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerRefreshToken(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ResendRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerResendConfirmationCode(body: ResendRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerResendConfirmationCode(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {RespondChallengeRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerRespondToNewPassword(body: RespondChallengeRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerRespondToNewPassword(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SignInRequestDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignIn(body: SignInRequestDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerSignIn(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SignupDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUp(body: SignupDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerSignUp(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {SignupFromProviderDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerSignUpFromProvider(body: SignupFromProviderDto, options?: any) {
            return AuthenticationAndRegistrationApiFp(configuration).authControllerSignUpFromProvider(body, options)(fetch, basePath);
        },
    };
};

/**
 * AuthenticationAndRegistrationApi - object-oriented interface
 * @export
 * @class AuthenticationAndRegistrationApi
 * @extends {BaseAPI}
 */
export class AuthenticationAndRegistrationApi extends BaseAPI {
    /**
     * 
     * @param {VerifyRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerConfirmUser(body: VerifyRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerConfirmUser(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ForgotPasswordRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerForgotPassword(body: ForgotPasswordRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerForgotPassword(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {LinkUserWith3rdProviderRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerLinkProvider(body: LinkUserWith3rdProviderRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerLinkProvider(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {NewPasswordRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerNewPassword(body: NewPasswordRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerNewPassword(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RefreshTokenRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerRefreshToken(body: RefreshTokenRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerRefreshToken(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ResendRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerResendConfirmationCode(body: ResendRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerResendConfirmationCode(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {RespondChallengeRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerRespondToNewPassword(body: RespondChallengeRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerRespondToNewPassword(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SignInRequestDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerSignIn(body: SignInRequestDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerSignIn(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SignupDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerSignUp(body: SignupDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerSignUp(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {SignupFromProviderDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationAndRegistrationApi
     */
    public authControllerSignUpFromProvider(body: SignupFromProviderDto, options?: any) {
        return AuthenticationAndRegistrationApiFp(this.configuration).authControllerSignUpFromProvider(body, options)(this.fetch, this.basePath);
    }

}
/**
 * CompaniesApi - fetch parameter creator
 * @export
 */
export const CompaniesApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCompaniesPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (filterCompanyVerified) {
                localVarQueryParameter['filter.companyVerified'] = filterCompanyVerified;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCompanyBySlugPublic(slug: string, options: any = {}): FetchArgs {
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling findCompanyBySlugPublic.');
            }
            const localVarPath = `/api/companies/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesApi - functional programming interface
 * @export
 */
export const CompaniesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCompaniesPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2001> {
            const localVarFetchArgs = CompaniesApiFetchParamCreator(configuration).findAllCompaniesPublic(page, limit, filterCountry, filterCompanyVerified, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCompanyBySlugPublic(slug: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyPublicReadOneDto> {
            const localVarFetchArgs = CompaniesApiFetchParamCreator(configuration).findCompanyBySlugPublic(slug, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CompaniesApi - factory interface
 * @export
 */
export const CompaniesApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllCompaniesPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return CompaniesApiFp(configuration).findAllCompaniesPublic(page, limit, filterCountry, filterCompanyVerified, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCompanyBySlugPublic(slug: string, options?: any) {
            return CompaniesApiFp(configuration).findCompanyBySlugPublic(slug, options)(fetch, basePath);
        },
    };
};

/**
 * CompaniesApi - object-oriented interface
 * @export
 * @class CompaniesApi
 * @extends {BaseAPI}
 */
export class CompaniesApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public findAllCompaniesPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return CompaniesApiFp(this.configuration).findAllCompaniesPublic(page, limit, filterCountry, filterCompanyVerified, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesApi
     */
    public findCompanyBySlugPublic(slug: string, options?: any) {
        return CompaniesApiFp(this.configuration).findCompanyBySlugPublic(slug, options)(this.fetch, this.basePath);
    }

}
/**
 * CompaniesAdminModuleApi - fetch parameter creator
 * @export
 */
export const CompaniesAdminModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CompanyAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCompany(body: CompanyAdminCreateDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adminCreateCompany.');
            }
            const localVarPath = `/api/admin/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyAdminCreateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCompany(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminDeleteCompany.');
            }
            const localVarPath = `/api/admin/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterTin] Filter by tin query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.tin&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.tin&#x3D;$not:$like:John Doe&amp;filter.tin&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country,email,manager.email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;manager.email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllCompanies(page?: number, limit?: number, filterName?: Array<string>, filterCountry?: Array<string>, filterTin?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterName) {
                localVarQueryParameter['filter.name'] = filterName;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (filterTin) {
                localVarQueryParameter['filter.tin'] = filterTin;
            }

            if (filterCompanyVerified) {
                localVarQueryParameter['filter.companyVerified'] = filterCompanyVerified;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneCompany(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminFindOneCompany.');
            }
            const localVarPath = `/api/admin/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneCompanyByManagerId(managerId: string, options: any = {}): FetchArgs {
            // verify required parameter 'managerId' is not null or undefined
            if (managerId === null || managerId === undefined) {
                throw new RequiredError('managerId','Required parameter managerId was null or undefined when calling adminFindOneCompanyByManagerId.');
            }
            const localVarPath = `/api/admin/companies/manager/{managerId}`
                .replace(`{${"managerId"}}`, encodeURIComponent(String(managerId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveCompanyLogo(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminRemoveCompanyLogo.');
            }
            const localVarPath = `/api/admin/companies/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {AdminCompanyGalleryRemoveDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveGalleryImage(body: AdminCompanyGalleryRemoveDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adminRemoveGalleryImage.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminRemoveGalleryImage.');
            }
            const localVarPath = `/api/admin/companies/{id}/gallery`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AdminCompanyGalleryRemoveDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCompany(body: CompanyAdminUpdateDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adminUpdateCompany.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminUpdateCompany.');
            }
            const localVarPath = `/api/admin/companies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyAdminUpdateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadCompanyLogo(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminUploadCompanyLogo.');
            }
            const localVarPath = `/api/admin/companies/{id}/logo`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Blob} file 
         * @param {string} title 
         * @param {string} description 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadGalleryImage(file: Blob, title: string, description: string, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling adminUploadGalleryImage.');
            }
            // verify required parameter 'title' is not null or undefined
            if (title === null || title === undefined) {
                throw new RequiredError('title','Required parameter title was null or undefined when calling adminUploadGalleryImage.');
            }
            // verify required parameter 'description' is not null or undefined
            if (description === null || description === undefined) {
                throw new RequiredError('description','Required parameter description was null or undefined when calling adminUploadGalleryImage.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminUploadGalleryImage.');
            }
            const localVarPath = `/api/admin/companies/{id}/gallery`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            if (title !== undefined) {
                localVarFormParams.set('title', title as any);
            }

            if (description !== undefined) {
                localVarFormParams.set('description', description as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesAdminModuleApi - functional programming interface
 * @export
 */
export const CompaniesAdminModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CompanyAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCompany(body: CompanyAdminCreateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAdminReadOneDto> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminCreateCompany(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCompany(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminDeleteCompany(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterTin] Filter by tin query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.tin&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.tin&#x3D;$not:$like:John Doe&amp;filter.tin&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country,email,manager.email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;manager.email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllCompanies(page?: number, limit?: number, filterName?: Array<string>, filterCountry?: Array<string>, filterTin?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2002> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminFindAllCompanies(page, limit, filterName, filterCountry, filterTin, filterCompanyVerified, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneCompany(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAdminReadOneDto> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminFindOneCompany(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneCompanyByManagerId(managerId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAdminReadOneDto> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminFindOneCompanyByManagerId(managerId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveCompanyLogo(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminRemoveCompanyLogo(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {AdminCompanyGalleryRemoveDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveGalleryImage(body: AdminCompanyGalleryRemoveDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminRemoveGalleryImage(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CompanyAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCompany(body: CompanyAdminUpdateDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<CompanyAdminReadOneDto> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminUpdateCompany(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadCompanyLogo(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminUploadCompanyLogo(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Blob} file 
         * @param {string} title 
         * @param {string} description 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadGalleryImage(file: Blob, title: string, description: string, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesAdminModuleApiFetchParamCreator(configuration).adminUploadGalleryImage(file, title, description, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CompaniesAdminModuleApi - factory interface
 * @export
 */
export const CompaniesAdminModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CompanyAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateCompany(body: CompanyAdminCreateDto, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminCreateCompany(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminDeleteCompany(id: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminDeleteCompany(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterTin] Filter by tin query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.tin&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.tin&#x3D;$not:$like:John Doe&amp;filter.tin&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country,email,manager.email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;manager.email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllCompanies(page?: number, limit?: number, filterName?: Array<string>, filterCountry?: Array<string>, filterTin?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminFindAllCompanies(page, limit, filterName, filterCountry, filterTin, filterCompanyVerified, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneCompany(id: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminFindOneCompany(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} managerId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneCompanyByManagerId(managerId: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminFindOneCompanyByManagerId(managerId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveCompanyLogo(id: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminRemoveCompanyLogo(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {AdminCompanyGalleryRemoveDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveGalleryImage(body: AdminCompanyGalleryRemoveDto, id: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminRemoveGalleryImage(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {CompanyAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateCompany(body: CompanyAdminUpdateDto, id: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminUpdateCompany(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadCompanyLogo(id: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminUploadCompanyLogo(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {Blob} file 
         * @param {string} title 
         * @param {string} description 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadGalleryImage(file: Blob, title: string, description: string, id: string, options?: any) {
            return CompaniesAdminModuleApiFp(configuration).adminUploadGalleryImage(file, title, description, id, options)(fetch, basePath);
        },
    };
};

/**
 * CompaniesAdminModuleApi - object-oriented interface
 * @export
 * @class CompaniesAdminModuleApi
 * @extends {BaseAPI}
 */
export class CompaniesAdminModuleApi extends BaseAPI {
    /**
     * 
     * @param {CompanyAdminCreateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminCreateCompany(body: CompanyAdminCreateDto, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminCreateCompany(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminDeleteCompany(id: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminDeleteCompany(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterTin] Filter by tin query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.tin&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.tin&#x3D;$not:$like:John Doe&amp;filter.tin&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterCompanyVerified] Filter by companyVerified query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.companyVerified&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.companyVerified&#x3D;$not:$like:John Doe&amp;filter.companyVerified&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,location,country,email,manager.email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;location&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;manager.email&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminFindAllCompanies(page?: number, limit?: number, filterName?: Array<string>, filterCountry?: Array<string>, filterTin?: Array<string>, filterCompanyVerified?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminFindAllCompanies(page, limit, filterName, filterCountry, filterTin, filterCompanyVerified, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminFindOneCompany(id: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminFindOneCompany(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} managerId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminFindOneCompanyByManagerId(managerId: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminFindOneCompanyByManagerId(managerId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminRemoveCompanyLogo(id: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminRemoveCompanyLogo(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {AdminCompanyGalleryRemoveDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminRemoveGalleryImage(body: AdminCompanyGalleryRemoveDto, id: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminRemoveGalleryImage(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CompanyAdminUpdateDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminUpdateCompany(body: CompanyAdminUpdateDto, id: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminUpdateCompany(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminUploadCompanyLogo(id: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminUploadCompanyLogo(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Blob} file 
     * @param {string} title 
     * @param {string} description 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesAdminModuleApi
     */
    public adminUploadGalleryImage(file: Blob, title: string, description: string, id: string, options?: any) {
        return CompaniesAdminModuleApiFp(this.configuration).adminUploadGalleryImage(file, title, description, id, options)(this.fetch, this.basePath);
    }

}
/**
 * CompaniesManagerModuleApi - fetch parameter creator
 * @export
 */
export const CompaniesManagerModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerRemoveAvatar(options: any = {}): FetchArgs {
            const localVarPath = `/api/manager/companies/logo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerCompanyGalleryRemoveDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerRemoveImageFromGallery(body: ManagerCompanyGalleryRemoveDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling companyManagerControllerRemoveImageFromGallery.');
            }
            const localVarPath = `/api/manager/companies/gallery`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagerCompanyGalleryRemoveDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerUploadAvatar(options: any = {}): FetchArgs {
            const localVarPath = `/api/manager/companies/logo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Blob} file 
         * @param {string} title 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerUploadGallery(file: Blob, title: string, description: string, options: any = {}): FetchArgs {
            // verify required parameter 'file' is not null or undefined
            if (file === null || file === undefined) {
                throw new RequiredError('file','Required parameter file was null or undefined when calling companyManagerControllerUploadGallery.');
            }
            // verify required parameter 'title' is not null or undefined
            if (title === null || title === undefined) {
                throw new RequiredError('title','Required parameter title was null or undefined when calling companyManagerControllerUploadGallery.');
            }
            // verify required parameter 'description' is not null or undefined
            if (description === null || description === undefined) {
                throw new RequiredError('description','Required parameter description was null or undefined when calling companyManagerControllerUploadGallery.');
            }
            const localVarPath = `/api/manager/companies/gallery`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new URLSearchParams();

            if (file !== undefined) {
                localVarFormParams.set('file', file as any);
            }

            if (title !== undefined) {
                localVarFormParams.set('title', title as any);
            }

            if (description !== undefined) {
                localVarFormParams.set('description', description as any);
            }

            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCompanyByManager(options: any = {}): FetchArgs {
            const localVarPath = `/api/manager/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompanyManagerUpdateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyByManager(body: CompanyManagerUpdateDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateCompanyByManager.');
            }
            const localVarPath = `/api/manager/companies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompanyManagerUpdateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompaniesManagerModuleApi - functional programming interface
 * @export
 */
export const CompaniesManagerModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerRemoveAvatar(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesManagerModuleApiFetchParamCreator(configuration).companyManagerControllerRemoveAvatar(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ManagerCompanyGalleryRemoveDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerRemoveImageFromGallery(body: ManagerCompanyGalleryRemoveDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesManagerModuleApiFetchParamCreator(configuration).companyManagerControllerRemoveImageFromGallery(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerUploadAvatar(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesManagerModuleApiFetchParamCreator(configuration).companyManagerControllerUploadAvatar(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {Blob} file 
         * @param {string} title 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerUploadGallery(file: Blob, title: string, description: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = CompaniesManagerModuleApiFetchParamCreator(configuration).companyManagerControllerUploadGallery(file, title, description, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCompanyByManager(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompaniesManagerModuleApiFetchParamCreator(configuration).findCompanyByManager(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CompanyManagerUpdateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyByManager(body: CompanyManagerUpdateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Company> {
            const localVarFetchArgs = CompaniesManagerModuleApiFetchParamCreator(configuration).updateCompanyByManager(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * CompaniesManagerModuleApi - factory interface
 * @export
 */
export const CompaniesManagerModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerRemoveAvatar(options?: any) {
            return CompaniesManagerModuleApiFp(configuration).companyManagerControllerRemoveAvatar(options)(fetch, basePath);
        },
        /**
         * 
         * @param {ManagerCompanyGalleryRemoveDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerRemoveImageFromGallery(body: ManagerCompanyGalleryRemoveDto, options?: any) {
            return CompaniesManagerModuleApiFp(configuration).companyManagerControllerRemoveImageFromGallery(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerUploadAvatar(options?: any) {
            return CompaniesManagerModuleApiFp(configuration).companyManagerControllerUploadAvatar(options)(fetch, basePath);
        },
        /**
         * 
         * @param {Blob} file 
         * @param {string} title 
         * @param {string} description 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyManagerControllerUploadGallery(file: Blob, title: string, description: string, options?: any) {
            return CompaniesManagerModuleApiFp(configuration).companyManagerControllerUploadGallery(file, title, description, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findCompanyByManager(options?: any) {
            return CompaniesManagerModuleApiFp(configuration).findCompanyByManager(options)(fetch, basePath);
        },
        /**
         * 
         * @param {CompanyManagerUpdateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCompanyByManager(body: CompanyManagerUpdateDto, options?: any) {
            return CompaniesManagerModuleApiFp(configuration).updateCompanyByManager(body, options)(fetch, basePath);
        },
    };
};

/**
 * CompaniesManagerModuleApi - object-oriented interface
 * @export
 * @class CompaniesManagerModuleApi
 * @extends {BaseAPI}
 */
export class CompaniesManagerModuleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesManagerModuleApi
     */
    public companyManagerControllerRemoveAvatar(options?: any) {
        return CompaniesManagerModuleApiFp(this.configuration).companyManagerControllerRemoveAvatar(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ManagerCompanyGalleryRemoveDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesManagerModuleApi
     */
    public companyManagerControllerRemoveImageFromGallery(body: ManagerCompanyGalleryRemoveDto, options?: any) {
        return CompaniesManagerModuleApiFp(this.configuration).companyManagerControllerRemoveImageFromGallery(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesManagerModuleApi
     */
    public companyManagerControllerUploadAvatar(options?: any) {
        return CompaniesManagerModuleApiFp(this.configuration).companyManagerControllerUploadAvatar(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {Blob} file 
     * @param {string} title 
     * @param {string} description 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesManagerModuleApi
     */
    public companyManagerControllerUploadGallery(file: Blob, title: string, description: string, options?: any) {
        return CompaniesManagerModuleApiFp(this.configuration).companyManagerControllerUploadGallery(file, title, description, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesManagerModuleApi
     */
    public findCompanyByManager(options?: any) {
        return CompaniesManagerModuleApiFp(this.configuration).findCompanyByManager(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CompanyManagerUpdateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CompaniesManagerModuleApi
     */
    public updateCompanyByManager(body: CompanyManagerUpdateDto, options?: any) {
        return CompaniesManagerModuleApiFp(this.configuration).updateCompanyByManager(body, options)(this.fetch, this.basePath);
    }

}
/**
 * DefaultApi - fetch parameter creator
 * @export
 */
export const DefaultApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AnalyticsQueryDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerProcessQuery(body: AnalyticsQueryDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling analyticsControllerProcessQuery.');
            }
            const localVarPath = `/api/analytics/query`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AnalyticsQueryDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetError(options: any = {}): FetchArgs {
            const localVarPath = `/api/v1/debug-sentry`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetHello(options: any = {}): FetchArgs {
            const localVarPath = `/api/v1`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultApi - functional programming interface
 * @export
 */
export const DefaultApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AnalyticsQueryDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerProcessQuery(body: AnalyticsQueryDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).analyticsControllerProcessQuery(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetError(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).appControllerGetError(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetHello(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = DefaultApiFetchParamCreator(configuration).appControllerGetHello(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * DefaultApi - factory interface
 * @export
 */
export const DefaultApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {AnalyticsQueryDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        analyticsControllerProcessQuery(body: AnalyticsQueryDto, options?: any) {
            return DefaultApiFp(configuration).analyticsControllerProcessQuery(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetError(options?: any) {
            return DefaultApiFp(configuration).appControllerGetError(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        appControllerGetHello(options?: any) {
            return DefaultApiFp(configuration).appControllerGetHello(options)(fetch, basePath);
        },
    };
};

/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
export class DefaultApi extends BaseAPI {
    /**
     * 
     * @param {AnalyticsQueryDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public analyticsControllerProcessQuery(body: AnalyticsQueryDto, options?: any) {
        return DefaultApiFp(this.configuration).analyticsControllerProcessQuery(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public appControllerGetError(options?: any) {
        return DefaultApiFp(this.configuration).appControllerGetError(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    public appControllerGetHello(options?: any) {
        return DefaultApiFp(this.configuration).appControllerGetHello(options)(this.fetch, this.basePath);
    }

}
/**
 * EmailSchedulerApi - fetch parameter creator
 * @export
 */
export const EmailSchedulerApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddJobPostingEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddJobPostingEmail(body: AddJobPostingEmailDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendAddJobPostingEmail.');
            }
            const localVarPath = `/api/admin/jobs/email-scheduler/add-job-posting`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"AddJobPostingEmailDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CompleteCompanyProfileEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCompleteCompanyProfileEmail(body: CompleteCompanyProfileEmailDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendCompleteCompanyProfileEmail.');
            }
            const localVarPath = `/api/admin/jobs/email-scheduler/complete-company-profile`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CompleteCompanyProfileEmailDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HelpOfferEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpOfferEmail(body: HelpOfferEmailDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendHelpOfferEmail.');
            }
            const localVarPath = `/api/admin/jobs/email-scheduler/help-offer`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"HelpOfferEmailDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {HelpOfferManagerEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpOfferManagerEmail(body: HelpOfferManagerEmailDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendHelpOfferManagerEmail.');
            }
            const localVarPath = `/api/admin/jobs/email-scheduler/help-offer-manager`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"HelpOfferManagerEmailDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ProfileCompletionEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProfileCompletionEmail(body: ProfileCompletionEmailDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendProfileCompletionEmail.');
            }
            const localVarPath = `/api/admin/jobs/email-scheduler/profile-completion`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ProfileCompletionEmailDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WeeklyJobRecommendationsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWeeklyJobRecommendations(body: WeeklyJobRecommendationsDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling sendWeeklyJobRecommendations.');
            }
            const localVarPath = `/api/admin/jobs/email-scheduler/weekly-recommendations`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"WeeklyJobRecommendationsDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailSchedulerApi - functional programming interface
 * @export
 */
export const EmailSchedulerApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {AddJobPostingEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddJobPostingEmail(body: AddJobPostingEmailDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmailSchedulerApiFetchParamCreator(configuration).sendAddJobPostingEmail(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {CompleteCompanyProfileEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCompleteCompanyProfileEmail(body: CompleteCompanyProfileEmailDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmailSchedulerApiFetchParamCreator(configuration).sendCompleteCompanyProfileEmail(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {HelpOfferEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpOfferEmail(body: HelpOfferEmailDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmailSchedulerApiFetchParamCreator(configuration).sendHelpOfferEmail(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {HelpOfferManagerEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpOfferManagerEmail(body: HelpOfferManagerEmailDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmailSchedulerApiFetchParamCreator(configuration).sendHelpOfferManagerEmail(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ProfileCompletionEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProfileCompletionEmail(body: ProfileCompletionEmailDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmailSchedulerApiFetchParamCreator(configuration).sendProfileCompletionEmail(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {WeeklyJobRecommendationsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWeeklyJobRecommendations(body: WeeklyJobRecommendationsDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = EmailSchedulerApiFetchParamCreator(configuration).sendWeeklyJobRecommendations(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * EmailSchedulerApi - factory interface
 * @export
 */
export const EmailSchedulerApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {AddJobPostingEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendAddJobPostingEmail(body: AddJobPostingEmailDto, options?: any) {
            return EmailSchedulerApiFp(configuration).sendAddJobPostingEmail(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {CompleteCompanyProfileEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendCompleteCompanyProfileEmail(body: CompleteCompanyProfileEmailDto, options?: any) {
            return EmailSchedulerApiFp(configuration).sendCompleteCompanyProfileEmail(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {HelpOfferEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpOfferEmail(body: HelpOfferEmailDto, options?: any) {
            return EmailSchedulerApiFp(configuration).sendHelpOfferEmail(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {HelpOfferManagerEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendHelpOfferManagerEmail(body: HelpOfferManagerEmailDto, options?: any) {
            return EmailSchedulerApiFp(configuration).sendHelpOfferManagerEmail(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ProfileCompletionEmailDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendProfileCompletionEmail(body: ProfileCompletionEmailDto, options?: any) {
            return EmailSchedulerApiFp(configuration).sendProfileCompletionEmail(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {WeeklyJobRecommendationsDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendWeeklyJobRecommendations(body: WeeklyJobRecommendationsDto, options?: any) {
            return EmailSchedulerApiFp(configuration).sendWeeklyJobRecommendations(body, options)(fetch, basePath);
        },
    };
};

/**
 * EmailSchedulerApi - object-oriented interface
 * @export
 * @class EmailSchedulerApi
 * @extends {BaseAPI}
 */
export class EmailSchedulerApi extends BaseAPI {
    /**
     * 
     * @param {AddJobPostingEmailDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSchedulerApi
     */
    public sendAddJobPostingEmail(body: AddJobPostingEmailDto, options?: any) {
        return EmailSchedulerApiFp(this.configuration).sendAddJobPostingEmail(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {CompleteCompanyProfileEmailDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSchedulerApi
     */
    public sendCompleteCompanyProfileEmail(body: CompleteCompanyProfileEmailDto, options?: any) {
        return EmailSchedulerApiFp(this.configuration).sendCompleteCompanyProfileEmail(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {HelpOfferEmailDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSchedulerApi
     */
    public sendHelpOfferEmail(body: HelpOfferEmailDto, options?: any) {
        return EmailSchedulerApiFp(this.configuration).sendHelpOfferEmail(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {HelpOfferManagerEmailDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSchedulerApi
     */
    public sendHelpOfferManagerEmail(body: HelpOfferManagerEmailDto, options?: any) {
        return EmailSchedulerApiFp(this.configuration).sendHelpOfferManagerEmail(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ProfileCompletionEmailDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSchedulerApi
     */
    public sendProfileCompletionEmail(body: ProfileCompletionEmailDto, options?: any) {
        return EmailSchedulerApiFp(this.configuration).sendProfileCompletionEmail(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {WeeklyJobRecommendationsDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EmailSchedulerApi
     */
    public sendWeeklyJobRecommendations(body: WeeklyJobRecommendationsDto, options?: any) {
        return EmailSchedulerApiFp(this.configuration).sendWeeklyJobRecommendations(body, options)(this.fetch, this.basePath);
    }

}
/**
 * FilesModuleApi - fetch parameter creator
 * @export
 */
export const FilesModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesControllerGetSignedUrl(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling filesControllerGetSignedUrl.');
            }
            const localVarPath = `/api/files/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilesModuleApi - functional programming interface
 * @export
 */
export const FilesModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesControllerGetSignedUrl(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = FilesModuleApiFetchParamCreator(configuration).filesControllerGetSignedUrl(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * FilesModuleApi - factory interface
 * @export
 */
export const FilesModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        filesControllerGetSignedUrl(id: string, options?: any) {
            return FilesModuleApiFp(configuration).filesControllerGetSignedUrl(id, options)(fetch, basePath);
        },
    };
};

/**
 * FilesModuleApi - object-oriented interface
 * @export
 * @class FilesModuleApi
 * @extends {BaseAPI}
 */
export class FilesModuleApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesModuleApi
     */
    public filesControllerGetSignedUrl(id: string, options?: any) {
        return FilesModuleApiFp(this.configuration).filesControllerGetSignedUrl(id, options)(this.fetch, this.basePath);
    }

}
/**
 * GroupApplyAdminModuleApi - fetch parameter creator
 * @export
 */
export const GroupApplyAdminModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveGroupApply(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminRemoveGroupApply.');
            }
            const localVarPath = `/api/admin/group-applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupAppliesByJob(jobId: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId','Required parameter jobId was null or undefined when calling findAllGroupAppliesByJob.');
            }
            const localVarPath = `/api/admin/group-applies/{jobId}`
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterJobCountry) {
                localVarQueryParameter['filter.job.country'] = filterJobCountry;
            }

            if (filterJobPositionNames) {
                localVarQueryParameter['filter.job.positionNames'] = filterJobPositionNames;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyAdmin(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findOneGroupApplyAdmin.');
            }
            const localVarPath = `/api/admin/group-applies/details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGroupApplyAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupApplyAdmin(body: UpdateGroupApplyAdminDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateGroupApplyAdmin.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateGroupApplyAdmin.');
            }
            const localVarPath = `/api/admin/group-applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateGroupApplyAdminDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * GroupApplyAdminModuleApi - functional programming interface
 * @export
 */
export const GroupApplyAdminModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveGroupApply(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = GroupApplyAdminModuleApiFetchParamCreator(configuration).adminRemoveGroupApply(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupAppliesByJob(jobId: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20015> {
            const localVarFetchArgs = GroupApplyAdminModuleApiFetchParamCreator(configuration).findAllGroupAppliesByJob(jobId, page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyAdmin(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReadOneGroupApplyAdminDto> {
            const localVarFetchArgs = GroupApplyAdminModuleApiFetchParamCreator(configuration).findOneGroupApplyAdmin(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {UpdateGroupApplyAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupApplyAdmin(body: UpdateGroupApplyAdminDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = GroupApplyAdminModuleApiFetchParamCreator(configuration).updateGroupApplyAdmin(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * GroupApplyAdminModuleApi - factory interface
 * @export
 */
export const GroupApplyAdminModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveGroupApply(id: string, options?: any) {
            return GroupApplyAdminModuleApiFp(configuration).adminRemoveGroupApply(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} jobId 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupAppliesByJob(jobId: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return GroupApplyAdminModuleApiFp(configuration).findAllGroupAppliesByJob(jobId, page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyAdmin(id: string, options?: any) {
            return GroupApplyAdminModuleApiFp(configuration).findOneGroupApplyAdmin(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {UpdateGroupApplyAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGroupApplyAdmin(body: UpdateGroupApplyAdminDto, id: string, options?: any) {
            return GroupApplyAdminModuleApiFp(configuration).updateGroupApplyAdmin(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * GroupApplyAdminModuleApi - object-oriented interface
 * @export
 * @class GroupApplyAdminModuleApi
 * @extends {BaseAPI}
 */
export class GroupApplyAdminModuleApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApplyAdminModuleApi
     */
    public adminRemoveGroupApply(id: string, options?: any) {
        return GroupApplyAdminModuleApiFp(this.configuration).adminRemoveGroupApply(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} jobId 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApplyAdminModuleApi
     */
    public findAllGroupAppliesByJob(jobId: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return GroupApplyAdminModuleApiFp(this.configuration).findAllGroupAppliesByJob(jobId, page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApplyAdminModuleApi
     */
    public findOneGroupApplyAdmin(id: string, options?: any) {
        return GroupApplyAdminModuleApiFp(this.configuration).findOneGroupApplyAdmin(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {UpdateGroupApplyAdminDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GroupApplyAdminModuleApi
     */
    public updateGroupApplyAdmin(body: UpdateGroupApplyAdminDto, id: string, options?: any) {
        return GroupApplyAdminModuleApiFp(this.configuration).updateGroupApplyAdmin(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * JobsApi - fetch parameter creator
 * @export
 */
export const JobsApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterExperienceLevel] Filter by experienceLevel query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceLevel&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceLevel&#x3D;$not:$like:John Doe&amp;filter.experienceLevel&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterContractType] Filter by contractType query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.contractType&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.contractType&#x3D;$not:$like:John Doe&amp;filter.contractType&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOvertime] Filter by overtime query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.overtime&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.overtime&#x3D;$not:$like:John Doe&amp;filter.overtime&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterRequiredTools] Filter by requiredTools query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.requiredTools&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.requiredTools&#x3D;$not:$like:John Doe&amp;filter.requiredTools&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredTransport] Filter by offerOptions.ensuredTransport query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredTransport&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredAccommodation] Filter by offerOptions.ensuredAccommodation query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredAccommodation&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredFeeding] Filter by offerOptions.ensuredFeeding query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredFeeding&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllJobsPublicSearch(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterExperienceLevel?: Array<string>, filterContractType?: Array<string>, filterOvertime?: Array<string>, filterRequiredTools?: Array<string>, filterOfferOptionsEnsuredTransport?: Array<string>, filterOfferOptionsEnsuredAccommodation?: Array<string>, filterOfferOptionsEnsuredFeeding?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/jobs/search`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (filterPositionNames) {
                localVarQueryParameter['filter.positionNames'] = filterPositionNames;
            }

            if (filterExperienceLevel) {
                localVarQueryParameter['filter.experienceLevel'] = filterExperienceLevel;
            }

            if (filterContractType) {
                localVarQueryParameter['filter.contractType'] = filterContractType;
            }

            if (filterOvertime) {
                localVarQueryParameter['filter.overtime'] = filterOvertime;
            }

            if (filterRequiredTools) {
                localVarQueryParameter['filter.requiredTools'] = filterRequiredTools;
            }

            if (filterOfferOptionsEnsuredTransport) {
                localVarQueryParameter['filter.offerOptions.ensuredTransport'] = filterOfferOptionsEnsuredTransport;
            }

            if (filterOfferOptionsEnsuredAccommodation) {
                localVarQueryParameter['filter.offerOptions.ensuredAccommodation'] = filterOfferOptionsEnsuredAccommodation;
            }

            if (filterOfferOptionsEnsuredFeeding) {
                localVarQueryParameter['filter.offerOptions.ensuredFeeding'] = filterOfferOptionsEnsuredFeeding;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBestMatchesForJob(slug: string, options: any = {}): FetchArgs {
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling findBestMatchesForJob.');
            }
            const localVarPath = `/api/jobs/{slug}/best-matches`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findJobBySlugPublic(slug: string, options: any = {}): FetchArgs {
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling findJobBySlugPublic.');
            }
            const localVarPath = `/api/jobs/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllJobs(options: any = {}): FetchArgs {
            const localVarPath = `/api/jobs/indexAllJobs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsApi - functional programming interface
 * @export
 */
export const JobsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterExperienceLevel] Filter by experienceLevel query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceLevel&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceLevel&#x3D;$not:$like:John Doe&amp;filter.experienceLevel&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterContractType] Filter by contractType query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.contractType&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.contractType&#x3D;$not:$like:John Doe&amp;filter.contractType&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOvertime] Filter by overtime query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.overtime&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.overtime&#x3D;$not:$like:John Doe&amp;filter.overtime&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterRequiredTools] Filter by requiredTools query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.requiredTools&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.requiredTools&#x3D;$not:$like:John Doe&amp;filter.requiredTools&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredTransport] Filter by offerOptions.ensuredTransport query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredTransport&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredAccommodation] Filter by offerOptions.ensuredAccommodation query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredAccommodation&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredFeeding] Filter by offerOptions.ensuredFeeding query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredFeeding&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllJobsPublicSearch(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterExperienceLevel?: Array<string>, filterContractType?: Array<string>, filterOvertime?: Array<string>, filterRequiredTools?: Array<string>, filterOfferOptionsEnsuredTransport?: Array<string>, filterOfferOptionsEnsuredAccommodation?: Array<string>, filterOfferOptionsEnsuredFeeding?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2006> {
            const localVarFetchArgs = JobsApiFetchParamCreator(configuration).findAllJobsPublicSearch(page, limit, filterCountry, filterPositionNames, filterExperienceLevel, filterContractType, filterOvertime, filterRequiredTools, filterOfferOptionsEnsuredTransport, filterOfferOptionsEnsuredAccommodation, filterOfferOptionsEnsuredFeeding, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBestMatchesForJob(slug: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Array<BestMatchDto>> {
            const localVarFetchArgs = JobsApiFetchParamCreator(configuration).findBestMatchesForJob(slug, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findJobBySlugPublic(slug: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JobPublicReadOneDto> {
            const localVarFetchArgs = JobsApiFetchParamCreator(configuration).findJobBySlugPublic(slug, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllJobs(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = JobsApiFetchParamCreator(configuration).indexAllJobs(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * JobsApi - factory interface
 * @export
 */
export const JobsApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterExperienceLevel] Filter by experienceLevel query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceLevel&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceLevel&#x3D;$not:$like:John Doe&amp;filter.experienceLevel&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterContractType] Filter by contractType query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.contractType&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.contractType&#x3D;$not:$like:John Doe&amp;filter.contractType&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOvertime] Filter by overtime query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.overtime&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.overtime&#x3D;$not:$like:John Doe&amp;filter.overtime&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterRequiredTools] Filter by requiredTools query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.requiredTools&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.requiredTools&#x3D;$not:$like:John Doe&amp;filter.requiredTools&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredTransport] Filter by offerOptions.ensuredTransport query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredTransport&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredAccommodation] Filter by offerOptions.ensuredAccommodation query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredAccommodation&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterOfferOptionsEnsuredFeeding] Filter by offerOptions.ensuredFeeding query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredFeeding&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllJobsPublicSearch(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterExperienceLevel?: Array<string>, filterContractType?: Array<string>, filterOvertime?: Array<string>, filterRequiredTools?: Array<string>, filterOfferOptionsEnsuredTransport?: Array<string>, filterOfferOptionsEnsuredAccommodation?: Array<string>, filterOfferOptionsEnsuredFeeding?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return JobsApiFp(configuration).findAllJobsPublicSearch(page, limit, filterCountry, filterPositionNames, filterExperienceLevel, filterContractType, filterOvertime, filterRequiredTools, filterOfferOptionsEnsuredTransport, filterOfferOptionsEnsuredAccommodation, filterOfferOptionsEnsuredFeeding, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findBestMatchesForJob(slug: string, options?: any) {
            return JobsApiFp(configuration).findBestMatchesForJob(slug, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findJobBySlugPublic(slug: string, options?: any) {
            return JobsApiFp(configuration).findJobBySlugPublic(slug, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        indexAllJobs(options?: any) {
            return JobsApiFp(configuration).indexAllJobs(options)(fetch, basePath);
        },
    };
};

/**
 * JobsApi - object-oriented interface
 * @export
 * @class JobsApi
 * @extends {BaseAPI}
 */
export class JobsApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterExperienceLevel] Filter by experienceLevel query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceLevel&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceLevel&#x3D;$not:$like:John Doe&amp;filter.experienceLevel&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterContractType] Filter by contractType query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.contractType&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.contractType&#x3D;$not:$like:John Doe&amp;filter.contractType&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterOvertime] Filter by overtime query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.overtime&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.overtime&#x3D;$not:$like:John Doe&amp;filter.overtime&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterRequiredTools] Filter by requiredTools query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.requiredTools&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.requiredTools&#x3D;$not:$like:John Doe&amp;filter.requiredTools&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterOfferOptionsEnsuredTransport] Filter by offerOptions.ensuredTransport query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredTransport&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredTransport&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterOfferOptionsEnsuredAccommodation] Filter by offerOptions.ensuredAccommodation query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredAccommodation&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredAccommodation&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterOfferOptionsEnsuredFeeding] Filter by offerOptions.ensuredFeeding query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.offerOptions.ensuredFeeding&#x3D;$not:$like:John Doe&amp;filter.offerOptions.ensuredFeeding&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public findAllJobsPublicSearch(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterExperienceLevel?: Array<string>, filterContractType?: Array<string>, filterOvertime?: Array<string>, filterRequiredTools?: Array<string>, filterOfferOptionsEnsuredTransport?: Array<string>, filterOfferOptionsEnsuredAccommodation?: Array<string>, filterOfferOptionsEnsuredFeeding?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return JobsApiFp(this.configuration).findAllJobsPublicSearch(page, limit, filterCountry, filterPositionNames, filterExperienceLevel, filterContractType, filterOvertime, filterRequiredTools, filterOfferOptionsEnsuredTransport, filterOfferOptionsEnsuredAccommodation, filterOfferOptionsEnsuredFeeding, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public findBestMatchesForJob(slug: string, options?: any) {
        return JobsApiFp(this.configuration).findBestMatchesForJob(slug, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public findJobBySlugPublic(slug: string, options?: any) {
        return JobsApiFp(this.configuration).findJobBySlugPublic(slug, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsApi
     */
    public indexAllJobs(options?: any) {
        return JobsApiFp(this.configuration).indexAllJobs(options)(this.fetch, this.basePath);
    }

}
/**
 * JobsManagerModuleApi - fetch parameter creator
 * @export
 */
export const JobsManagerModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {JobsManagerCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobByManager(body: JobsManagerCreateDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createJobByManager.');
            }
            const localVarPath = `/api/manager/jobs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JobsManagerCreateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobByManager(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteJobByManager.');
            }
            const localVarPath = `/api/manager/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsManagerFindAll(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/manager/jobs`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (filterPositionNames) {
                localVarQueryParameter['filter.positionNames'] = filterPositionNames;
            }

            if (filterActive) {
                localVarQueryParameter['filter.active'] = filterActive;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsManagerFindOne(slug: string, options: any = {}): FetchArgs {
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling jobsManagerFindOne.');
            }
            const localVarPath = `/api/manager/jobs/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {JobsManagerUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobByManager(body: JobsManagerUpdateDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateJobByManager.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateJobByManager.');
            }
            const localVarPath = `/api/manager/jobs/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"JobsManagerUpdateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * JobsManagerModuleApi - functional programming interface
 * @export
 */
export const JobsManagerModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {JobsManagerCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobByManager(body: JobsManagerCreateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = JobsManagerModuleApiFetchParamCreator(configuration).createJobByManager(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobByManager(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = JobsManagerModuleApiFetchParamCreator(configuration).deleteJobByManager(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsManagerFindAll(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2007> {
            const localVarFetchArgs = JobsManagerModuleApiFetchParamCreator(configuration).jobsManagerFindAll(page, limit, filterCountry, filterPositionNames, filterActive, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsManagerFindOne(slug: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<JobManagerDto> {
            const localVarFetchArgs = JobsManagerModuleApiFetchParamCreator(configuration).jobsManagerFindOne(slug, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {JobsManagerUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobByManager(body: JobsManagerUpdateDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Job> {
            const localVarFetchArgs = JobsManagerModuleApiFetchParamCreator(configuration).updateJobByManager(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * JobsManagerModuleApi - factory interface
 * @export
 */
export const JobsManagerModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {JobsManagerCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobByManager(body: JobsManagerCreateDto, options?: any) {
            return JobsManagerModuleApiFp(configuration).createJobByManager(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobByManager(id: string, options?: any) {
            return JobsManagerModuleApiFp(configuration).deleteJobByManager(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsManagerFindAll(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return JobsManagerModuleApiFp(configuration).jobsManagerFindAll(page, limit, filterCountry, filterPositionNames, filterActive, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        jobsManagerFindOne(slug: string, options?: any) {
            return JobsManagerModuleApiFp(configuration).jobsManagerFindOne(slug, options)(fetch, basePath);
        },
        /**
         * 
         * @param {JobsManagerUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobByManager(body: JobsManagerUpdateDto, id: string, options?: any) {
            return JobsManagerModuleApiFp(configuration).updateJobByManager(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * JobsManagerModuleApi - object-oriented interface
 * @export
 * @class JobsManagerModuleApi
 * @extends {BaseAPI}
 */
export class JobsManagerModuleApi extends BaseAPI {
    /**
     * 
     * @param {JobsManagerCreateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsManagerModuleApi
     */
    public createJobByManager(body: JobsManagerCreateDto, options?: any) {
        return JobsManagerModuleApiFp(this.configuration).createJobByManager(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsManagerModuleApi
     */
    public deleteJobByManager(id: string, options?: any) {
        return JobsManagerModuleApiFp(this.configuration).deleteJobByManager(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterPositionNames] Filter by positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionNames&#x3D;$not:$like:John Doe&amp;filter.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterActive] Filter by active query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.active&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.active&#x3D;$not:$like:John Doe&amp;filter.active&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;title&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; title,positionNames,city,company.name,description           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;title&lt;/li&gt; &lt;li&gt;positionNames&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;company.name&lt;/li&gt; &lt;li&gt;description&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsManagerModuleApi
     */
    public jobsManagerFindAll(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionNames?: Array<string>, filterActive?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return JobsManagerModuleApiFp(this.configuration).jobsManagerFindAll(page, limit, filterCountry, filterPositionNames, filterActive, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsManagerModuleApi
     */
    public jobsManagerFindOne(slug: string, options?: any) {
        return JobsManagerModuleApiFp(this.configuration).jobsManagerFindOne(slug, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {JobsManagerUpdateDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof JobsManagerModuleApi
     */
    public updateJobByManager(body: JobsManagerUpdateDto, id: string, options?: any) {
        return JobsManagerModuleApiFp(this.configuration).updateJobByManager(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * ManagerApplyManagementApi - fetch parameter creator
 * @export
 */
export const ManagerApplyManagementApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobSlug 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'jobSlug' is not null or undefined
            if (jobSlug === null || jobSlug === undefined) {
                throw new RequiredError('jobSlug','Required parameter jobSlug was null or undefined when calling findAllAppliesByJobSlugManager.');
            }
            const localVarPath = `/api/manager/applies/{jobSlug}`
                .replace(`{${"jobSlug"}}`, encodeURIComponent(String(jobSlug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterName) {
                localVarQueryParameter['filter.name'] = filterName;
            }

            if (filterEmail) {
                localVarQueryParameter['filter.email'] = filterEmail;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userSlug 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedUserInformation(userSlug: string, jobId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userSlug' is not null or undefined
            if (userSlug === null || userSlug === undefined) {
                throw new RequiredError('userSlug','Required parameter userSlug was null or undefined when calling getAppliedUserInformation.');
            }
            // verify required parameter 'jobId' is not null or undefined
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId','Required parameter jobId was null or undefined when calling getAppliedUserInformation.');
            }
            const localVarPath = `/api/manager/users/{userSlug}/jobs/{jobId}`
                .replace(`{${"userSlug"}}`, encodeURIComponent(String(userSlug)))
                .replace(`{${"jobId"}}`, encodeURIComponent(String(jobId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCertificateUrl(applyId: string, certificateId: string, options: any = {}): FetchArgs {
            // verify required parameter 'applyId' is not null or undefined
            if (applyId === null || applyId === undefined) {
                throw new RequiredError('applyId','Required parameter applyId was null or undefined when calling getSignedCertificateUrl.');
            }
            // verify required parameter 'certificateId' is not null or undefined
            if (certificateId === null || certificateId === undefined) {
                throw new RequiredError('certificateId','Required parameter certificateId was null or undefined when calling getSignedCertificateUrl.');
            }
            const localVarPath = `/api/manager/applies/{applyId}/{certificateId}`
                .replace(`{${"applyId"}}`, encodeURIComponent(String(applyId)))
                .replace(`{${"certificateId"}}`, encodeURIComponent(String(certificateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrl(applyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'applyId' is not null or undefined
            if (applyId === null || applyId === undefined) {
                throw new RequiredError('applyId','Required parameter applyId was null or undefined when calling getSignedCvUrl.');
            }
            const localVarPath = `/api/manager/applies/{applyId}/cv`
                .replace(`{${"applyId"}}`, encodeURIComponent(String(applyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ManagerUpdateApplicationStatusDto} body 
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeApplicationStatus(body: ManagerUpdateApplicationStatusDto, applicationId: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling managerChangeApplicationStatus.');
            }
            // verify required parameter 'applicationId' is not null or undefined
            if (applicationId === null || applicationId === undefined) {
                throw new RequiredError('applicationId','Required parameter applicationId was null or undefined when calling managerChangeApplicationStatus.');
            }
            const localVarPath = `/api/manager/applies/{applicationId}`
                .replace(`{${"applicationId"}}`, encodeURIComponent(String(applicationId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ManagerUpdateApplicationStatusDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerRemoveApply(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling managerRemoveApply.');
            }
            const localVarPath = `/api/manager/applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificate(applyId: string, certificateId: string, options: any = {}): FetchArgs {
            // verify required parameter 'applyId' is not null or undefined
            if (applyId === null || applyId === undefined) {
                throw new RequiredError('applyId','Required parameter applyId was null or undefined when calling viewCertificate.');
            }
            // verify required parameter 'certificateId' is not null or undefined
            if (certificateId === null || certificateId === undefined) {
                throw new RequiredError('certificateId','Required parameter certificateId was null or undefined when calling viewCertificate.');
            }
            const localVarPath = `/api/manager/applies/{applyId}/certificate/{certificateId}/view`
                .replace(`{${"applyId"}}`, encodeURIComponent(String(applyId)))
                .replace(`{${"certificateId"}}`, encodeURIComponent(String(certificateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCv(applyId: string, options: any = {}): FetchArgs {
            // verify required parameter 'applyId' is not null or undefined
            if (applyId === null || applyId === undefined) {
                throw new RequiredError('applyId','Required parameter applyId was null or undefined when calling viewCv.');
            }
            const localVarPath = `/api/manager/applies/{applyId}/cv/view`
                .replace(`{${"applyId"}}`, encodeURIComponent(String(applyId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagerApplyManagementApi - functional programming interface
 * @export
 */
export const ManagerApplyManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobSlug 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2005> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).findAllAppliesByJobSlugManager(jobSlug, page, limit, filterName, filterEmail, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} userSlug 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedUserInformation(userSlug: string, jobId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<AppliedUserInfoManagerDto> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).getAppliedUserInformation(userSlug, jobId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCertificateUrl(applyId: string, certificateId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).getSignedCertificateUrl(applyId, certificateId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrl(applyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).getSignedCvUrl(applyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ManagerUpdateApplicationStatusDto} body 
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeApplicationStatus(body: ManagerUpdateApplicationStatusDto, applicationId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).managerChangeApplicationStatus(body, applicationId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerRemoveApply(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).managerRemoveApply(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificate(applyId: string, certificateId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).viewCertificate(applyId, certificateId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCv(applyId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerApplyManagementApiFetchParamCreator(configuration).viewCv(applyId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManagerApplyManagementApi - factory interface
 * @export
 */
export const ManagerApplyManagementApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} jobSlug 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return ManagerApplyManagementApiFp(configuration).findAllAppliesByJobSlugManager(jobSlug, page, limit, filterName, filterEmail, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} userSlug 
         * @param {string} jobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppliedUserInformation(userSlug: string, jobId: string, options?: any) {
            return ManagerApplyManagementApiFp(configuration).getAppliedUserInformation(userSlug, jobId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} applyId 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCertificateUrl(applyId: string, certificateId: string, options?: any) {
            return ManagerApplyManagementApiFp(configuration).getSignedCertificateUrl(applyId, certificateId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrl(applyId: string, options?: any) {
            return ManagerApplyManagementApiFp(configuration).getSignedCvUrl(applyId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {ManagerUpdateApplicationStatusDto} body 
         * @param {string} applicationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeApplicationStatus(body: ManagerUpdateApplicationStatusDto, applicationId: string, options?: any) {
            return ManagerApplyManagementApiFp(configuration).managerChangeApplicationStatus(body, applicationId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerRemoveApply(id: string, options?: any) {
            return ManagerApplyManagementApiFp(configuration).managerRemoveApply(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} applyId 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificate(applyId: string, certificateId: string, options?: any) {
            return ManagerApplyManagementApiFp(configuration).viewCertificate(applyId, certificateId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} applyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCv(applyId: string, options?: any) {
            return ManagerApplyManagementApiFp(configuration).viewCv(applyId, options)(fetch, basePath);
        },
    };
};

/**
 * ManagerApplyManagementApi - object-oriented interface
 * @export
 * @class ManagerApplyManagementApi
 * @extends {BaseAPI}
 */
export class ManagerApplyManagementApi extends BaseAPI {
    /**
     * 
     * @param {string} jobSlug 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterName] Filter by name query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.name&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.name&#x3D;$not:$like:John Doe&amp;filter.name&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt; &lt;li&gt;$not&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterEmail] Filter by email query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.email&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.email&#x3D;$not:$like:John Doe&amp;filter.email&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; id:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;name&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; name,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;name&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public findAllAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterName?: Array<string>, filterEmail?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).findAllAppliesByJobSlugManager(jobSlug, page, limit, filterName, filterEmail, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} userSlug 
     * @param {string} jobId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public getAppliedUserInformation(userSlug: string, jobId: string, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).getAppliedUserInformation(userSlug, jobId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} applyId 
     * @param {string} certificateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public getSignedCertificateUrl(applyId: string, certificateId: string, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).getSignedCertificateUrl(applyId, certificateId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} applyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public getSignedCvUrl(applyId: string, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).getSignedCvUrl(applyId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ManagerUpdateApplicationStatusDto} body 
     * @param {string} applicationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public managerChangeApplicationStatus(body: ManagerUpdateApplicationStatusDto, applicationId: string, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).managerChangeApplicationStatus(body, applicationId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public managerRemoveApply(id: string, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).managerRemoveApply(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} applyId 
     * @param {string} certificateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public viewCertificate(applyId: string, certificateId: string, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).viewCertificate(applyId, certificateId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} applyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerApplyManagementApi
     */
    public viewCv(applyId: string, options?: any) {
        return ManagerApplyManagementApiFp(this.configuration).viewCv(applyId, options)(this.fetch, this.basePath);
    }

}
/**
 * ManagerGroupApplyManagementApi - fetch parameter creator
 * @export
 */
export const ManagerGroupApplyManagementApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobSlug 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            // verify required parameter 'jobSlug' is not null or undefined
            if (jobSlug === null || jobSlug === undefined) {
                throw new RequiredError('jobSlug','Required parameter jobSlug was null or undefined when calling findGroupAppliesByJobSlugManager.');
            }
            const localVarPath = `/api/manager/group-applies/{jobSlug}`
                .replace(`{${"jobSlug"}}`, encodeURIComponent(String(jobSlug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterJobCountry) {
                localVarQueryParameter['filter.job.country'] = filterJobCountry;
            }

            if (filterJobPositionNames) {
                localVarQueryParameter['filter.job.positionNames'] = filterJobPositionNames;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyManager(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findOneGroupApplyManager.');
            }
            const localVarPath = `/api/manager/group-applies/details/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateGroupApplyManagerDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeGroupApplicationStatus(body: UpdateGroupApplyManagerDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling managerChangeGroupApplicationStatus.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling managerChangeGroupApplicationStatus.');
            }
            const localVarPath = `/api/manager/group-applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateGroupApplyManagerDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerRemoveGroupApply(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling managerRemoveGroupApply.');
            }
            const localVarPath = `/api/manager/group-applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ManagerGroupApplyManagementApi - functional programming interface
 * @export
 */
export const ManagerGroupApplyManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} jobSlug 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20014> {
            const localVarFetchArgs = ManagerGroupApplyManagementApiFetchParamCreator(configuration).findGroupAppliesByJobSlugManager(jobSlug, page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyManager(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReadOneGroupApplyManagerDto> {
            const localVarFetchArgs = ManagerGroupApplyManagementApiFetchParamCreator(configuration).findOneGroupApplyManager(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {UpdateGroupApplyManagerDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeGroupApplicationStatus(body: UpdateGroupApplyManagerDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerGroupApplyManagementApiFetchParamCreator(configuration).managerChangeGroupApplicationStatus(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerRemoveGroupApply(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = ManagerGroupApplyManagementApiFetchParamCreator(configuration).managerRemoveGroupApply(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * ManagerGroupApplyManagementApi - factory interface
 * @export
 */
export const ManagerGroupApplyManagementApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} jobSlug 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findGroupAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return ManagerGroupApplyManagementApiFp(configuration).findGroupAppliesByJobSlugManager(jobSlug, page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyManager(id: string, options?: any) {
            return ManagerGroupApplyManagementApiFp(configuration).findOneGroupApplyManager(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {UpdateGroupApplyManagerDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerChangeGroupApplicationStatus(body: UpdateGroupApplyManagerDto, id: string, options?: any) {
            return ManagerGroupApplyManagementApiFp(configuration).managerChangeGroupApplicationStatus(body, id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerRemoveGroupApply(id: string, options?: any) {
            return ManagerGroupApplyManagementApiFp(configuration).managerRemoveGroupApply(id, options)(fetch, basePath);
        },
    };
};

/**
 * ManagerGroupApplyManagementApi - object-oriented interface
 * @export
 * @class ManagerGroupApplyManagementApi
 * @extends {BaseAPI}
 */
export class ManagerGroupApplyManagementApi extends BaseAPI {
    /**
     * 
     * @param {string} jobSlug 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerGroupApplyManagementApi
     */
    public findGroupAppliesByJobSlugManager(jobSlug: string, page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return ManagerGroupApplyManagementApiFp(this.configuration).findGroupAppliesByJobSlugManager(jobSlug, page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerGroupApplyManagementApi
     */
    public findOneGroupApplyManager(id: string, options?: any) {
        return ManagerGroupApplyManagementApiFp(this.configuration).findOneGroupApplyManager(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {UpdateGroupApplyManagerDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerGroupApplyManagementApi
     */
    public managerChangeGroupApplicationStatus(body: UpdateGroupApplyManagerDto, id: string, options?: any) {
        return ManagerGroupApplyManagementApiFp(this.configuration).managerChangeGroupApplicationStatus(body, id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ManagerGroupApplyManagementApi
     */
    public managerRemoveGroupApply(id: string, options?: any) {
        return ManagerGroupApplyManagementApiFp(this.configuration).managerRemoveGroupApply(id, options)(this.fetch, this.basePath);
    }

}
/**
 * TalentPoolApi - fetch parameter creator
 * @export
 */
export const TalentPoolApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterExperienceYears] Filter by experienceYears query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceYears&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceYears&#x3D;$not:$like:John Doe&amp;filter.experienceYears&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterIsLookingForJob] Filter by isLookingForJob query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.isLookingForJob&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.isLookingForJob&#x3D;$not:$like:John Doe&amp;filter.isLookingForJob&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,country,positionName,experience           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTalentsPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterExperienceYears?: Array<string>, filterPreferredCountries?: Array<string>, filterIsLookingForJob?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/talent-pool`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (filterPositionName) {
                localVarQueryParameter['filter.positionName'] = filterPositionName;
            }

            if (filterExperienceYears) {
                localVarQueryParameter['filter.experienceYears'] = filterExperienceYears;
            }

            if (filterPreferredCountries) {
                localVarQueryParameter['filter.preferredCountries'] = filterPreferredCountries;
            }

            if (filterIsLookingForJob) {
                localVarQueryParameter['filter.isLookingForJob'] = filterIsLookingForJob;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTalentBySlugPublic(slug: string, options: any = {}): FetchArgs {
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling findTalentBySlugPublic.');
            }
            const localVarPath = `/api/talent-pool/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TalentPoolApi - functional programming interface
 * @export
 */
export const TalentPoolApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterExperienceYears] Filter by experienceYears query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceYears&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceYears&#x3D;$not:$like:John Doe&amp;filter.experienceYears&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterIsLookingForJob] Filter by isLookingForJob query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.isLookingForJob&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.isLookingForJob&#x3D;$not:$like:John Doe&amp;filter.isLookingForJob&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,country,positionName,experience           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTalentsPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterExperienceYears?: Array<string>, filterPreferredCountries?: Array<string>, filterIsLookingForJob?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20010> {
            const localVarFetchArgs = TalentPoolApiFetchParamCreator(configuration).findAllTalentsPublic(page, limit, filterCountry, filterPositionName, filterExperienceYears, filterPreferredCountries, filterIsLookingForJob, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTalentBySlugPublic(slug: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TalentPublicReadOneDto> {
            const localVarFetchArgs = TalentPoolApiFetchParamCreator(configuration).findTalentBySlugPublic(slug, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TalentPoolApi - factory interface
 * @export
 */
export const TalentPoolApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterExperienceYears] Filter by experienceYears query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceYears&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceYears&#x3D;$not:$like:John Doe&amp;filter.experienceYears&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterIsLookingForJob] Filter by isLookingForJob query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.isLookingForJob&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.isLookingForJob&#x3D;$not:$like:John Doe&amp;filter.isLookingForJob&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,country,positionName,experience           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllTalentsPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterExperienceYears?: Array<string>, filterPreferredCountries?: Array<string>, filterIsLookingForJob?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return TalentPoolApiFp(configuration).findAllTalentsPublic(page, limit, filterCountry, filterPositionName, filterExperienceYears, filterPreferredCountries, filterIsLookingForJob, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTalentBySlugPublic(slug: string, options?: any) {
            return TalentPoolApiFp(configuration).findTalentBySlugPublic(slug, options)(fetch, basePath);
        },
    };
};

/**
 * TalentPoolApi - object-oriented interface
 * @export
 * @class TalentPoolApi
 * @extends {BaseAPI}
 */
export class TalentPoolApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$in&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterExperienceYears] Filter by experienceYears query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.experienceYears&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.experienceYears&#x3D;$not:$like:John Doe&amp;filter.experienceYears&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterIsLookingForJob] Filter by isLookingForJob query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.isLookingForJob&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.isLookingForJob&#x3D;$not:$like:John Doe&amp;filter.isLookingForJob&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,country,positionName,experience           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolApi
     */
    public findAllTalentsPublic(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterExperienceYears?: Array<string>, filterPreferredCountries?: Array<string>, filterIsLookingForJob?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return TalentPoolApiFp(this.configuration).findAllTalentsPublic(page, limit, filterCountry, filterPositionName, filterExperienceYears, filterPreferredCountries, filterIsLookingForJob, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolApi
     */
    public findTalentBySlugPublic(slug: string, options?: any) {
        return TalentPoolApiFp(this.configuration).findTalentBySlugPublic(slug, options)(this.fetch, this.basePath);
    }

}
/**
 * TalentPoolAdminModuleApi - fetch parameter creator
 * @export
 */
export const TalentPoolAdminModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserCompetencesDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateTalent(body: CreateUserCompetencesDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adminCreateTalent.');
            }
            const localVarPath = `/api/admin/talent-pool`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateUserCompetencesDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;user.createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,positionName,country,user.firstName,user.lastName           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;user.firstName&lt;/li&gt; &lt;li&gt;user.lastName&lt;/li&gt; &lt;li&gt;user.email&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllTalents(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterPreferredCountries?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/talent-pool`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (filterPositionName) {
                localVarQueryParameter['filter.positionName'] = filterPositionName;
            }

            if (filterPreferredCountries) {
                localVarQueryParameter['filter.preferredCountries'] = filterPreferredCountries;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneTalent(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminFindOneTalent.');
            }
            const localVarPath = `/api/admin/talent-pool/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneTalentByUserId(userId: string, options: any = {}): FetchArgs {
            // verify required parameter 'userId' is not null or undefined
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId','Required parameter userId was null or undefined when calling adminFindOneTalentByUserId.');
            }
            const localVarPath = `/api/admin/talent-pool/user/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSignedCertificateUrl(id: string, certificateId: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminGetSignedCertificateUrl.');
            }
            // verify required parameter 'certificateId' is not null or undefined
            if (certificateId === null || certificateId === undefined) {
                throw new RequiredError('certificateId','Required parameter certificateId was null or undefined when calling adminGetSignedCertificateUrl.');
            }
            const localVarPath = `/api/admin/talent-pool/{id}/certificates/{certificateId}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"certificateId"}}`, encodeURIComponent(String(certificateId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSignedCvUrl(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminGetSignedCvUrl.');
            }
            const localVarPath = `/api/admin/talent-pool/{id}/cv`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateTalentAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateTalent(body: UpdateTalentAdminDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adminUpdateTalent.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminUpdateTalent.');
            }
            const localVarPath = `/api/admin/talent-pool/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateTalentAdminDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TalentPoolAdminModuleApi - functional programming interface
 * @export
 */
export const TalentPoolAdminModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateUserCompetencesDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateTalent(body: CreateUserCompetencesDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserCompetences> {
            const localVarFetchArgs = TalentPoolAdminModuleApiFetchParamCreator(configuration).adminCreateTalent(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;user.createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,positionName,country,user.firstName,user.lastName           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;user.firstName&lt;/li&gt; &lt;li&gt;user.lastName&lt;/li&gt; &lt;li&gt;user.email&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllTalents(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterPreferredCountries?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse2009> {
            const localVarFetchArgs = TalentPoolAdminModuleApiFetchParamCreator(configuration).adminFindAllTalents(page, limit, filterCountry, filterPositionName, filterPreferredCountries, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneTalent(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TalentAdminReadOneDto> {
            const localVarFetchArgs = TalentPoolAdminModuleApiFetchParamCreator(configuration).adminFindOneTalent(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneTalentByUserId(userId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TalentAdminReadOneDto> {
            const localVarFetchArgs = TalentPoolAdminModuleApiFetchParamCreator(configuration).adminFindOneTalentByUserId(userId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSignedCertificateUrl(id: string, certificateId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TalentPoolAdminModuleApiFetchParamCreator(configuration).adminGetSignedCertificateUrl(id, certificateId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSignedCvUrl(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = TalentPoolAdminModuleApiFetchParamCreator(configuration).adminGetSignedCvUrl(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {UpdateTalentAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateTalent(body: UpdateTalentAdminDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TalentAdminReadOneDto> {
            const localVarFetchArgs = TalentPoolAdminModuleApiFetchParamCreator(configuration).adminUpdateTalent(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * TalentPoolAdminModuleApi - factory interface
 * @export
 */
export const TalentPoolAdminModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CreateUserCompetencesDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateTalent(body: CreateUserCompetencesDto, options?: any) {
            return TalentPoolAdminModuleApiFp(configuration).adminCreateTalent(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;user.createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,positionName,country,user.firstName,user.lastName           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;user.firstName&lt;/li&gt; &lt;li&gt;user.lastName&lt;/li&gt; &lt;li&gt;user.email&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllTalents(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterPreferredCountries?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return TalentPoolAdminModuleApiFp(configuration).adminFindAllTalents(page, limit, filterCountry, filterPositionName, filterPreferredCountries, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneTalent(id: string, options?: any) {
            return TalentPoolAdminModuleApiFp(configuration).adminFindOneTalent(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindOneTalentByUserId(userId: string, options?: any) {
            return TalentPoolAdminModuleApiFp(configuration).adminFindOneTalentByUserId(userId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {string} certificateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSignedCertificateUrl(id: string, certificateId: string, options?: any) {
            return TalentPoolAdminModuleApiFp(configuration).adminGetSignedCertificateUrl(id, certificateId, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminGetSignedCvUrl(id: string, options?: any) {
            return TalentPoolAdminModuleApiFp(configuration).adminGetSignedCvUrl(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {UpdateTalentAdminDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUpdateTalent(body: UpdateTalentAdminDto, id: string, options?: any) {
            return TalentPoolAdminModuleApiFp(configuration).adminUpdateTalent(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * TalentPoolAdminModuleApi - object-oriented interface
 * @export
 * @class TalentPoolAdminModuleApi
 * @extends {BaseAPI}
 */
export class TalentPoolAdminModuleApi extends BaseAPI {
    /**
     * 
     * @param {CreateUserCompetencesDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolAdminModuleApi
     */
    public adminCreateTalent(body: CreateUserCompetencesDto, options?: any) {
        return TalentPoolAdminModuleApiFp(this.configuration).adminCreateTalent(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterPositionName] Filter by positionName query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.positionName&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.positionName&#x3D;$not:$like:John Doe&amp;filter.positionName&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterPreferredCountries] Filter by preferredCountries query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.preferredCountries&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.preferredCountries&#x3D;$not:$like:John Doe&amp;filter.preferredCountries&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;user.createdAt&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; city,positionName,country,user.firstName,user.lastName           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;city&lt;/li&gt; &lt;li&gt;positionName&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;user.firstName&lt;/li&gt; &lt;li&gt;user.lastName&lt;/li&gt; &lt;li&gt;user.email&lt;/li&gt; &lt;li&gt;experience&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolAdminModuleApi
     */
    public adminFindAllTalents(page?: number, limit?: number, filterCountry?: Array<string>, filterPositionName?: Array<string>, filterPreferredCountries?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return TalentPoolAdminModuleApiFp(this.configuration).adminFindAllTalents(page, limit, filterCountry, filterPositionName, filterPreferredCountries, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolAdminModuleApi
     */
    public adminFindOneTalent(id: string, options?: any) {
        return TalentPoolAdminModuleApiFp(this.configuration).adminFindOneTalent(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolAdminModuleApi
     */
    public adminFindOneTalentByUserId(userId: string, options?: any) {
        return TalentPoolAdminModuleApiFp(this.configuration).adminFindOneTalentByUserId(userId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {string} certificateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolAdminModuleApi
     */
    public adminGetSignedCertificateUrl(id: string, certificateId: string, options?: any) {
        return TalentPoolAdminModuleApiFp(this.configuration).adminGetSignedCertificateUrl(id, certificateId, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolAdminModuleApi
     */
    public adminGetSignedCvUrl(id: string, options?: any) {
        return TalentPoolAdminModuleApiFp(this.configuration).adminGetSignedCvUrl(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {UpdateTalentAdminDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TalentPoolAdminModuleApi
     */
    public adminUpdateTalent(body: UpdateTalentAdminDto, id: string, options?: any) {
        return TalentPoolAdminModuleApiFp(this.configuration).adminUpdateTalent(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * UnsubscribeModuleApi - fetch parameter creator
 * @export
 */
export const UnsubscribeModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} hashId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeControllerUnsubscribe(hashId: string, options: any = {}): FetchArgs {
            // verify required parameter 'hashId' is not null or undefined
            if (hashId === null || hashId === undefined) {
                throw new RequiredError('hashId','Required parameter hashId was null or undefined when calling unsubscribeControllerUnsubscribe.');
            }
            const localVarPath = `/api/unsubscribe/{hashId}`
                .replace(`{${"hashId"}}`, encodeURIComponent(String(hashId)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnsubscribeModuleApi - functional programming interface
 * @export
 */
export const UnsubscribeModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} hashId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeControllerUnsubscribe(hashId: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UnsubscribeModuleApiFetchParamCreator(configuration).unsubscribeControllerUnsubscribe(hashId, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UnsubscribeModuleApi - factory interface
 * @export
 */
export const UnsubscribeModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} hashId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unsubscribeControllerUnsubscribe(hashId: string, options?: any) {
            return UnsubscribeModuleApiFp(configuration).unsubscribeControllerUnsubscribe(hashId, options)(fetch, basePath);
        },
    };
};

/**
 * UnsubscribeModuleApi - object-oriented interface
 * @export
 * @class UnsubscribeModuleApi
 * @extends {BaseAPI}
 */
export class UnsubscribeModuleApi extends BaseAPI {
    /**
     * 
     * @param {string} hashId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UnsubscribeModuleApi
     */
    public unsubscribeControllerUnsubscribe(hashId: string, options?: any) {
        return UnsubscribeModuleApiFp(this.configuration).unsubscribeControllerUnsubscribe(hashId, options)(this.fetch, this.basePath);
    }

}
/**
 * UserGroupApplyApi - fetch parameter creator
 * @export
 */
export const UserGroupApplyApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateGroupApplyUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupApply(body: CreateGroupApplyUserDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling createGroupApply.');
            }
            const localVarPath = `/api/user/group-applies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"CreateGroupApplyUserDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupAppliesUser(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/user/group-applies`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterJobCountry) {
                localVarQueryParameter['filter.job.country'] = filterJobCountry;
            }

            if (filterJobPositionNames) {
                localVarQueryParameter['filter.job.positionNames'] = filterJobPositionNames;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyUser(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findOneGroupApplyUser.');
            }
            const localVarPath = `/api/user/group-applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRemoveGroupApply(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userRemoveGroupApply.');
            }
            const localVarPath = `/api/user/group-applies/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserGroupApplyApi - functional programming interface
 * @export
 */
export const UserGroupApplyApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateGroupApplyUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupApply(body: CreateGroupApplyUserDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserGroupApplyApiFetchParamCreator(configuration).createGroupApply(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupAppliesUser(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20013> {
            const localVarFetchArgs = UserGroupApplyApiFetchParamCreator(configuration).findAllGroupAppliesUser(page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyUser(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<ReadOneGroupApplyUserDto> {
            const localVarFetchArgs = UserGroupApplyApiFetchParamCreator(configuration).findOneGroupApplyUser(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRemoveGroupApply(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserGroupApplyApiFetchParamCreator(configuration).userRemoveGroupApply(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserGroupApplyApi - factory interface
 * @export
 */
export const UserGroupApplyApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {CreateGroupApplyUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createGroupApply(body: CreateGroupApplyUserDto, options?: any) {
            return UserGroupApplyApiFp(configuration).createGroupApply(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllGroupAppliesUser(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return UserGroupApplyApiFp(configuration).findAllGroupAppliesUser(page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneGroupApplyUser(id: string, options?: any) {
            return UserGroupApplyApiFp(configuration).findOneGroupApplyUser(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRemoveGroupApply(id: string, options?: any) {
            return UserGroupApplyApiFp(configuration).userRemoveGroupApply(id, options)(fetch, basePath);
        },
    };
};

/**
 * UserGroupApplyApi - object-oriented interface
 * @export
 * @class UserGroupApplyApi
 * @extends {BaseAPI}
 */
export class UserGroupApplyApi extends BaseAPI {
    /**
     * 
     * @param {CreateGroupApplyUserDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApplyApi
     */
    public createGroupApply(body: CreateGroupApplyUserDto, options?: any) {
        return UserGroupApplyApiFp(this.configuration).createGroupApply(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterJobCountry] Filter by job.country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.country&#x3D;$not:$like:John Doe&amp;filter.job.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterJobPositionNames] Filter by job.positionNames query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.job.positionNames&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.job.positionNames&#x3D;$not:$like:John Doe&amp;filter.job.positionNames&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; job.title,job.city,job.company.name,job.country,job.positionNames           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;job.title&lt;/li&gt; &lt;li&gt;job.city&lt;/li&gt; &lt;li&gt;job.company.name&lt;/li&gt; &lt;li&gt;job.country&lt;/li&gt; &lt;li&gt;job.positionNames&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApplyApi
     */
    public findAllGroupAppliesUser(page?: number, limit?: number, filterJobCountry?: Array<string>, filterJobPositionNames?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return UserGroupApplyApiFp(this.configuration).findAllGroupAppliesUser(page, limit, filterJobCountry, filterJobPositionNames, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApplyApi
     */
    public findOneGroupApplyUser(id: string, options?: any) {
        return UserGroupApplyApiFp(this.configuration).findOneGroupApplyUser(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupApplyApi
     */
    public userRemoveGroupApply(id: string, options?: any) {
        return UserGroupApplyApiFp(this.configuration).userRemoveGroupApply(id, options)(this.fetch, this.basePath);
    }

}
/**
 * UserTalentPoolManagementApi - fetch parameter creator
 * @export
 */
export const UserTalentPoolManagementApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTalentByUserId(options: any = {}): FetchArgs {
            const localVarPath = `/api/user/talent-pool`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCV(options: any = {}): FetchArgs {
            const localVarPath = `/api/user/talent-pool/generateCV`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCertUrl(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getSignedCertUrl.');
            }
            const localVarPath = `/api/user/talent-pool/certificates/{id}/getSignedCertUrl`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrl(options: any = {}): FetchArgs {
            const localVarPath = `/api/user/talent-pool/getSignedCvUrl`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCertificate(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling removeCertificate.');
            }
            const localVarPath = `/api/user/talent-pool/certificates/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGeneratedCVByQuery(index: string, options: any = {}): FetchArgs {
            // verify required parameter 'index' is not null or undefined
            if (index === null || index === undefined) {
                throw new RequiredError('index','Required parameter index was null or undefined when calling removeGeneratedCVByQuery.');
            }
            const localVarPath = `/api/user/talent-pool/removeGeneratedCv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {TalentUserUpdateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTalentByUserId(body: TalentUserUpdateDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateTalentByUserId.');
            }
            const localVarPath = `/api/user/talent-pool`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"TalentUserUpdateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCertificate(options: any = {}): FetchArgs {
            const localVarPath = `/api/user/talent-pool/certificates`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificate(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling viewCertificate.');
            }
            const localVarPath = `/api/user/talent-pool/certificates/{id}/view`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewGeneratedCV(index: number, options: any = {}): FetchArgs {
            // verify required parameter 'index' is not null or undefined
            if (index === null || index === undefined) {
                throw new RequiredError('index','Required parameter index was null or undefined when calling viewGeneratedCV.');
            }
            const localVarPath = `/api/user/talent-pool/viewCV`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (index !== undefined) {
                localVarQueryParameter['index'] = index;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserTalentPoolManagementApi - functional programming interface
 * @export
 */
export const UserTalentPoolManagementApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTalentByUserId(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TalentPoolUserReadOneDto> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).findTalentByUserId(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCV(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<string> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).generateCV(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCertUrl(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).getSignedCertUrl(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrl(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).getSignedCvUrl(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCertificate(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).removeCertificate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGeneratedCVByQuery(index: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).removeGeneratedCVByQuery(index, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {TalentUserUpdateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTalentByUserId(body: TalentUserUpdateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<TalentPoolUserReadOneDto> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).updateTalentByUserId(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCertificate(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).uploadCertificate(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificate(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).viewCertificate(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewGeneratedCV(index: number, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UserTalentPoolManagementApiFetchParamCreator(configuration).viewGeneratedCV(index, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UserTalentPoolManagementApi - factory interface
 * @export
 */
export const UserTalentPoolManagementApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findTalentByUserId(options?: any) {
            return UserTalentPoolManagementApiFp(configuration).findTalentByUserId(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateCV(options?: any) {
            return UserTalentPoolManagementApiFp(configuration).generateCV(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCertUrl(id: string, options?: any) {
            return UserTalentPoolManagementApiFp(configuration).getSignedCertUrl(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCvUrl(options?: any) {
            return UserTalentPoolManagementApiFp(configuration).getSignedCvUrl(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCertificate(id: string, options?: any) {
            return UserTalentPoolManagementApiFp(configuration).removeCertificate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeGeneratedCVByQuery(index: string, options?: any) {
            return UserTalentPoolManagementApiFp(configuration).removeGeneratedCVByQuery(index, options)(fetch, basePath);
        },
        /**
         * 
         * @param {TalentUserUpdateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateTalentByUserId(body: TalentUserUpdateDto, options?: any) {
            return UserTalentPoolManagementApiFp(configuration).updateTalentByUserId(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadCertificate(options?: any) {
            return UserTalentPoolManagementApiFp(configuration).uploadCertificate(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCertificate(id: string, options?: any) {
            return UserTalentPoolManagementApiFp(configuration).viewCertificate(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} index 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewGeneratedCV(index: number, options?: any) {
            return UserTalentPoolManagementApiFp(configuration).viewGeneratedCV(index, options)(fetch, basePath);
        },
    };
};

/**
 * UserTalentPoolManagementApi - object-oriented interface
 * @export
 * @class UserTalentPoolManagementApi
 * @extends {BaseAPI}
 */
export class UserTalentPoolManagementApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public findTalentByUserId(options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).findTalentByUserId(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public generateCV(options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).generateCV(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public getSignedCertUrl(id: string, options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).getSignedCertUrl(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public getSignedCvUrl(options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).getSignedCvUrl(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public removeCertificate(id: string, options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).removeCertificate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} index 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public removeGeneratedCVByQuery(index: string, options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).removeGeneratedCVByQuery(index, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {TalentUserUpdateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public updateTalentByUserId(body: TalentUserUpdateDto, options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).updateTalentByUserId(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public uploadCertificate(options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).uploadCertificate(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public viewCertificate(id: string, options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).viewCertificate(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} index 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserTalentPoolManagementApi
     */
    public viewGeneratedCV(index: number, options?: any) {
        return UserTalentPoolManagementApiFp(this.configuration).viewGeneratedCV(index, options)(this.fetch, this.basePath);
    }

}
/**
 * UsersApi - fetch parameter creator
 * @export
 */
export const UsersApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(options: any = {}): FetchArgs {
            const localVarPath = `/api/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCVUrl(options: any = {}): FetchArgs {
            const localVarPath = `/api/users/cv/getSignedUrl`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {ChangePasswordDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerChangePassword(body: ChangePasswordDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling usersUserControllerChangePassword.');
            }
            const localVarPath = `/api/users/change-password`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"ChangePasswordDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerRemoveAvatar(options: any = {}): FetchArgs {
            const localVarPath = `/api/users/avatar`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerRemoveCV(options: any = {}): FetchArgs {
            const localVarPath = `/api/users/cv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UpdateUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUpdate(body: UpdateUserDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling usersUserControllerUpdate.');
            }
            const localVarPath = `/api/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UpdateUserDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUploadAvatar(options: any = {}): FetchArgs {
            const localVarPath = `/api/users/avatar`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUploadCV(options: any = {}): FetchArgs {
            const localVarPath = `/api/users/cv`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUserInfo(options: any = {}): FetchArgs {
            const localVarPath = `/api/users/userinfo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCV(options: any = {}): FetchArgs {
            const localVarPath = `/api/users/cv/view`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).deleteAccount(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCVUrl(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).getSignedCVUrl(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {ChangePasswordDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerChangePassword(body: ChangePasswordDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).usersUserControllerChangePassword(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerRemoveAvatar(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).usersUserControllerRemoveAvatar(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerRemoveCV(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).usersUserControllerRemoveCV(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {UpdateUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUpdate(body: UpdateUserDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).usersUserControllerUpdate(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUploadAvatar(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).usersUserControllerUploadAvatar(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUploadCV(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).usersUserControllerUploadCV(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUserInfo(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).usersUserControllerUserInfo(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCV(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersApiFetchParamCreator(configuration).viewCV(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteAccount(options?: any) {
            return UsersApiFp(configuration).deleteAccount(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSignedCVUrl(options?: any) {
            return UsersApiFp(configuration).getSignedCVUrl(options)(fetch, basePath);
        },
        /**
         * 
         * @param {ChangePasswordDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerChangePassword(body: ChangePasswordDto, options?: any) {
            return UsersApiFp(configuration).usersUserControllerChangePassword(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerRemoveAvatar(options?: any) {
            return UsersApiFp(configuration).usersUserControllerRemoveAvatar(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerRemoveCV(options?: any) {
            return UsersApiFp(configuration).usersUserControllerRemoveCV(options)(fetch, basePath);
        },
        /**
         * 
         * @param {UpdateUserDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUpdate(body: UpdateUserDto, options?: any) {
            return UsersApiFp(configuration).usersUserControllerUpdate(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUploadAvatar(options?: any) {
            return UsersApiFp(configuration).usersUserControllerUploadAvatar(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUploadCV(options?: any) {
            return UsersApiFp(configuration).usersUserControllerUploadCV(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersUserControllerUserInfo(options?: any) {
            return UsersApiFp(configuration).usersUserControllerUserInfo(options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        viewCV(options?: any) {
            return UsersApiFp(configuration).viewCV(options)(fetch, basePath);
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public deleteAccount(options?: any) {
        return UsersApiFp(this.configuration).deleteAccount(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public getSignedCVUrl(options?: any) {
        return UsersApiFp(this.configuration).getSignedCVUrl(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {ChangePasswordDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserControllerChangePassword(body: ChangePasswordDto, options?: any) {
        return UsersApiFp(this.configuration).usersUserControllerChangePassword(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserControllerRemoveAvatar(options?: any) {
        return UsersApiFp(this.configuration).usersUserControllerRemoveAvatar(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserControllerRemoveCV(options?: any) {
        return UsersApiFp(this.configuration).usersUserControllerRemoveCV(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {UpdateUserDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserControllerUpdate(body: UpdateUserDto, options?: any) {
        return UsersApiFp(this.configuration).usersUserControllerUpdate(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserControllerUploadAvatar(options?: any) {
        return UsersApiFp(this.configuration).usersUserControllerUploadAvatar(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserControllerUploadCV(options?: any) {
        return UsersApiFp(this.configuration).usersUserControllerUploadCV(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersUserControllerUserInfo(options?: any) {
        return UsersApiFp(this.configuration).usersUserControllerUserInfo(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public viewCV(options?: any) {
        return UsersApiFp(this.configuration).viewCV(options)(this.fetch, this.basePath);
    }

}
/**
 * UsersAdminApi - fetch parameter creator
 * @export
 */
export const UsersAdminApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateUser(body: UserAdminCreateDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling adminCreateUser.');
            }
            const localVarPath = `/api/admin/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserAdminCreateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; firstName,lastName,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllManagers(page?: number, limit?: number, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/users/managers`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllUsers(options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/users`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemove(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminRemove.');
            }
            const localVarPath = `/api/admin/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveAvatar(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminRemoveAvatar.');
            }
            const localVarPath = `/api/admin/users/{id}/avatar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSendPasswordEmail(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminSendPasswordEmail.');
            }
            const localVarPath = `/api/admin/users/{id}/send-password-email`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadAvatar(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling adminUploadAvatar.');
            }
            const localVarPath = `/api/admin/users/{id}/avatar`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerFindOne(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userAdminControllerFindOne.');
            }
            const localVarPath = `/api/admin/users/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerFindOneManager(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userAdminControllerFindOneManager.');
            }
            const localVarPath = `/api/admin/users/managers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {UserAdminManagerUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerUpdateManager(body: UserAdminManagerUpdateDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling userAdminControllerUpdateManager.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling userAdminControllerUpdateManager.');
            }
            const localVarPath = `/api/admin/users/managers/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"UserAdminManagerUpdateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersAdminApi - functional programming interface
 * @export
 */
export const UsersAdminApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {UserAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateUser(body: UserAdminCreateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).adminCreateUser(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; firstName,lastName,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllManagers(page?: number, limit?: number, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse200> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).adminFindAllManagers(page, limit, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllUsers(options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).adminFindAllUsers(options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemove(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).adminRemove(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveAvatar(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).adminRemoveAvatar(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSendPasswordEmail(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).adminSendPasswordEmail(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadAvatar(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).adminUploadAvatar(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerFindOne(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<any> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).userAdminControllerFindOne(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerFindOneManager(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserAdminManagerReadOneDto> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).userAdminControllerFindOneManager(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {UserAdminManagerUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerUpdateManager(body: UserAdminManagerUpdateDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserAdminManagerUpdateDto> {
            const localVarFetchArgs = UsersAdminApiFetchParamCreator(configuration).userAdminControllerUpdateManager(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UsersAdminApi - factory interface
 * @export
 */
export const UsersAdminApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {UserAdminCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminCreateUser(body: UserAdminCreateDto, options?: any) {
            return UsersAdminApiFp(configuration).adminCreateUser(body, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; firstName,lastName,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllManagers(page?: number, limit?: number, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return UsersAdminApiFp(configuration).adminFindAllManagers(page, limit, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminFindAllUsers(options?: any) {
            return UsersAdminApiFp(configuration).adminFindAllUsers(options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemove(id: string, options?: any) {
            return UsersAdminApiFp(configuration).adminRemove(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminRemoveAvatar(id: string, options?: any) {
            return UsersAdminApiFp(configuration).adminRemoveAvatar(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminSendPasswordEmail(id: string, options?: any) {
            return UsersAdminApiFp(configuration).adminSendPasswordEmail(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        adminUploadAvatar(id: string, options?: any) {
            return UsersAdminApiFp(configuration).adminUploadAvatar(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerFindOne(id: string, options?: any) {
            return UsersAdminApiFp(configuration).userAdminControllerFindOne(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerFindOneManager(id: string, options?: any) {
            return UsersAdminApiFp(configuration).userAdminControllerFindOneManager(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {UserAdminManagerUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userAdminControllerUpdateManager(body: UserAdminManagerUpdateDto, id: string, options?: any) {
            return UsersAdminApiFp(configuration).userAdminControllerUpdateManager(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * UsersAdminApi - object-oriented interface
 * @export
 * @class UsersAdminApi
 * @extends {BaseAPI}
 */
export class UsersAdminApi extends BaseAPI {
    /**
     * 
     * @param {UserAdminCreateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public adminCreateUser(body: UserAdminCreateDto, options?: any) {
        return UsersAdminApiFp(this.configuration).adminCreateUser(body, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default sorting specified, the result order is not guaranteed           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; firstName,lastName,email           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;firstName&lt;/li&gt; &lt;li&gt;lastName&lt;/li&gt; &lt;li&gt;email&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public adminFindAllManagers(page?: number, limit?: number, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return UsersAdminApiFp(this.configuration).adminFindAllManagers(page, limit, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public adminFindAllUsers(options?: any) {
        return UsersAdminApiFp(this.configuration).adminFindAllUsers(options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public adminRemove(id: string, options?: any) {
        return UsersAdminApiFp(this.configuration).adminRemove(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public adminRemoveAvatar(id: string, options?: any) {
        return UsersAdminApiFp(this.configuration).adminRemoveAvatar(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public adminSendPasswordEmail(id: string, options?: any) {
        return UsersAdminApiFp(this.configuration).adminSendPasswordEmail(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public adminUploadAvatar(id: string, options?: any) {
        return UsersAdminApiFp(this.configuration).adminUploadAvatar(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public userAdminControllerFindOne(id: string, options?: any) {
        return UsersAdminApiFp(this.configuration).userAdminControllerFindOne(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public userAdminControllerFindOneManager(id: string, options?: any) {
        return UsersAdminApiFp(this.configuration).userAdminControllerFindOneManager(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {UserAdminManagerUpdateDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersAdminApi
     */
    public userAdminControllerUpdateManager(body: UserAdminManagerUpdateDto, id: string, options?: any) {
        return UsersAdminApiFp(this.configuration).userAdminControllerUpdateManager(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * UsersPublicApi - fetch parameter creator
 * @export
 */
export const UsersPublicApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * !!! If method requires api key, it must not be called by client side !!!
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInformationFor3rdPartyAuthentication(email: string, options: any = {}): FetchArgs {
            // verify required parameter 'email' is not null or undefined
            if (email === null || email === undefined) {
                throw new RequiredError('email','Required parameter email was null or undefined when calling userInformationFor3rdPartyAuthentication.');
            }
            const localVarPath = `/api/public/users/userinfo`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersPublicApi - functional programming interface
 * @export
 */
export const UsersPublicApiFp = function(configuration?: Configuration) {
    return {
        /**
         * !!! If method requires api key, it must not be called by client side !!!
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInformationFor3rdPartyAuthentication(email: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<UserInfoResponseDto> {
            const localVarFetchArgs = UsersPublicApiFetchParamCreator(configuration).userInformationFor3rdPartyAuthentication(email, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * UsersPublicApi - factory interface
 * @export
 */
export const UsersPublicApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * !!! If method requires api key, it must not be called by client side !!!
         * @param {string} email 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userInformationFor3rdPartyAuthentication(email: string, options?: any) {
            return UsersPublicApiFp(configuration).userInformationFor3rdPartyAuthentication(email, options)(fetch, basePath);
        },
    };
};

/**
 * UsersPublicApi - object-oriented interface
 * @export
 * @class UsersPublicApi
 * @extends {BaseAPI}
 */
export class UsersPublicApi extends BaseAPI {
    /**
     * !!! If method requires api key, it must not be called by client side !!!
     * @param {string} email 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersPublicApi
     */
    public userInformationFor3rdPartyAuthentication(email: string, options?: any) {
        return UsersPublicApiFp(this.configuration).userInformationFor3rdPartyAuthentication(email, options)(this.fetch, this.basePath);
    }

}
/**
 * WorkerRequestsAdminModuleApi - fetch parameter creator
 * @export
 */
export const WorkerRequestsAdminModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRequest(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteRequest.');
            }
            const localVarPath = `/api/admin/worker-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country,managerEmail,requestNumber           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;managerEmail&lt;/li&gt; &lt;li&gt;requestNumber&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllRequests(page?: number, limit?: number, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/admin/worker-requests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRequestById(id: string, options: any = {}): FetchArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling findRequestById.');
            }
            const localVarPath = `/api/admin/worker-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkerRequestAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequest(body: WorkerRequestAdminUpdateDto, id: string, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateRequest.');
            }
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateRequest.');
            }
            const localVarPath = `/api/admin/worker-requests/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'PATCH' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"WorkerRequestAdminUpdateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkerRequestsAdminModuleApi - functional programming interface
 * @export
 */
export const WorkerRequestsAdminModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRequest(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<Response> {
            const localVarFetchArgs = WorkerRequestsAdminModuleApiFetchParamCreator(configuration).deleteRequest(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country,managerEmail,requestNumber           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;managerEmail&lt;/li&gt; &lt;li&gt;requestNumber&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllRequests(page?: number, limit?: number, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20011> {
            const localVarFetchArgs = WorkerRequestsAdminModuleApiFetchParamCreator(configuration).findAllRequests(page, limit, filterCountry, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRequestById(id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WorkerRequestAdminReadOneDto> {
            const localVarFetchArgs = WorkerRequestsAdminModuleApiFetchParamCreator(configuration).findRequestById(id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {WorkerRequestAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequest(body: WorkerRequestAdminUpdateDto, id: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WorkerRequestAdminReadOneDto> {
            const localVarFetchArgs = WorkerRequestsAdminModuleApiFetchParamCreator(configuration).updateRequest(body, id, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * WorkerRequestsAdminModuleApi - factory interface
 * @export
 */
export const WorkerRequestsAdminModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRequest(id: string, options?: any) {
            return WorkerRequestsAdminModuleApiFp(configuration).deleteRequest(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country,managerEmail,requestNumber           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;managerEmail&lt;/li&gt; &lt;li&gt;requestNumber&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllRequests(page?: number, limit?: number, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return WorkerRequestsAdminModuleApiFp(configuration).findAllRequests(page, limit, filterCountry, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findRequestById(id: string, options?: any) {
            return WorkerRequestsAdminModuleApiFp(configuration).findRequestById(id, options)(fetch, basePath);
        },
        /**
         * 
         * @param {WorkerRequestAdminUpdateDto} body 
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRequest(body: WorkerRequestAdminUpdateDto, id: string, options?: any) {
            return WorkerRequestsAdminModuleApiFp(configuration).updateRequest(body, id, options)(fetch, basePath);
        },
    };
};

/**
 * WorkerRequestsAdminModuleApi - object-oriented interface
 * @export
 * @class WorkerRequestsAdminModuleApi
 * @extends {BaseAPI}
 */
export class WorkerRequestsAdminModuleApi extends BaseAPI {
    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerRequestsAdminModuleApi
     */
    public deleteRequest(id: string, options?: any) {
        return WorkerRequestsAdminModuleApiFp(this.configuration).deleteRequest(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;status&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country,managerEmail,requestNumber           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt; &lt;li&gt;managerEmail&lt;/li&gt; &lt;li&gt;requestNumber&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerRequestsAdminModuleApi
     */
    public findAllRequests(page?: number, limit?: number, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return WorkerRequestsAdminModuleApiFp(this.configuration).findAllRequests(page, limit, filterCountry, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerRequestsAdminModuleApi
     */
    public findRequestById(id: string, options?: any) {
        return WorkerRequestsAdminModuleApiFp(this.configuration).findRequestById(id, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {WorkerRequestAdminUpdateDto} body 
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerRequestsAdminModuleApi
     */
    public updateRequest(body: WorkerRequestAdminUpdateDto, id: string, options?: any) {
        return WorkerRequestsAdminModuleApiFp(this.configuration).updateRequest(body, id, options)(this.fetch, this.basePath);
    }

}
/**
 * WorkerRequestsManagerModuleApi - fetch parameter creator
 * @export
 */
export const WorkerRequestsManagerModuleApiFetchParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterStatus] Filter by status query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.status&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.status&#x3D;$not:$like:John Doe&amp;filter.status&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllManagerRequests(page?: number, limit?: number, filterStatus?: Array<string>, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options: any = {}): FetchArgs {
            const localVarPath = `/api/manager/worker-requests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (filterStatus) {
                localVarQueryParameter['filter.status'] = filterStatus;
            }

            if (filterCountry) {
                localVarQueryParameter['filter.country'] = filterCountry;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (searchBy) {
                localVarQueryParameter['searchBy'] = searchBy;
            }

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneManagerRequest(slug: string, options: any = {}): FetchArgs {
            // verify required parameter 'slug' is not null or undefined
            if (slug === null || slug === undefined) {
                throw new RequiredError('slug','Required parameter slug was null or undefined when calling findOneManagerRequest.');
            }
            const localVarPath = `/api/manager/worker-requests/{slug}`
                .replace(`{${"slug"}}`, encodeURIComponent(String(slug)));
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {WorkerRequestCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerCreateWorkerRequest(body: WorkerRequestCreateDto, options: any = {}): FetchArgs {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling managerCreateWorkerRequest.');
            }
            const localVarPath = `/api/manager/worker-requests`;
            const localVarUrlObj = url.parse(localVarPath, true);
            const localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            // fix override query string Detail: https://stackoverflow.com/a/7517673/1077943
            localVarUrlObj.search = null;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            const needsSerialization = (<any>"WorkerRequestCreateDto" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body =  needsSerialization ? JSON.stringify(body || {}) : (body || "");

            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * WorkerRequestsManagerModuleApi - functional programming interface
 * @export
 */
export const WorkerRequestsManagerModuleApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterStatus] Filter by status query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.status&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.status&#x3D;$not:$like:John Doe&amp;filter.status&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllManagerRequests(page?: number, limit?: number, filterStatus?: Array<string>, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<InlineResponse20012> {
            const localVarFetchArgs = WorkerRequestsManagerModuleApiFetchParamCreator(configuration).findAllManagerRequests(page, limit, filterStatus, filterCountry, sortBy, search, searchBy, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneManagerRequest(slug: string, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WorkerRequestManagerReadOneDto> {
            const localVarFetchArgs = WorkerRequestsManagerModuleApiFetchParamCreator(configuration).findOneManagerRequest(slug, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
        /**
         * 
         * @param {WorkerRequestCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerCreateWorkerRequest(body: WorkerRequestCreateDto, options?: any): (fetch?: FetchAPI, basePath?: string) => Promise<WorkerRequest> {
            const localVarFetchArgs = WorkerRequestsManagerModuleApiFetchParamCreator(configuration).managerCreateWorkerRequest(body, options);
            return (fetch: FetchAPI = isomorphicFetch, basePath: string = BASE_PATH) => {
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then((response) => {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    } else {
                        throw response;
                    }
                });
            };
        },
    }
};

/**
 * WorkerRequestsManagerModuleApi - factory interface
 * @export
 */
export const WorkerRequestsManagerModuleApiFactory = function (configuration?: Configuration, fetch?: FetchAPI, basePath?: string) {
    return {
        /**
         * 
         * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
         * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
         * @param {Array<string>} [filterStatus] Filter by status query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.status&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.status&#x3D;$not:$like:John Doe&amp;filter.status&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
         * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt;&lt;/ul&gt;       
         * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
         * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findAllManagerRequests(page?: number, limit?: number, filterStatus?: Array<string>, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
            return WorkerRequestsManagerModuleApiFp(configuration).findAllManagerRequests(page, limit, filterStatus, filterCountry, sortBy, search, searchBy, options)(fetch, basePath);
        },
        /**
         * 
         * @param {string} slug 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findOneManagerRequest(slug: string, options?: any) {
            return WorkerRequestsManagerModuleApiFp(configuration).findOneManagerRequest(slug, options)(fetch, basePath);
        },
        /**
         * 
         * @param {WorkerRequestCreateDto} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        managerCreateWorkerRequest(body: WorkerRequestCreateDto, options?: any) {
            return WorkerRequestsManagerModuleApiFp(configuration).managerCreateWorkerRequest(body, options)(fetch, basePath);
        },
    };
};

/**
 * WorkerRequestsManagerModuleApi - object-oriented interface
 * @export
 * @class WorkerRequestsManagerModuleApi
 * @extends {BaseAPI}
 */
export class WorkerRequestsManagerModuleApi extends BaseAPI {
    /**
     * 
     * @param {number} [page] Page number to retrieve.If you provide invalid value the default page number will applied         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 1           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 1           &lt;/p&gt;         
     * @param {number} [limit] Number of records per page.       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; 20           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Max Value: &lt;/b&gt; 100           &lt;/p&gt;        If provided value is greater than max value, max value will be applied.       
     * @param {Array<string>} [filterStatus] Filter by status query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.status&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.status&#x3D;$not:$like:John Doe&amp;filter.status&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [filterCountry] Filter by country query param.           &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; filter.country&#x3D;{$not}:OPERATION:VALUE           &lt;/p&gt;           &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; filter.country&#x3D;$not:$like:John Doe&amp;filter.country&#x3D;like:John           &lt;/p&gt;           &lt;h4&gt;Available Operations&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;$eq&lt;/li&gt;&lt;/ul&gt;
     * @param {Array<string>} [sortBy] Parameter to sort by.       &lt;p&gt;To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting&lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Format: &lt;/b&gt; fieldName:DIRECTION           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; sortBy&#x3D;id:DESC&amp;sortBy&#x3D;createdAt:ASC           &lt;/p&gt;       &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; createdAt:DESC           &lt;/p&gt;       &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;id&lt;/li&gt; &lt;li&gt;createdAt&lt;/li&gt; &lt;li&gt;status&lt;/li&gt;&lt;/ul&gt;       
     * @param {string} [search] Search term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; John           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; No default value           &lt;/p&gt;         
     * @param {Array<string>} [searchBy] List of fields to search by term to filter result values         &lt;p&gt;              &lt;b&gt;Example: &lt;/b&gt; companyName,city,country           &lt;/p&gt;         &lt;p&gt;              &lt;b&gt;Default Value: &lt;/b&gt; By default all fields mentioned below will be used to search by term           &lt;/p&gt;         &lt;h4&gt;Available Fields&lt;/h4&gt;&lt;ul&gt;&lt;li&gt;companyName&lt;/li&gt; &lt;li&gt;city&lt;/li&gt; &lt;li&gt;country&lt;/li&gt;&lt;/ul&gt;         
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerRequestsManagerModuleApi
     */
    public findAllManagerRequests(page?: number, limit?: number, filterStatus?: Array<string>, filterCountry?: Array<string>, sortBy?: Array<string>, search?: string, searchBy?: Array<string>, options?: any) {
        return WorkerRequestsManagerModuleApiFp(this.configuration).findAllManagerRequests(page, limit, filterStatus, filterCountry, sortBy, search, searchBy, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {string} slug 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerRequestsManagerModuleApi
     */
    public findOneManagerRequest(slug: string, options?: any) {
        return WorkerRequestsManagerModuleApiFp(this.configuration).findOneManagerRequest(slug, options)(this.fetch, this.basePath);
    }

    /**
     * 
     * @param {WorkerRequestCreateDto} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof WorkerRequestsManagerModuleApi
     */
    public managerCreateWorkerRequest(body: WorkerRequestCreateDto, options?: any) {
        return WorkerRequestsManagerModuleApiFp(this.configuration).managerCreateWorkerRequest(body, options)(this.fetch, this.basePath);
    }

}
